// import React, { useEffect, useState } from "react";
// import { ClipLoader } from "react-spinners"; // Example react-spinners usage

// import { useParams, useNavigate } from "react-router-dom";

// // const API_BASE_URL = "https://screening.fanisko.com";
// const API_BASE_URL = "http://127.0.0.1:8000";

// function ResumePreviewModal({ open, onClose, pdfUrl }) {
//   if (!open || !pdfUrl) return null;

// return (
//   <div
//     style={{
//       position: "fixed",
//       left: -300, top: 0, width: "120vw", height: "100vh",
//       background: "rgba(20,40,90,0.29)",
//       display: "flex", alignItems: "center", justifyContent: "center",
//       zIndex: 9999,
//     }}
//     onClick={onClose}
//   >
//     {/* Close button OUTSIDE preview box */}
//     <button
//       onClick={onClose}
//       aria-label="Close Resume"
//       style={{
//         position: "fixed", // Instead of absolute, so it's relative to viewport
//         right: "10vw",
//         top: "4vh",        // Or try top: 22px;
//         background: "none",
//         border: "none",
//         fontSize: 33,
//         color: "#000000ff",
//         cursor: "pointer",
//         fontWeight: 900,
//         zIndex: 800,     // Higher than preview
//         padding: 18,
//         lineHeight: 1,
//       }}
//     >
//       &times;
//     </button>
//     <div
//       onClick={e => e.stopPropagation()}
//       style={{
//         background: "#fff",
//         borderRadius: 12,
//         boxShadow: "0 8px 48px #11275360",
//         width: "min(700px,96vw)",
//         maxHeight: "80vh",
//         position: "relative",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <iframe
//         title="Resume Preview"
//         src={pdfUrl}
//         width="150%"
//         height="800px"
//         marginright="200px"
//         style={{ border: "none", borderRadius: 12 }}
//       />
//     </div>
//   </div>
// );
// }

// function parseCoverLetter(raw) {
//   console.log("parseCoverLetter INPUT:", raw);

//   // If raw is an object with type and value, extract the value string
//   let valueStr = raw;
//   if (typeof raw === "object" && raw !== null && "value" in raw) {
//     valueStr = raw.value;
//   }

//   if (valueStr && typeof valueStr === "string" && valueStr.includes("_")) {
//     const lastUnderscoreIndex = valueStr.lastIndexOf("_");
//     const possibleId = valueStr.slice(lastUnderscoreIndex + 1);
//     console.log("parseCoverLetter possibleId:", possibleId);

//     if (lastUnderscoreIndex > 0 && possibleId && /^[a-fA-F0-9]+$/.test(possibleId)) {
//       console.log("parseCoverLetter: showButton = true");
//       return {
//         showButton: true,
//         value: possibleId,
//         filename: valueStr.slice(0, lastUnderscoreIndex),
//       };
//     }
//     console.log("parseCoverLetter: showButton = false - did not match hex/number");
//   }

//   return { showButton: false, value: valueStr || "" };
// }

// function convertUtcToIst(utcDateStr) {
//   // Parse the date string directly as UTC
//   const utcDate = new Date(utcDateStr + ' UTC');
//   // Format the date explicitly in 'Asia/Kolkata' timezone
//   return utcDate.toLocaleString('en-IN', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//     hour12: true,
//     timeZone: 'Asia/Kolkata',
//   });
// }
// // --- Modal to preview (file or text) ---
// function CoverLetterPreviewModal({ open, onClose, coverLetter }) {
//   if (!open) return null;
//   console.log("CoverLetterPreviewModal: coverLetter:", coverLetter);

//   if (coverLetter.showButton && coverLetter.value) {
//     // const fileUrl = `https://screening.fanisko.com/api/cover_letter_file/${coverLetter.value}`;
//       const fileUrl = `${API_BASE_URL}/api/cover_letter_file/${coverLetter.value}`;
//     return (
//       <div
//         style={{
//           position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
//           background: "rgba(20,40,90,0.29)",
//           display: "flex", alignItems: "center", justifyContent: "center",
//           zIndex: 9999,
//         }}
//         onClick={onClose}
//       >
//         <button
//           onClick={onClose}
//           aria-label="Close Cover Letter"
//           style={{
//             position: "fixed", right: "20vw", top: "6vh",
//             background: "none", border: "none", fontSize: 33, color: "#000000ff",
//             cursor: "pointer", fontWeight: 900, zIndex: 800, padding: 18, lineHeight: 1,
//           }}
//         >&times;</button>
//         <div
//           onClick={(e) => e.stopPropagation()}
//           style={{
//             background: "#fff", borderRadius: 12, boxShadow: "0 8px 48px #11275360",
//             width: "min(700px,96vw)", height: "80vh",
//             position: "relative", display: "flex", flexDirection: "column",
//           }}>
//           <iframe
//             title="Cover Letter Preview"
//             src={fileUrl}
//             width="100%"
//             height="100%"
//             style={{ border: "none", borderRadius: 12 }}
//           />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
//         background: "rgba(20,40,90,0.29)",
//         display: "flex", alignItems: "center", justifyContent: "center",
//         zIndex: 9999,
//       }}
//       onClick={onClose}
//     >
//       <button
//         onClick={onClose}
//         aria-label="Close Cover Letter"
//         style={{
//           position: "fixed", right: "20vw", top: "6vh", background: "none",
//           border: "none", fontSize: 33, color: "#000000ff", cursor: "pointer",
//           fontWeight: 900, zIndex: 800, padding: 18, lineHeight: 1,
//         }}
//       >&times;</button>
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           background: "#fff", borderRadius: 12, boxShadow: "0 8px 48px #11275360",
//           width: "min(700px,96vw)", maxHeight: "80vh", padding: 30,
//           overflowY: "auto", color: "#223455", fontSize: 18, whiteSpace: "pre-wrap",
//           lineHeight: 1.7, position: "relative",
//         }}
//       >{coverLetter.value || "No cover letter available."}
//       </div>
//     </div>
//   );
// }

// function CandidateDetailsModal({ open, onClose, candidate, jobOnboarding, loading, applicationDate }) {
//   const [isDrawerOpen, setDrawerOpen] = useState(false);
//   // const [jobOnboarding, setJobOnboarding] = useState(null);
//   const [showResume, setShowResume] = useState(false);
//   const [showCoverLetter, setShowCoverLetter] = useState(false);
//   if (!open) return null;
//   const resumePdfUrl = candidate?.resume_file_id
//     // ? `https://screening.fanisko.com/api/resume_pdf/${candidate.resume_file_id}`
//      ? `${API_BASE_URL}/api/resume_pdf/${candidate.resume_file_id}`
//     : null;

//   // Icons
//   const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
//   const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";
//   const locationIcon = "https://cdn-icons-png.flaticon.com/128/14027/14027590.png";
//   // Mapping of display names (edit or extend as needed)
// const FIELD_LABEL_MAP = {
//   linkedin: "LinkedIn",
//   notice_period: "Notice Period",
//   current_salary: "Current Salary",
//   expected_salary: "Expected Salary",
//   work_mode: "Work Mode",
//   preferred_city: "Preferred City",
//   current_location: "Current Location",
//   interview_date: "Interview Date",
//   interview_time_slots: "Interview Time Slots",
//   legally_authorized: "Legally Authorized",
//   open_to_relocate: "Open to Relocate",
//   found_us:"Found Us by",
//   job_change_reason: "Reason for Job Change",
//   career_gap_reason: "Reason for Career Gap",

//   // add others or fallback to onboarding.label
// };

// // Array controls the order and set of shown fields
// // const SHOWN_FIELDS = [
// //   "linkedin",
// //   "notice_period",
// //   "current_salary",
// //   "expected_salary",
// //   "work_mode",
// //   "preferred_city",
// //   "current_location",
// //   "interview_date",
// //   "interview_time_slots",
// //   "legally_authorized",
// // ];

// // Exclude these always (already handled above for core, but in case onboarding includes them)
// const EXCLUDED_ONBOARDING_KEYS = ["has_cover_letter", "cover_letter"];
// const EXCLUDED_EXTRA_KEYS = ["coverLetterName"];
//   const coverLetterObj = candidate ? parseCoverLetter(candidate.cover_letter || "") : { showButton: false, value: "" };
//   console.log("coverLetterObj in CandidateDetailsModal:", coverLetterObj);
//   console.log("jobOnboarding", jobOnboarding);
//   console.log("candidate", candidate);


//   return (
//     <div
//       style={{
//         position: "fixed",
//         left: 0,
//         top: 0,
//         width: "100vw",
//         height: "100vh",
//         background: "rgba(0, 0, 0, 0.15)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 2000,
//         overflowY: "auto",
//         padding: 20,
//       }}
//       onClick={onClose}
//       aria-modal="true"
//       role="dialog"
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           minWidth: 600,
//           maxWidth: 520,
//           background: "#fff",
//           borderRadius: 18,
//           boxShadow: "0 6px 32px #52a4f420",
//           padding: "30px 40px",
//           position: "relative",
//           maxHeight: "93vh",
//           top: -20,
//           bottom: 190,
//           overflowY: "auto",
//         }}
//       >
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             right: 18,
//             top: 6,
//             background: "none",
//             border: "none",
//             fontSize: 30,
//             color: "#236ef2",
//             cursor: "pointer",
//             fontWeight: 800,
//             lineHeight: 1,
//           }}
//           aria-label="Close Modal"
//         >
//           &times;
//         </button>

//         {loading ? (
//           <div style={{ fontSize: 17, textAlign: "center", padding: 40, color: "#236ef2" }}>
//             Loading details...
//           </div>
//         ) : candidate ? (
//           <>
//             {/* Profile Section */}
//             <div style={{ display: "flex", alignItems: "center", marginBottom: 22 }}>
//               <div
//   style={{
//     width: 66,
//     height: 66,
//     borderRadius: "50%",
//     background: "radial-gradient(ellipse at 60% 40%, #eaf2ff 80%, #e4ecfc 100%)",
//     color: "#2457ac", // rich blue for letter (matches your image)
//     fontWeight: 700,
//     fontSize: 35,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 4px 20px #eaf2ff, 0 0 0 6px #fff inset",
//     border: "4px solid #fff",
//     marginRight: 18,
//   }}
// >
//   {(candidate.name || "?").slice(0, 1).toUpperCase()}
// </div>
//               <div>
//                 <div
//                   style={{
//                     fontWeight: 800,
//                     fontSize: 23,
//                     color: "#182a43",
//                     marginBottom: 7,
//                   }}
//                 >
//                   {candidate.name || "idk"}
//                 </div>
//                 {candidate.email && (
//                   <div style={{display: "flex", alignItems: "center", color: "#53709c", fontSize: 15, marginBottom: 2}}>
//                     <img src={emailIcon} alt="Email" style={{width: 17, height: 17, marginRight: 6}} />
//                     {candidate.email}
//                   </div>
//                 )}
//                 {candidate.phone && (
//                   <div style={{display: "flex", alignItems: "center", color: "#53709c", fontSize: 15, marginBottom: 2}}>
//                     <img src={phoneIcon} alt="Phone" style={{width: 15, height: 15, marginRight: 7}} />
//                     {candidate.phone}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Additional Details Tile */}
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 background: "#f7fbfd",
//                 borderRadius: 12,
//                 marginTop: 6,
//                 padding: "19px 26px 16px 21px",
//               }}
//             >
//               <div style={{
//                 fontWeight: 700,
//                 fontSize: 16,
//                 marginBottom: 2,
//                 color: "#2465ae",
//                 letterSpacing: "0.02em"
//               }}>
//                 Additional Details:
//               </div>
//               <div style={{ fontSize: 15, color: "#2d3b51", marginTop: 10, lineHeight: 2 }}>
//   {/* <div>
//   <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//   <b>Cover Letter:</b> {
//     candidate.cover_letter?.type === "text"
//       ? candidate.cover_letter.value || "N/A"
//       : candidate.cover_letter?.type === "file"
//         ? "Uploaded File"
//         : "N/A"
//   }
// </div> */}

// {jobOnboarding && (
//   <div style={{ marginTop: 24 }}>
//     {Object.entries(jobOnboarding).map(([key, config]) => {
//   if (EXCLUDED_ONBOARDING_KEYS.includes(key)) return null;
//   if (
//     key === "preferred_city" &&
//     (
//       (candidate.work_mode && candidate.work_mode.toLowerCase() === "remote") ||
//       (candidate["work_mode"] && candidate["work_mode"].toLowerCase() === "remote")
//     )
//   ) return null;
//   let v = candidate[key];
//   if ((v === undefined || v === "") && candidate.extra_onboarding_fields) {
//     v = candidate.extra_onboarding_fields[key];
//   }
//   if (v === undefined || v === "") v = "N/A";
//   if (typeof v === "object" && v !== null) {
//     if ("value" in v) v = v.value;
//     else v = JSON.stringify(v);
//   }
//   // Legal label logic as before
//   let label = FIELD_LABEL_MAP[key] || config.label || key;
//   if (key === "legally_authorized" && config.label) {
//     const suffix = config.label.split("legally authorized")[1]?.trim();
//     if (suffix) label = `Legally Authorized (${suffix.replace(/[?]/g, '')}):`;
//   }
//   if (key === "linkedin" && v && v !== "N/A") {
//   return (
//     <div key={key} style={{ marginBottom: 14 }}>
//       <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//       <b>
//         {label.replace(/[?:\s]+$/, "")}:
//       </b>{" "}
//       <a
//         href={v}
//         target="_blank"
//         rel="noopener noreferrer"
//         style={{
//           color: "#2465ae",
//           textDecoration: "underline",
//         }}
//       >
//         Profile Link
//       </a>
//     </div>
//   );
// }
//   return (
//   <div key={key} style={{ marginBottom: 14 }}>
//     <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//     <b>
//       <span>{label.replace(/[?:\s]+$/, "")}:</span>
//     </b> {v}
//   </div>
// );
// })}

//     {/* Show extra/dynamic fields not in SHOWN_FIELDS */}
//     <div style={{ marginTop: 12 }}>
//   {candidate.extra_onboarding_fields &&
//   Object.entries(candidate.extra_onboarding_fields)
//     // Exclude any extra field whose key is in jobOnboarding (already shown above)
//     .filter(([key]) => !jobOnboarding.hasOwnProperty(key) && !EXCLUDED_EXTRA_KEYS.includes(key))
//     .map(([key, value]) => (
//       <div key={key} style={{ marginBottom: 14 }}>
//         <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//         <b>{jobOnboarding[key]?.label || key.replace(/[?:\s]+$/, "")}:</b> {value || "N/A"}
//       </div>
//     ))}
// </div>
// <div style={{ marginTop: 18, marginBottom: 3 }}>
//       <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//       <b>Application Date:</b>{" "}
//       {applicationDate && applicationDate !== "N/A"
//         ? convertUtcToIst(applicationDate)
//         : <em>Fetching...</em>
//       }
//     </div>
//   </div>
// )}


//               </div>
//             </div>

//              {/* View Resume Button */}
//             {resumePdfUrl && (
//               <div style={{ marginTop: 20 }}>
//                 <button
//                   onClick={() => setShowResume(true)}
//                   style={{
//                     backgroundColor: "#236ef2",
//                     color: "#fff",
//                     border: "none", borderRadius: 6, padding: "12px 20px",
//                     fontWeight: "bold", cursor: "pointer", width: "100%", fontSize: 16,
//                   }}
//                 >
//                   View Resume
//                 </button>
//               </div>
//             )}
//             {/* View Cover Letter button */}
// {/* console.log("coverLetterObj in CandidateDetailsModal:", coverLetterObj); */}

// {(coverLetterObj.showButton || coverLetterObj.value) && (
//   <div style={{ marginTop: 20 }}>
//     <button
//       onClick={() => setShowCoverLetter(true)}
//       style={{
//         backgroundColor: "#236ef2",
//         color: "#fff",
//         border: "none",
//         borderRadius: 6,
//         padding: "12px 20px",
//         fontWeight: "bold",
//         cursor: "pointer",
//         width: "100%",
//         fontSize: 16,
//       }}
//     >
//       View Cover Letter
//     </button>
//   </div>
// )}
//             <ResumePreviewModal
//               open={showResume}
//               onClose={() => setShowResume(false)}
//               pdfUrl={resumePdfUrl}
//             />
//             {/* Cover Letter Preview Modal */}
//             <CoverLetterPreviewModal
//               open={showCoverLetter}
//               onClose={() => setShowCoverLetter(false)}
//               coverLetter={coverLetterObj}
//             />
//           </>
//         ) : (
//           <div style={{ fontSize: 16, textAlign: "center", padding: 20, color: "red" }}>
//             Failed to load candidate details.
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function L2QuestionsDialog({ onClose, loading, questions, error }) {
//   console.log("L2QuestionsDialog questions prop:", questions);
//   const shimmerBase = {
//     background: "linear-gradient(90deg, #eef3ff 0%, #f7f9ff 40%, #eef3ff 80%)",
//     backgroundSize: "200% 100%",
//     animation: "shimmer 1.5s infinite",
//     borderRadius: 10
//   };

//   return (
//     <>
//       {/* keyframes for shimmer */}
//       <style>
//         {`
//         @keyframes shimmer {
//           0% { background-position: -200% 0; }
//           100% { background-position: 200% 0; }
//         }
//       `}
//       </style>

//       <div
//         style={{
//           position: "fixed",
//           inset: 0,
//           background: "rgba(0,0,0,0.25)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           zIndex: 2500
//         }}
//         onClick={onClose}
//       >
//         <div
//           onClick={e => e.stopPropagation()}
//           style={{
//             width: 720,
//             maxHeight: "80vh",
//             background: "#fff",
//             borderRadius: 16,
//             boxShadow: "0 10px 40px #13254f33",
//             padding: "24px 26px 26px 26px",
//             position: "relative",
//             overflowY: "auto"
//           }}
//         >
//           <button
//             onClick={onClose}
//             style={{
//               position: "absolute",
//               top: 10,
//               right: 14,
//               border: "none",
//               background: "transparent",
//               fontSize: 26,
//               color: "#2457ac",
//               cursor: "pointer",
//               fontWeight: 700
//             }}
//           >
//             &times;
//           </button>

//           <div style={{ fontSize: 22, fontWeight: 800, color: "#182a43", marginBottom: 8 }}>
//             L2 Interview Question Suggestions
//           </div>
//           <div style={{ fontSize: 13, color: "#667699", marginBottom: 20 }}>
//             Generated Based on Resume and Job Description
//           </div>

//           {loading && (
//             <div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 12 }}>
//               {[1, 2, 3, 4].map(i => (
//                 <div
//                   key={i}
//                   style={{
//                     ...shimmerBase,
//                     height: 60,
//                     padding: "14px 16px",
//                     boxShadow: "0 1px 6px rgba(138, 143, 157, 0.9)"
//                   }}
//                 />
//               ))}
//             </div>
//           )}

//           {!loading && error && (
//             <div
//               style={{
//                 marginTop: 12,
//                 padding: 14,
//                 borderRadius: 10,
//                 background: "#ffefef",
//                 color: "#b02a37",
//                 fontSize: 14,
//                 fontWeight: 500
//               }}
//             >
//               {error}
//             </div>
//           )}

//           {!loading && !error && Array.isArray(questions) && questions.length > 0 && (
//             <div style={{ marginTop: 6, display: "flex", flexDirection: "column", gap: 14 }}>
//               {questions.map((q, idx) => (
//                 <div
//                   key={idx}
//                   style={{
//                     borderRadius: 12,
//                     border: "1px solid #e0e7fb",
//                     padding: "14px 16px",
//                     background: "#f7f9ff",
//                     boxShadow: "0 2px 10px #e1e9ff90",
//                     display: "flex",
//                     gap: 12
//                   }}
//                 >
//                   <div
//                     style={{
//                       minWidth: 26,
//                       height: 26,
//                       borderRadius: "50%",
//                       background: "#2457ac",
//                       color: "#fff",
//                       fontSize: 14,
//                       fontWeight: 700,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginTop: 4
//                     }}
//                   >
//                     {idx + 1}
//                   </div>
//                   <div style={{ fontSize: 15, color: "#182a43", fontWeight: 500, lineHeight: 1.4 }}>
//                     {q}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {!loading && !error && (!questions || questions.length === 0) && (
//             <div style={{ marginTop: 16, fontSize: 14, color: "#6b7280" }}>
//               No questions generated yet.
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }


// function CandidateScoreModal({
//   open,
//   onClose,
//   scores,
//   screeningQA,
//   loading,
//   error,
//   approvedCandidates,
//   rejectedCandidates,
//   setApprovedCandidates,
//   setRejectedCandidates,
//   handleOpenL2 
// }) {
//   const [isVerified, setIsVerified] = useState(false);
//   const [decisionMade, setDecisionMade] = useState(false);

//   const handleApprove = async () => {
//     // await fetch('https://screening.fanisko.com/api/update_l1_status', {
//      await fetch(`${API_BASE_URL}/api/update_l1_status`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         candidate_id: scores.candidate_id,
//         job_id: scores.job_id,
//         status: 'approved'
//       })
//     });
//     setDecisionMade(true);
//     onClose();
//   };

//   const handleReject = async () => {
//     // await fetch('https://screening.fanisko.com/api/update_l1_status', {
//      await fetch(`${API_BASE_URL}/api/update_l1_status`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         candidate_id: scores.candidate_id,
//         job_id: scores.job_id,
//         status: 'rejected'
//       })
//     });
//     setDecisionMade(true);
//     onClose();
//   };

//   if (!open) return null;

//   const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
//   const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";

//   const loadingOrNoScore = loading || scores?.llm_score == null;

//   if (loadingOrNoScore)
//     return (
//       <div style={{ padding: 300, display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <ClipLoader color="#2d3b51" size={200} />
//         <div style={{ marginTop: 10 }}>Loading score...</div>
//       </div>
//     );

//   const profileCircleStyle = {
//     width: 66,
//     height: 66,
//     borderRadius: "50%",
//     background: "radial-gradient(ellipse at 60% 40%, #eaf2ff 80%, #e4ecfc 100%)",
//     color: "#2457ac",
//     fontWeight: 800,
//     fontSize: 38,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 4px 20px #eaf2ff, inset 0 0 0 6px #fff",
//     border: "4px solid #fff",
//     marginRight: 18,
//   };

//   const initialScreeningPassed = (scores?.compatibility ?? 0) >= 40;

//   // Use nested report structure for screening questions and L1 score
//   const overallL1Score = screeningQA?.interview_report?.overall_l1_score ?? "N/A";
// const questionScores =
//   Array.isArray(screeningQA?.interview_report?.question_scores)
//     ? screeningQA.interview_report.question_scores
//     : [];

//   return (
//     <div
//       style={{
//         position: "fixed",
//         left: 0,
//         top: 0,
//         width: "100vw",
//         height: "100vh",
//         background: "rgba(36, 84, 217, 0.15)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 2100,
//         overflowY: "auto",
//         padding: 20,
//       }}
//       onClick={onClose}
//       aria-modal="true"
//       role="dialog"
//     >
//       <div
//         onClick={e => e.stopPropagation()}
//         style={{
//           minWidth: 900,
//           maxWidth: 1000,
//           background: "#fff",
//           borderRadius: 14,
//           boxShadow: "0 6px 28px #52a4f420",
//           padding: "32px 40px",
//           position: "relative",
//           maxHeight: "90vh",
//           overflowY: "auto",
//           display: "grid",
//           gridTemplateAreas: `
//             "left right"
//             "bottom bottom"
//           `,
//           gridTemplateColumns: "1fr 1fr",
//           gridTemplateRows: "auto auto",
//           gridGap: 32,
//         }}
//       >
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             right: 18,
//             top: 6,
//             background: "none",
//             border: "none",
//             fontSize: 30,
//             color: "#236ef2",
//             cursor: "pointer",
//             fontWeight: 800,
//             lineHeight: 1,
//           }}
//           aria-label="Close Modal"
//         >
//           &times;
//         </button>

//         {/* Left Column: Profile + Status + Score */}
//         <div style={{ gridArea: "left", display: "flex", flexDirection: "column", gap: 20 }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
//             <div style={profileCircleStyle}>{(scores?.candidate_name || "?")[0].toUpperCase()}</div>
//             <div>
//               <div style={{ fontWeight: 800, fontSize: 28, color: "#182a43" }}>
//                 {scores?.candidate_name || "N/A"}
//               </div>
//               <div style={{ color: "#53709c", marginTop: 5 }}>
//                 <img src={emailIcon} alt="Email" style={{ width: 17, height: 17, marginRight: 6 }} />
//                 {scores?.candidate_email || "N/A"}
//               </div>
//               <div style={{ color: "#53709c", marginTop: 6 }}>
//                 <img src={phoneIcon} alt="Phone" style={{ width: 15, height: 15, marginRight: 7 }} />
//                 {scores?.candidate_phone || "N/A"}
//               </div>
//             </div>
//           </div>


//           {/* Screening Pass/Fail */}
//           <div
//             style={{
//               border: "1.6px solid #e7eefa",
//               borderRadius: 12,
//               padding: 18,
//               fontWeight: 700,
//               fontSize: 20,
//               color: initialScreeningPassed ? "#198754" : "#d9534f",
//             }}
//           >
//             Initial Screening Status: {initialScreeningPassed ? "Pass" : "Fail"} ({scores?.compatibility ?? "N/A"})
//           </div>

//     {Array.isArray(scores.l0_reasons) && scores.l0_reasons.length > 0 && (
//     <div
//       style={{
//         border: "1.6px solid #e7eefa",
//         borderRadius: 12,
//         padding: 10,
//         fontWeight: 700,
//         fontSize: 19,
//         color: "#2d3b51",
//         background: "#ffffffff",
//       }}
//     >
//       <div style={{ fontWeight: 700, marginBottom: 10 }}>L0 Reasons:</div>
//       <ul
//         style={{
//           marginTop: 6,
//           paddingLeft: 21,
//           color: "#444",
//           fontWeight: 500,
//           fontSize: 16,
//         }}
//       >
//         {scores.l0_reasons.map((reason, idx) => (
//           <li key={idx} style={{ marginBottom: 3, whiteSpace: "pre-wrap" }}>
//             {reason}
//           </li>
//         ))}
//       </ul>
//     </div>
//   )}
//         </div>
// <br></br>
// <br></br>
// <br></br>

// {/* Right Column: Separate tiles for L0 Reasons and Score Breakdown */}
// <div
//   style={{
//     gridArea: "right",
//     marginTop: 60,
//     display: "flex",
//     flexDirection: "column",
//     gap: 30, // space between tiles
//   }}
// >
//   <br></br>
//   {scores?.llm_score !== undefined && (
//     <div
//       style={{
//         border: "1.6px solid #e7eefa",
//         borderRadius: 12,
//         padding: 18,
//         fontWeight: 700,
//         fontSize: 20,
//         color: "#2d3b51",
//       }}
//     >
//       Resume Score: <span style={{ color: "#238a51" }}>{scores.llm_score} / 100</span>
//     </div>
//   )}

//   {scores?.score_breakdown?.length > 0 && (
//     <div
//       style={{
//         border: "1.6px solid #e7eefa",
//         borderRadius: 12,
//         padding: 18,
//         marginTop: -10,
//         fontWeight: 600,
//         fontSize: 20,
//         color: "#2d3b51",
//         background: "#ffffff",
//       }}
//     >
//       <div style={{ fontWeight: 700, marginBottom: 12 }}>Score Breakdown (Section wise):</div>
//       <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//         {scores.score_breakdown.map((item, idx) => (
//           <li key={idx}>
//             {item.category.charAt(0).toUpperCase() + item.category.slice(1)}: {item.score}
//           </li>
//         ))}
//       </ul>
//     </div>
//   )}

//   {/* L2 Question Icon Button: placed below Score Breakdown, above Reasons */}
//   {initialScreeningPassed && (
//     <div
//       style={{
//         marginTop: 24,  // space from Score Breakdown
//         marginBottom: 16, // space before Reasons below
//         display: "flex",
//         justifyContent: "flex-start",
//       }}
//     >
//       <button
//         onClick={handleOpenL2}
//         style={{
//           border: "none",
//           background: "transparent",
//           cursor: "pointer",
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//           padding: 0,
//         }}
//         title="Generate L2 interview questions"
//       >
//         <div
//           style={{
//             width: 34,
//             height: 34,
//             borderRadius: "50%",
//             background: "#e9f2ff",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             boxShadow: "0 2px 8px #2b6fe010",
//           }}
//         >
//           <span style={{ fontWeight: 800, color: "#2457ac", fontSize: 20 }}>L2</span>
//         </div>
//         <span style={{ fontSize: 14, color: "#2457ac", fontWeight: 600 }}>
//           Generate L2 Interview Questions
//         </span>
//       </button>
//     </div>
//   )}
// </div>


//         {/* Full-width Bottom: Reasons + L1 Q&A */}
//         <div style={{ gridArea: "bottom", width: "100%" }}>
//           {scores?.reasons?.length > 0 && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 fontWeight: 600,
//                 fontSize: 20,
//                 color: "#2d3b51",
//                 marginBottom: 32,
//               }}
//             >
//               <div style={{ fontWeight: 700, marginBottom: 12 }}>Reasons:</div>
//               <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//                 {scores.reasons.map((reason, idx) => (
//                   <li key={idx}>{reason}</li>
//                 ))}
//               </ul>
//             </div>
//           )}
//           {overallL1Score >= 0 && (
//   <>
//     {/* Overall L1 Score Tile */}
//     <div
//       style={{
//         border: "1.6px solid #e7eefa",
//         borderRadius: 12,
//         padding: 18,
//         fontWeight: 700,
//         fontSize: 20,
//         color: "#2d3b51",
//       }}
//     >
//       Overall L1 Score: <span style={{ color: "#238a51" }}>{overallL1Score}</span>
//     </div>
//             <br></br>
// {questionScores.length > 0 && (
//   <div
//     style={{
//       border: "1.6px solid #e7eefa",
//       borderRadius: 12,
//       padding: 18,
//       fontWeight: 600,
//       fontSize: 20,
//       color: "#2d3b51",
//       marginBottom: 32,
//     }}>
//     <div style={{ fontWeight: 700, marginBottom: 12 }}>L1 Questions and Responses:</div>
//     <div style={{
//       display: "flex",
//       flexDirection: "column",
//       gap: 34,
//       marginTop: 20,
//     }}>
//       {questionScores.map((qscore, idx) => (
//         <div key={idx} style={{
//           background: "#fff",
//           borderRadius: 16,
//           border: "1.6px solid #e2eefa",
//           boxShadow: "0 2px 10px #22519708",
//           padding: "26px 28px 22px 28px",
//           display: "flex",
//           flexDirection: "column",
//           gap: 9,
//           position: "relative"
//         }}>
//           {/* Score badge */}
//           <div style={{
//             position: "absolute",
//             top: 15,
//             right: 28,
//             fontWeight: 700,
//             padding: "6px 20px",
//             borderRadius: 14,
//             fontSize: 15,
//             background: qscore.score > 0 ? "#cdfee0" : "#ffeaea",
//             color: qscore.score > 0 ? "#228b22" : "#d9534f",
//             boxShadow: "0 0 6px #e1eefa50"
//           }}>
//             Score: {qscore.score}
//           </div>
//           {/* Question label + tile */}
//           <div style={{
//             fontWeight: 700,
//             color: "#213a7d",
//             fontSize: 25,
//             marginBottom: 7
//           }}>
//             Question
//           </div>
//           <div style={{
//             background: "#e6eeff",
//             borderRadius: 10,
//             padding: "14px 18px",
//             color: "#213a7d",
//             fontWeight: 600,
//             fontSize: 21,
//             wordBreak: "break-word",
//             minHeight: 40,
//             marginBottom: 19
//           }}>
//             {qscore.question}
//           </div>
//           {/* Answer label + tile */}
//           <div style={{
//             fontWeight: 700,
//             color: "#237804",
//             fontSize: 22,
//             marginBottom: 7
//           }}>
//             Answer summary
//           </div>
//           <div style={{
//             background: "#e5fbe7",
//             borderRadius: 10,
//             padding: "13px 18px",
//             color: "#136a24",
//             fontWeight: 500,
//             fontSize: 21,
//             wordBreak: "break-word",
//             minHeight: 36
//           }}>
//             {qscore.answer_summary || <span style={{ color: "#989" }}>No summary provided</span>}
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// )}
// </>
//           )}



//           {/* Verified Checkbox and Approve/Reject Buttons if Passed */}
//           {initialScreeningPassed && scores.status === "pending" && !decisionMade && (
//             <div style={{ marginBottom: 32, textAlign: "center" }}>
//               <label style={{ fontWeight: 600, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <input
//                   type="checkbox"
//                   checked={isVerified}
//                   onChange={e => setIsVerified(e.target.checked)}
//                   style={{ marginRight: 10, width: 18, height: 14 }}
//                 />
//                 <span style={{ color: "#236ef2", marginTop: -5, display: "inline-block" }}>
//                   Verified all details and ready for decision
//                 </span>
//               </label>
//             </div>
//           )}

//           {initialScreeningPassed && (
//             <div style={{ display: "flex", gap: 22, justifyContent: "center", marginBottom: 8 }}>
//               {scores.status === "pending" && !decisionMade ? (
//                 <>
//                   <button
//                     style={{
//                       background: "#32d157",
//                       color: "#fff",
//                       fontWeight: 600,
//                       fontSize: 16,
//                       border: "none",
//                       borderRadius: 8,
//                       padding: "16px 22px",
//                       cursor: isVerified ? "pointer" : "not-allowed",
//                       opacity: isVerified ? 1 : 0.6
//                     }}
//                     disabled={!isVerified}
//                     onClick={handleApprove}
//                   >
//                     Approve
//                   </button>
//                   <button
//                     style={{
//                       background: "#e34848",
//                       color: "#fff",
//                       fontWeight: 600,
//                       fontSize: 16,
//                       border: "none",
//                       borderRadius: 8,
//                       padding: "16px 22px",
//                       cursor: isVerified ? "pointer" : "not-allowed",
//                       opacity: isVerified ? 1 : 0.6
//                     }}
//                     disabled={!isVerified}
//                     onClick={handleReject}
//                   >
//                     Reject
//                   </button>
//                 </>
//               ) : scores.status === "approved" || (decisionMade && scores.status === "approved") ? (
//                 <span
//                   style={{
//                     background: "#eaf9ed",
//                     color: "#238a51",
//                     fontWeight: 600,
//                     fontSize: 20,
//                     width: 110,
//                     marginTop: 20,
//                     borderRadius: 8,
//                     padding: "15px 32px",
//                     marginLeft: 75,
//                     display: "inline-block"
//                   }}
//                 >
//                   Approved
//                 </span>
//               ) : (
//                 <span
//                   style={{
//                     background: "#ffebeb",
//                     color: "#d9534f",
//                     fontWeight: 600,
//                     fontSize: 20,
//                     width: 110,
//                     marginTop: 20,
//                     borderRadius: 8,
//                     padding: "10px 36px",
//                     marginLeft: 75,
//                     display: "inline-block"
//                   }}
//                 >
//                   Rejected
//                 </span>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// function ManualCandidateScoreModal({
//   open,
//   onClose,
//   candidate, // expects { full_name, email, phone, llm_score, score_breakdown, reasons }
//   loading,
//   error
// }) {
//   if (!open) return null;

//   const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
//   const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";

//   if (loading)
//     return (
//       <div style={{ padding: 200, display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <ClipLoader color="#2d3b51" size={120} />
//         <div style={{ marginTop: 10 }}>Loading candidate info...</div>
//       </div>
//     );

//   // Defensive defaults
//   const name = candidate?.full_name || "N/A";
//   const email = candidate?.email || "N/A";
//   const phone = candidate?.phone || "N/A";
//   const score = candidate?.llm_score !== undefined ? candidate.llm_score : "N/A";
//   const breakdown = Array.isArray(candidate?.score_breakdown) ? candidate.score_breakdown : [];
//   const l1Reasons = Array.isArray(candidate?.reasons) ? candidate.reasons : [];

//   const profileCircleStyle = {
//     width: 66,
//     height: 66,
//     borderRadius: "50%",
//     background: "radial-gradient(ellipse at 60% 40%, #eaf2ff 80%, #e4ecfc 100%)",
//     color: "#2457ac",
//     fontWeight: 800,
//     fontSize: 38,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 4px 20px #eaf2ff, inset 0 0 0 6px #fff",
//     border: "4px solid #fff",
//     marginRight: 18,
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         left: 0,
//         top: 0,
//         width: "100vw",
//         height: "100vh",
//         background: "rgba(36, 84, 217, 0.15)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 2100,
//         overflowY: "auto",
//         padding: 20,
//       }}
//       onClick={onClose}
//       aria-modal="true"
//       role="dialog"
//     >
//       <div
//         onClick={e => e.stopPropagation()}
//         style={{
//           minWidth: 700,
//           maxWidth: 850,
//           background: "#fff",
//           borderRadius: 14,
//           boxShadow: "0 6px 28px #52a4f420",
//           padding: "32px 40px",
//           position: "relative",
//           maxHeight: "90vh",
//           overflowY: "auto",
//           display: "grid",
//           gridTemplateAreas: `
//             "left right"
//             "bottom bottom"
//           `,
//           gridTemplateColumns: "1fr 1fr",
//           gridTemplateRows: "auto auto",
//           gridGap: 32,
//         }}
//       >
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             right: 18,
//             top: 6,
//             background: "none",
//             border: "none",
//             fontSize: 30,
//             color: "#236ef2",
//             cursor: "pointer",
//             fontWeight: 800,
//             lineHeight: 1,
//           }}
//           aria-label="Close Modal"
//         >
//           &times;
//         </button>
//         {/* LEFT: Personal Info */}
//         <div style={{ gridArea: "left", display: "flex", flexDirection: "column", gap: 18 }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
//             <div style={profileCircleStyle}>
//               {(name || "?")[0].toUpperCase()}
//             </div>
//             <div>
//               <div style={{ fontWeight: 800, fontSize: 28, color: "#182a43" }}>
//                 {name}
//               </div>
//               <div style={{ color: "#53709c", marginTop: 8 }}>
//                 <img src={emailIcon} alt="Email" style={{ width: 17, height: 17, marginRight: 6 }} />
//                 {email}
//               </div>
//               <div style={{ color: "#53709c", marginTop: 6 }}>
//                 <img src={phoneIcon} alt="Phone" style={{ width: 15, height: 15, marginRight: 7 }} />
//                 {phone}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div
//   style={{
//     gridArea: "left",
//     marginTop: 60,
//     display: "flex",
//     flexDirection: "column",
//     gap: 30, // space between two tiles
//   }}
// >
//   <br></br>
//   <br></br>
//   <br></br>
//   {score!== undefined && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 fontWeight: 700,
//                 fontSize: 20,
//                 marginright:150,
//                 color: "#2d3b51",
//               }}
//             >
//               Resume Score: <span style={{ color: "#238a51" }}>{score} / 100</span>
//             </div>
//           )}

//   {breakdown.length > 0 && (
//     <div
//       style={{
//         border: "1.6px solid #e7eefa",
//         borderRadius: 12,
//         padding: 18,
//         marginTop: -10,
//         fontWeight: 600,
//         fontSize: 20,
//         color: "#2d3b51",
//         background: "#ffffff",
//       }}
//     >
//       <div style={{ fontWeight: 700, marginBottom: 12 }}>Score Breakdown (Section wise):</div>
//       <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//         {breakdown.map((item, idx) => (
//           <li key={idx}>
//             {item.category.charAt(0).toUpperCase() + item.category.slice(1)}: {item.score}
//           </li>
//         ))}
//       </ul>
//     </div>
//   )}
// </div>
//         {/* BOTTOM: L1 Reasons */}
//         <div style={{ gridArea: "bottom", width: "100%" }}>
//           {l1Reasons.length > 0 && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 fontWeight: 600,
//                 fontSize: 20,
//                 color: "#2d3b51",
//               }}
//             >
//               <div style={{ fontWeight: 700, marginBottom: 12 }}>
//                 L1 Reasons:
//               </div>
//               <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//                 {l1Reasons.map((reason, idx) => (
//                   <li key={idx}>{reason}</li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }




// export default function HRJobApplications() {
//   const { jobrole, location, jobid } = useParams();
//   console.log("Params:", jobrole, location, jobid);

//   const navigate = useNavigate();
//   const [applications, setApplications] = useState([]);
//   const [loadingList, setLoadingList] = useState(true);
//   const [listError, setListError] = useState(null);

//   const [jobOnboarding, setJobOnboarding] = useState(null); 
//   const [showDetails, setShowDetails] = useState(false);
//   const [selectedCand, setSelectedCand] = useState(null);
//   const [loadingDetails, setLoadingDetails] = useState(false);
//   const [detailsError, setDetailsError] = useState(null);
//   const [applicationDate, setApplicationDate] = useState("N/A");

//   const [hoveredCard, setHoveredCard] = useState(null);


//   // For scores modal
//   const [showScores, setShowScores] = useState(false);
//   const [scores, setScores] = useState(null);
//   const [loadingScores, setLoadingScores] = useState(false);
//   const [scoresError, setScoresError] = useState(null);
//   const [showL2Dialog, setShowL2Dialog] = useState(false);
//   const [l2Loading, setL2Loading] = useState(false);
//   const [l2Questions, setL2Questions] = useState([]);
//   const [l2Error, setL2Error] = useState("");

//   const handleOpenL2 = async () => {
//   setShowL2Dialog(true);
//   setL2Loading(true);
//   setL2Error("");
//   try {
//     const res = await fetch(
//       // `https://screening.fanisko.com/l2-questions/${scores.candidate_id}/${scores.job_id}`
//         `${API_BASE_URL}/l2-questions/${scores.candidate_id}/${scores.job_id}`
//     );
//     const data = await res.json();
//     console.log("L2 RAW DATA:", data);

//     if (!res.ok || data.error) {
//       setL2Error(data.error || "Failed to generate L2 questions");
//       setL2Questions([]);
//     } else {
//       // backend: { "question": [...] }
//       const arr = Array.isArray(data.question) ? data.question : [];
//       console.log("L2 QUESTIONS ARRAY:", arr);
//       setL2Questions(arr);
//     }
//   } catch (e) {
//     setL2Error("Network error while generating L2 questions");
//     setL2Questions([]);
//   } finally {
//     setL2Loading(false);
//   }
// };



//   const fetchCandidates = () => {
//   setLoadingList(true);
//   // fetch(`https://screening.fanisko.com/api/candidate_scores/${jobid}`)
//     fetch(`${API_BASE_URL}/api/candidate_scores/${jobid}`)
//     .then(res => res.json())
//     .then(async scoresList => {
//       const mergedList = await Promise.all(scoresList.map(async cand => {
//         // const infoRes = await fetch(`https://screening.fanisko.com/api/candidate_by_id/${cand.candidate_id}`);
//         const infoRes = await fetch(`${API_BASE_URL}/api/candidate_by_id/${cand.candidate_id}`);
//         const info = await infoRes.json();
//         return { ...cand, name: info.name, email: info.email };
//       }));
//       setApplications(mergedList);
//       setLoadingList(false);
//       setListError(null);
//     })
//     .catch(err => {
//       setListError(err.message);
//       setLoadingList(false);
//     });
// };
//   useEffect(() => {
//   fetchCandidates();
// }, [jobid]);
// useEffect(() => {
//   if (!showScores) {
//     fetchCandidates();
//   }
// }, [showScores]);

//   const [filterOpen, setFilterOpen] = useState(false);
//   const [sortType, setSortType] = useState("");

//   const [screeningQA, setScreeningQA] = useState(null);

//   // const [tabFilter, setTabFilter] = useState("all");
//   // const [approvedCandidates, setApprovedCandidates] = useState([]);
//   // const [rejectedCandidates, setRejectedCandidates] = useState([]);
//   // const [l0Status, setL0Status] = useState("all");  // "all" | "passed" | "failed"
//   // const [l1Status, setL1Status] = useState("all");  // "all" | "approved" | "failed"
//   // const [activeTab, setActiveTab] = useState("all");
//   //   // Tab labels & keys
//   //   const tabDefinitions = [
//   //   { key: "all", label: "All" },
//   //   { key: "l0", label: "L0" },
//   //   { key: "l1", label: "L1" },
//   // ];
//   const [l0Dropdown, setL0Dropdown] = useState("all");
// const [l1Dropdown, setL1Dropdown] = useState("all");
// const [activeTab, setActiveTab] = useState("all");
// const [manualApplications, setManualApplications] = useState([]);
// const [loadingManual, setLoadingManual] = useState(false);
// const [manualError, setManualError] = useState(null);
// const [showManualScore, setShowManualScore] = useState(false);
// const [selectedManualCandidate, setSelectedManualCandidate] = useState(null);
// const [manualScoreLoading, setManualScoreLoading] = useState(false);
// const [manualScoreError, setManualScoreError] = useState(null);
// const [loadingManualScore, setLoadingManualScore] = useState(false);
// const [showManualScoreModal, setShowManualScoreModal] = useState(false);
// const [manualCandidateScore, setManualCandidateScore] = useState(null);



// const tabDefs = [
//   { key: "all", label: "All" },
//   { key: "l0", label: "L0" },
//   { key: "l1", label: "L1" },
//   { key: "manual", label: "Manual" }, // New tab
// ];

// const [showL0Dropdown, setShowL0Dropdown] = useState(false);
// const [showL1Dropdown, setShowL1Dropdown] = useState(false);

//   // Fetch candidate list for job
//   useEffect(() => {
//   setLoadingList(true);
//   // fetch(`https://screening.fanisko.com/api/candidate_scores/${jobid}`)
//     fetch(`${API_BASE_URL}/api/candidate_scores/${jobid}`)
//     .then(res => res.json())
//     .then(async scoresList => {
//       // Fetch name/email for every candidate_id
//       const mergedList = await Promise.all(scoresList.map(async cand => {
//         // const infoRes = await fetch(`https://screening.fanisko.com/api/candidate_by_id/${cand.candidate_id}`);
//         const infoRes = await fetch(`${API_BASE_URL}/api/candidate_by_id/${cand.candidate_id}`);
//         const info = await infoRes.json();
//         return { ...cand, name: info.name, email: info.email };
//       }));
//       setApplications(mergedList);
//       setLoadingList(false);
//       setListError(null);
//     })
//     .catch(err => {
//       setListError(err.message);
//       setLoadingList(false);
//     });
// }, [jobid]);

// useEffect(() => {
//   if (activeTab === "manual") {
//     setLoadingManual(true);
//     // fetch(`https://screening.fanisko.com/api/manual_candidates/${jobid}`)
//     fetch(`${API_BASE_URL}/api/manual_candidates/${jobid}`)
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to fetch manual candidates");
//         return res.json();
//       })
//       .then(manualList => {
//         setManualApplications(manualList); // manualList includes {candidate_id, full_name, email, phone, llm_score}
//         setLoadingManual(false);
//         setManualError(null);
//       })
//       .catch(err => {
//         setManualError(err.message);
//         setLoadingManual(false);
//       });
//   }
// }, [activeTab, jobid]);


// const openCandidateDetails = (candidate) => {
//   setLoadingDetails(true);
//   setDetailsError(null);
//   setShowDetails(true);
//   setSelectedCand(null);
//   setApplicationDate("N/A");

//   // Fetch candidate basic details
//   // fetch(`https://screening.fanisko.com/api/candidate/${candidate.candidate_id}?job_id=${jobid}`)
//    fetch(`${API_BASE_URL}/api/candidate/${candidate.candidate_id}?job_id=${jobid}`)
//     .then((res) => {
//       if (!res.ok) throw new Error("Failed to fetch candidate details");
//       return res.json();
//     })
// .then((data) => {
//   setSelectedCand(data);
//   console.log("Fetched candidate details:", data);                // Check entire candidate object
//   console.log("Will fetch onboarding for job_id:", data.job_id);  // Should be a valid string, not undefined

//   if (data.job_id) {
//     // fetch(`https://screening.fanisko.com/api/jobview/${data.job_id}/onboarding`)
//      fetch(`${API_BASE_URL}/api/jobview/${data.job_id}/onboarding`)
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to fetch onboarding questions");
//         return res.json();
//       })
//       .then(onboarding => setJobOnboarding(onboarding))
//       .catch(() => setJobOnboarding(null)); // If no onboarding, set to null
//   } else {
//     console.error("No job_id found in candidate data — onboarding fetch skipped");
//     setJobOnboarding(null);
//   }

//       // After getting candidate details, fetch resume upload date
//       if (data.resume_file_id) {
//         // fetch(`https://screening.fanisko.com/api/resume_upload_date/${candidate.candidate_id}/${jobid}`)
//         fetch(`${API_BASE_URL}/api/resume_upload_date/${candidate.candidate_id}/${jobid}`)
//           .then((res) => {
//             if (!res.ok) throw new Error("Failed to fetch resume upload date");
//             return res.json();
//           })
//           .then((dateData) => {
//             if (dateData.uploadDate) {
//               setApplicationDate(new Date(dateData.uploadDate).toLocaleString());
//             }
//           })
//           .catch(() => {
//             setApplicationDate("N/A");
//           });
//       } else {
//         setApplicationDate("N/A");
//       }

//       setLoadingDetails(false);
//     })
//     .catch((err) => {
//       setDetailsError(err.message);
//       setLoadingDetails(false);
//     });
// };



//   // Fetch candidate scores and show modal
//  const openCandidateScores = async (candidate) => {
//   setLoadingScores(true);
//   setScoresError(null);
//   setScores(null);
//   setScreeningQA(null); // reset Q&A
//   setShowScores(true);

//   try {
//     const [scoresRes, infoRes] = await Promise.all([
//       // fetch(`https://screening.fanisko.com/api/get_final_score?candidate_id=${candidate.candidate_id}&job_id=${jobid}`),
//       // fetch(`https://screening.fanisko.com/api/candidate_by_id/${candidate.candidate_id}`)
//        fetch(`${API_BASE_URL}/api/get_final_score?candidate_id=${candidate.candidate_id}&job_id=${jobid}`),
//         fetch(`${API_BASE_URL}/api/candidate_by_id/${candidate.candidate_id}`)
//     ]);
//     if (!scoresRes.ok) throw new Error("Failed to fetch candidate scores");
//     if (!infoRes.ok) throw new Error("Failed to fetch candidate info");

//     const scoresData = await scoresRes.json();
//     const infoData = await infoRes.json();

//     // Merge candidate info into the scores object
//     const mergedScores = {
//       ...scoresData,
//       candidate_name: infoData.name,
//       candidate_email: infoData.email,
//       candidate_phone: infoData.phone,
//     };
//     setScores(mergedScores);

//     // Only fetch Q&A if candidate passed
//     if (mergedScores.llm_score && mergedScores.llm_score > 0) {
//       const screeningRes = await fetch(
//         // `https://screening.fanisko.com/api/screening_questions?candidate_id=${candidate.candidate_id}&job_id=${jobid}`
//           `${API_BASE_URL}/api/screening_questions?candidate_id=${candidate.candidate_id}&job_id=${jobid}`
//       );
//       if (screeningRes.ok) {
//         setScreeningQA(await screeningRes.json());
//       }
//     }

//     setLoadingScores(false);
//   } catch (err) {
//     setScoresError(err.message);
//     setLoadingScores(false);
//   }
// };

// const openManualScore = (cand) => {
//   setManualCandidateScore(cand); // use full object directly
//   setShowManualScoreModal(true);
// };

// const renderManualCandidateCard = (cand, i) => (

//   <div
//     key={i}
//     style={{
//       background: "#fff",
//       borderRadius: 14,
//       boxShadow: "0 4px 18px rgba(35,115,240,0.08)",
//       padding: "22px 22px 20px 22px",
//       minHeight: 170,
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "stretch",
//       border: "1px solid #35b5ffff",
//       cursor: "default"
//     }}
//     onMouseEnter={() => setHoveredCard(i)}
//     onMouseLeave={() => setHoveredCard(null)}
//   >
//     <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
//       <div
//         aria-label="Profile"
//         title={cand.full_name || "Applicant"}
//         style={{
//           width: 44,
//           height: 44,
//           borderRadius: "50%",
//           background: "linear-gradient(135deg,#eaf2ff,#cfe0ff)",
//           color: "#1b4ab8",
//           fontWeight: 800,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           boxShadow: "inset 0 0 0 2px #ffffff, 0 2px 8px rgba(35,115,240,.12)",
//         }}
//       >
//         {(cand?.full_name || "?").toString().trim().slice(0, 1).toUpperCase()}
//       </div>
//       <div style={{ minWidth: 0 }}>
//         <div
//           style={{
//             fontWeight: 800,
//             fontSize: 16,
//             color: "#1c3558",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis"
//           }}
//           title={cand.full_name || ""}
//         >
//           {cand.full_name || "N/A"}
//         </div>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 4,
//             fontSize: 13,
//             color: "#5f779b",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis"
//           }}
//           title={cand.email || ""}
//         >
//           <img
//             src="https://cdn-icons-png.flaticon.com/128/14348/14348015.png"
//             alt="Email Icon"
//             style={{ width: 16, height: 16, flexShrink: 0 }}
//           />
//           <span>{cand.email || "N/A"}</span>
//         </div>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 4,
//             fontSize: 13,
//             color: "#5f779b",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis"
//           }}
//           title={cand.email || ""}
//         >
//           <img
//             src="https://cdn-icons-png.flaticon.com/128/597/597177.png"
//             alt="Email Icon"
//             style={{ width: 16, height: 16, flexShrink: 0 }}
//           />
//           <span>{cand.phone || "N/A"}</span>
//         </div>
//         <div
//           style={{
//             fontSize: 15,
//             color: "#000000",
//             fontWeight: 600,
//             marginTop: 4,
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis"
//           }}
//           title={`Resume Score: ${cand.llm_score ?? "N/A"}/100`}
//         >
//           Resume Score:{" "}
//           <span style={{ marginLeft: 20, color: "#2c6d15" }}>
//             {typeof cand.llm_score === "number" ? `${cand.llm_score}/100` : "N/A"}
//           </span>
//         </div>
//         {/* Add status or additional info as needed */}
//       </div>
//     </div>
//     <div style={{
//       marginTop: "auto",
//       width: "100%",
//       display: "flex",
//       gap: 12
//     }}>
//       <button
//   onClick={() => {
//     setSelectedManualCandidate(cand);
//     setShowManualScore(true);
//   }}
//   style={{
//     background: "#1e7e34",
//     color: "#fff",
//     fontWeight: 700,
//     padding: "10px 0",
//     border: "none",
//     borderRadius: 6,
//     fontSize: 15,
//     cursor: "pointer",
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",
//     flex: 1,
//     minWidth: 0
//   }}
// >
//   View Scores
// </button>
//     </div>
//   </div>
// );

// if (loadingList)
//   return (
//     <div style={{ padding: 300, display: "flex", flexDirection: "column", alignItems: "center" }}>
//       <ClipLoader color="#2d3b51" size={32} />
//       <div style={{ marginTop: 10 }}>Loading candidates...</div>
//     </div>
//   );

//   if (listError)
//     return (
//       <div style={{ padding: 20, color: "red" }}>
//         Error loading candidates: {listError}
//       </div>
//     );

// const applySort = (apps, sortType) => {
//   if (sortType === "score-desc") {
//     return [...apps].sort((a, b) => (b.llm_score ?? 0) - (a.llm_score ?? 0));
//   }
//   if (sortType === "score-asc") {
//     return [...apps].sort((a, b) => (a.llm_score ?? 0) - (b.llm_score ?? 0));
//   }
//   return apps;
// };

// const sortedApplications = applySort(applications, sortType);

//   const l0PassedCount = applications.filter(cand => (cand.compatibility ?? 0) >= 40).length;
// const l0FailedCount = applications.filter(cand => (cand.compatibility ?? 0) < 40).length;
// const l1ApprovedCount = applications.filter(cand => cand.status === "approved").length;





// // Filtering by tab selection
// const filteredApplications = sortedApplications.filter((cand) => {
//   // if (activeTab === "all") return true;
//   if (activeTab === "l0") {
//     const screened = (cand.compatibility ?? 0) >= 40;
//     if (l0Dropdown === "all") return true;
//     if (l0Dropdown === "passed") return screened;
//     if (l0Dropdown === "failed") return !screened;
//   }
//   if (activeTab === "l1") {
//     if (l1Dropdown === "all") return cand.status === "approved" || cand.status === "rejected";
//     if (l1Dropdown === "approved") return cand.status === "approved";
//     if (l1Dropdown === "rejected") return cand.status === "rejected";
//   }
//   return true;
// });



// const getSortLabel = (sortType) => {
//   switch (sortType) {
//     case "score-desc":
//       return "High to Low";
//     case "score-asc":
//       return "Low to High";
//     default:
//       return "Filter & Sort";
//   }
// };

//   // Helper to render a candidate card used in both grids
//   const renderCandidateCard = (cand, i) => (
//     <div
//       key={i}
//       style={{
//         background: "#fff",
//         borderRadius: 14,
//         boxShadow:
//           hoveredCard === i
//             ? "0 10px 26px rgba(39,130,226,0.18)"
//             : "0 4px 18px rgba(35,115,240,0.08)",
//         padding: "22px 22px 20px 22px",
//         minHeight: 170,
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "stretch",
//         transform: hoveredCard === i ? "translateY(-4px)" : "translateY(0)",
//         transition: "all 0.2s ease",
//         border: "1px solid #35b5ffff",
//         cursor: "default",
//       }}
//       onMouseEnter={() => setHoveredCard(i)}
//       onMouseLeave={() => setHoveredCard(null)}
//     >
//       <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
//         <div
//           aria-label="Profile"
//           title={cand.name || "Applicant"}
//           style={{
//             width: 44,
//             height: 44,
//             borderRadius: "50%",
//             background: "linear-gradient(135deg,#eaf2ff,#cfe0ff)",
//             color: "#1b4ab8",
//             fontWeight: 800,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             boxShadow: "inset 0 0 0 2px #ffffff, 0 2px 8px rgba(35,115,240,.12)",
//           }}
//         >
//           {(cand?.name || "?")
//             .toString()
//             .trim()
//             .slice(0, 1)
//             .toUpperCase()}
//         </div>
//         <div style={{ minWidth: 0 }}>
//           <div
//             style={{
//               fontWeight: 800,
//               fontSize: 16,
//               color: "#1c3558",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//             }}
//             title={cand.name || ""}
//           >
//             {cand.name || "N/A"}
//           </div>
//           <div
//   style={{
//     display: "flex",
//     alignItems: "center",
//     gap: 4,
//     fontSize: 13,
//     color: "#5f779b",
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",
//   }}
//   title={cand.email || ""}
// >
//   <img
//     src="https://cdn-icons-png.flaticon.com/128/14348/14348015.png"
//     alt="Email Icon"
//     style={{ width: 16, height: 16, flexShrink: 0 }}
//   />
//   <span>{cand.email || "N/A"}</span>
// </div>
//           <div
//   style={{
//     fontSize: 15,
//     color: "#000000", // black for label
//     fontWeight: 600,
//     marginTop: 4,
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",
//   }}
//   title={`Resume Score: ${cand.llm_score ?? "N/A"}/100`}
// >
//   Resume Score:{" "}
//   <span style={{ marginLeft:65,color: "#2c6d15" }}>
//     {cand.llm_score !== undefined ? `${cand.llm_score}/100` : "N/A"}
//   </span>
// </div>
// <div style={{
//   display: "flex",
//   alignItems: "center",
//   gap: 8,
//   fontSize: 15,
//   color: "#000",
//   fontWeight: 600,
//   marginTop: 4,
// }}>
//   <span>Status:</span>
//   {cand.status === "approved" ? (
//     <span style={{
//       background: "#eaf9ed",
//       color: "#238a51",
//       fontWeight: 600,
//       fontSize: 13,
//       borderRadius: 8,
//       padding: "5px 16px",
//       marginLeft: 10,
//       display: "inline-block"
//     }}>Approved</span>
//   ) : cand.status === "rejected" ? (
//     <span style={{
//       background: "#ffebeb",
//       color: "#d9534f",
//       fontWeight: 600,
//       fontSize: 13,
//       borderRadius: 8,
//       padding: "5px 16px",
//       marginLeft: 10,
//       display: "inline-block"
//     }}>Rejected</span>
//   ) : (
//     <span style={{
//       color: "#777",
//       fontSize: 13,
//       marginLeft: 10,
//       fontStyle: "italic"
//     }}>Pending</span>
//   )}
// </div>
//         </div>
//       </div>
//       <div
//         style={{
//           marginTop: "auto",
//           width: "100%",
//           display: "flex",
//           gap: 12
//         }}
//       >
//         <button
//           style={{
//             background: "#2684ff",
//             color: "#fff",
//             fontWeight: 700,  
//             padding: "10px 0",
//             border: "none",
//             borderRadius: 6,
//             fontSize: 15,
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             flex: 1,
//             minWidth: 0
//           }}
//           onClick={() => openCandidateDetails(cand)}
//         >
//           More Info
//         </button>
//         <button
//           style={{
//             background: "#1e7e34",
//             color: "#fff",
//             fontWeight: 700,
//             padding: "10px 0",
//             border: "none",
//             borderRadius: 6,
//             fontSize: 15,
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             flex: 1,
//             minWidth: 0
//           }}
//           onClick={() => openCandidateScores(cand)}
//         >
//           View Scores
//         </button>
//       </div>
//     </div>
//   );


//   return (
//     <>
//       {/* Header with job info from params */}
//       <div
//         style={{
//           position: "sticky",
//           top: 0,
//           left: 0,
//           right: 0,
//           background: "#fff",
//           zIndex: 110,
//           borderBottom: "1px solid #f0f1f5",
//           padding: "24px 40px 18px 40px",
//           display: "flex",
//           alignItems: "flex-end",
//           justifyContent: "space-between",
//         }}
//       >
//         <div>
//           <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
//             <button
//               onClick={() => navigate(-1)}
//               style={{
//                 background: "#eaf2ff",
//                 color: "#236ef2",
//                 border: "none",
//                 borderRadius: 8,
//                 padding: "8px 12px",
//                 fontWeight: 700,
//                 cursor: "pointer",
//               }}
//             >
//               ← Back to Jobs
//             </button>
//             <span style={{ fontSize: 40, fontWeight: 800,marginLeft:10, color: "#172d44" }}>
//               {jobrole || "Job"}
//             </span>
//           </div>
//           <div style={{ color: "#5a6e8a",marginLeft:150,fontSize:20, fontWeight: 600 }}>
//             <span style={{ marginRight: 12 }}>{jobid}</span>·
//             <span style={{ marginLeft: 12 }}>{location}</span>
//           </div>
//         </div>
//         <div style={{ color: "#4a5f85", marginRight: 40, marginBottom: 10, fontWeight: 800 }}>
//   Total Applications: <span style={{ color: "#236ef2" }}>{applications.length}</span>
//   <div style={{ fontWeight: 600, marginTop: 4 }}>
//     <span style={{ color: "#4a5f85", fontWeight: 800 }}>L0 Passed:</span><span style={{ color: "#236ef2" }}> {l0PassedCount} </span> |<span style={{ color: "#4a5f85", fontWeight: 800 }}> L0 Failed:</span> <span style={{ color: "#236ef2" }}> {l0FailedCount} </span> | <span style={{ color: "#4a5f85", fontWeight: 800 }}>L1 Approved:</span><span style={{ color: "#236ef2" }}> {l1ApprovedCount}</span>
//   </div>
// </div>
//       </div>

// {/* Filter and Sort Bar with Tabs */}
//       <div
//   style={{
//     width: "95%",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     background: "#f9fbff",
//     padding: "12px 36px 8px 36px",
//     borderBottom: "1px solid #ebfaedff",
//     marginBottom: 16,
//     position: "relative"
//   }}
// >
//   <div
//   style={{
//     display: "flex",
//     gap: 4,
//     justifyContent: "flex-start", 
//     marginLeft:153,    // <-- LEFT ALIGN
//     alignItems: "center",
//     flex: 1,                      // <-- MAKE SURE TABS FILL THE ROW
//   }}
// >
//    {tabDefs.map(tab => (
//   <div key={tab.key} style={{ position: "relative" }}>
//     {tab.key === "l0" ? (
//       <button
//          onClick={() => {
//       setActiveTab("l0");
//       setShowL0Dropdown(true);
//       setShowL1Dropdown(false);
//     }}
//         style={{
//           background: activeTab === "l0" ? "#236ef2" : "transparent",
//           color: activeTab === "l0" ? "#fff" : "#236ef2",
//           border: "none",
//           borderRadius: 8,
//           padding: "8px 20px",
//           fontWeight: 700,
//           cursor: "pointer",
//           fontSize: 18,
//           boxShadow: activeTab === "l0" ? "0 2px 8px #b9dbff45" : "none",
//         }}
//       >
//         {tab.label}
//       <span style={{
//       marginLeft: 6,
//       fontSize: 16,
//       transition: "transform 0.2s",
//       transform: showL0Dropdown ? "rotate(180deg)" : "none"
//     }}>
//       ▼
//     </span>
//   </button>
//     ) : tab.key === "l1" ? (
//       <button
//         onClick={() => {
//       setActiveTab("l1");
//       setShowL1Dropdown(true);
//       setShowL0Dropdown(false);
//     }}
//         style={{
//           background: activeTab === "l1" ? "#236ef2" : "transparent",
//           color: activeTab === "l1" ? "#fff" : "#236ef2",
//           border: "none",
//           borderRadius: 8,
//           padding: "8px 20px",
//           fontWeight: 700,
//           cursor: "pointer",
//           fontSize: 18,
//           boxShadow: activeTab === "l1" ? "0 2px 8px #b9dbff45" : "none",
//         }}
//       >
//         {tab.label}
//          <span style={{
//       marginLeft: 6,
//       fontSize: 16,
//       transition: "transform 0.2s",
//       transform: showL1Dropdown ? "rotate(180deg)" : "none"
//     }}>
//       ▼
//     </span>
//       </button>
//     ) : (
//       <button
//         onClick={() => setActiveTab(tab.key)}
//         style={{
//           background: activeTab === tab.key ? "#236ef2" : "transparent",
//           color: activeTab === tab.key ? "#fff" : "#236ef2",
//           border: "none",
//           borderRadius: 8,
//           padding: "8px 20px",
//           fontWeight: 700,
//           cursor: "pointer",
//           fontSize: 18,
//           boxShadow: activeTab === tab.key ? "0 2px 8px #b9dbff45" : "none",
//         }}
//       >
//         {tab.label}

//   </button>
//     )}

//     {/* Show custom dropdown if L0 tab is active and dropdown is open */}
//     {tab.key === "l0" && activeTab === "l0" && showL0Dropdown && (
//       <div style={{
//         position: "absolute",
//         top: "100%",
//         left: 0,
//         background: "#fff",
//         border: "1px solid #daeafd",
//         borderRadius: 7,
//         marginTop: 5,
//         boxShadow: "0 7px 18px #dae2ff59",
//         zIndex: 200,
//         minWidth: 144,
//         fontWeight: 600,
//       }}>
//         <div
//           style={{
//             padding: "10px 22px",
//             color: l0Dropdown === "passed" ? "#fff" : "#236ef2",
//             background: l0Dropdown === "passed" ? "#236ef2" : "none",
//             cursor: "pointer",
//             borderTopLeftRadius: 7,
//             borderTopRightRadius: 7,
//           }}
//           onClick={() => {
//             setL0Dropdown("passed");
//             setShowL0Dropdown(false); // Close after selection
//           }}
//         >
//           L0 Passed
//         </div>
//         <div
//           style={{
//             padding: "10px 22px",
//             color: l0Dropdown === "failed" ? "#fff" : "#236ef2",
//             background: l0Dropdown === "failed" ? "#236ef2" : "none",
//             cursor: "pointer",
//             borderBottomLeftRadius: 7,
//             borderBottomRightRadius: 7,
//           }}
//           onClick={() => {
//             setL0Dropdown("failed");
//             setShowL0Dropdown(false); // Close after selection
//           }}
//         >
//           L0 Failed
//         </div>
//       </div>
//     )}

//     {/* Same for L1 */}
//     {tab.key === "l1" && activeTab === "l1" && showL1Dropdown && (
//       <div style={{
//         position: "absolute",
//         top: "100%",
//         left: 0,
//         background: "#fff",
//         border: "1px solid #daeafd",
//         borderRadius: 7,
//         marginTop: 5,
//         boxShadow: "0 7px 18px #dae2ff59",
//         zIndex: 200,
//         minWidth: 144,
//         fontWeight: 600,
//       }}>
//         <div
//           style={{
//             padding: "10px 22px",
//             color: l1Dropdown === "approved" ? "#fff" : "#236ef2",
//             background: l1Dropdown === "approved" ? "#236ef2" : "none",
//             cursor: "pointer",
//             borderTopLeftRadius: 7,
//             borderTopRightRadius: 7,
//           }}
//           onClick={() => {
//             setL1Dropdown("approved");
//             setShowL1Dropdown(false);
//           }}
//         >
//           L1 Approved
//         </div>
//         <div
//           style={{
//             padding: "10px 22px",
//             color: l1Dropdown === "rejected" ? "#fff" : "#236ef2",
//             background: l1Dropdown === "rejected" ? "#236ef2" : "none",
//             cursor: "pointer",
//             borderBottomLeftRadius: 7,
//             borderBottomRightRadius: 7,
//           }}
//           onClick={() => {
//             setL1Dropdown("rejected");
//             setShowL1Dropdown(false);
//           }}
//         >
//           L1 Rejected
//         </div>
//       </div>
//     )}
//   </div>
// ))}
//   </div>

//   {/* Sort button absolutely positioned on the right */}
//   <div
//     style={{
//       position: "absolute",
//       right: 36,
//       top: "50%",
//       transform: "translateY(-50%)",
//     }}
//   >
//     <button
//       style={{
//         background: "#eef5ff",
//         color: "#236ef2",
//         border: "1px solid #daeafd",
//         borderRadius: 8,
//         fontWeight: 700,
//         fontSize: 16,
//         padding: "10px 22px 10px 16px",
//         cursor: "pointer",
//         display: "flex",
//         alignItems: "center",
//         gap: 7,
//         userSelect: "none"
//       }}
//       onClick={() => setFilterOpen(f => !f)}
//     >
//       {getSortLabel(sortType)}
//       <span style={{
//         fontSize: 15,
//         transform: filterOpen ? "rotate(180deg)" : "none",
//         transition: "transform 0.2s ease"
//       }}>▼</span>
//     </button>
//     {filterOpen && (
//       <div style={{
//         position: "absolute",
//         right: 0,
//         top: "115%",
//         minWidth: 170,
//         background: "#fff",
//         border: "1px solid #ddeafc",
//         borderRadius: 8,
//         boxShadow: "0 7px 18px #dae2ff59",
//         zIndex: 30,
//         padding: "10px 0",
//       }}>
//         <button
//           style={{
//             background: "none",
//             border: "none",
//             color: "#236ef2",
//             fontWeight: 600,
//             textAlign: "left",
//             width: "100%",
//             padding: "10px 24px",
//             cursor: "pointer",
//             fontSize: 15,
//             userSelect: "none"
//           }}
//           onClick={() => { setSortType("score-desc"); setFilterOpen(false); }}
//         >
//           Sort by High Score
//         </button>
//         <button
//           style={{
//             background: "none",
//             border: "none",
//             color: "#236ef2",
//             fontWeight: 600,
//             textAlign: "left",
//             width: "100%",
//             padding: "10px 24px",
//             cursor: "pointer",
//             fontSize: 15,
//             userSelect: "none"
//           }}
//           onClick={() => { setSortType("score-asc"); setFilterOpen(false); }}
//         >
//           Sort by Low Score
//         </button>
//       </div>
//     )}
//   </div>
// </div>

//       {/* Candidate Cards Grid filtered */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(3, 320px)",
//           gap: 32,
//           justifyContent: "center",
//           alignItems: "start",
//           maxWidth: 1080,
//           margin: "28px auto 0 auto",
//           padding: "0 16px"
//         }}
//       >
//         {activeTab === "manual" ? (
//     loadingManual ? (
//       <div>Loading manual candidates...</div>
//     ) : manualError ? (
//       <div style={{ color: "red" }}>Error loading manual candidates: {manualError}</div>
//     ) : manualApplications.length === 0 ? (
//       <div>No manual candidates added by HR found.</div>
//     ) : (
//       manualApplications.map((cand, i) => renderManualCandidateCard(cand, i))
//     )
//   ) : (
//     filteredApplications.length === 0 ? (
//       <div style={{ color: "#999", fontSize: 17 }}>
//         No applications found for this filter.
//       </div>
//     ) : (
//       filteredApplications.map((cand, i) => renderCandidateCard(cand, i))
//     )
//   )}
// </div>

//       {/* Candidate details modal */}
//       <CandidateDetailsModal
//         open={showDetails}
//         onClose={() => setShowDetails(false)}
//         candidate={selectedCand}
//         jobOnboarding={jobOnboarding}
//         loading={loadingDetails}
//         applicationDate={applicationDate}
// />


//       {/* Candidate scores modal */}
//       <CandidateScoreModal
//   open={showScores}
//   onClose={() => setShowScores(false)}
//   scores={scores}
//   screeningQA={screeningQA}
//   loading={loadingScores}
//   error={scoresError}
//   handleOpenL2={handleOpenL2}  
// />
// {showL2Dialog && (
//   <L2QuestionsDialog
//     onClose={() => setShowL2Dialog(false)}
//     loading={l2Loading}
//     questions={l2Questions}
//     error={l2Error}
//   />
// )}
// <ManualCandidateScoreModal
//   open={showManualScore}
//   onClose={() => setShowManualScore(false)}
//   candidate={selectedManualCandidate}
//   loading={manualScoreLoading}
//   error={manualScoreError}
// />

//     </>
//   );
// }

// pdf format set ready
// import React, { useEffect, useState, useRef } from "react";
// import { ClipLoader } from "react-spinners"; // Example react-spinners usage
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { useParams, useNavigate } from "react-router-dom";

// const API_BASE_URL = "http://127.0.0.1:8000";



// function ResumePreviewModal({ open, onClose, pdfUrl }) {
//   if (!open || !pdfUrl) return null;

//   return (
//     <div
//       style={{
//         position: "fixed",
//         left: -300, top: 0, width: "120vw", height: "100vh",
//         background: "rgba(20,40,90,0.29)",
//         display: "flex", alignItems: "center", justifyContent: "center",
//         zIndex: 9999,
//       }}
//       onClick={onClose}
//     >
//       {/* Close button OUTSIDE preview box */}
//       <button
//         onClick={onClose}
//         aria-label="Close Resume"
//         style={{
//           position: "fixed", // Instead of absolute, so it's relative to viewport
//           right: "10vw",
//           top: "4vh",        // Or try top: 22px;
//           background: "none",
//           border: "none",
//           fontSize: 33,
//           color: "#000000ff",
//           cursor: "pointer",
//           fontWeight: 900,
//           zIndex: 800,     // Higher than preview
//           padding: 18,
//           lineHeight: 1,
//         }}
//       >
//         &times;
//       </button>
//       <div
//         onClick={e => e.stopPropagation()}
//         style={{
//           background: "#fff",
//           borderRadius: 12,
//           boxShadow: "0 8px 48px #11275360",
//           width: "min(700px,96vw)",
//           maxHeight: "80vh",
//           position: "relative",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <iframe
//           title="Resume Preview"
//           src={pdfUrl}
//           width="150%"
//           height="800px"
//           marginright="200px"
//           style={{ border: "none", borderRadius: 12 }}
//         />
//       </div>
//     </div>
//   );
// }

// function parseCoverLetter(raw) {
//   console.log("parseCoverLetter INPUT:", raw);

//   // If raw is an object with type and value, extract the value string
//   let valueStr = raw;
//   if (typeof raw === "object" && raw !== null && "value" in raw) {
//     valueStr = raw.value;
//   }

//   if (valueStr && typeof valueStr === "string" && valueStr.includes("_")) {
//     const lastUnderscoreIndex = valueStr.lastIndexOf("_");
//     const possibleId = valueStr.slice(lastUnderscoreIndex + 1);
//     console.log("parseCoverLetter possibleId:", possibleId);

//     if (lastUnderscoreIndex > 0 && possibleId && /^[a-fA-F0-9]+$/.test(possibleId)) {
//       console.log("parseCoverLetter: showButton = true");
//       return {
//         showButton: true,
//         value: possibleId,
//         filename: valueStr.slice(0, lastUnderscoreIndex),
//       };
//     }
//     console.log("parseCoverLetter: showButton = false - did not match hex/number");
//   }

//   return { showButton: false, value: valueStr || "" };
// }

// function convertUtcToIst(utcDateStr) {
//   // Parse the date string directly as UTC
//   const utcDate = new Date(utcDateStr + ' UTC');
//   // Format the date explicitly in 'Asia/Kolkata' timezone
//   return utcDate.toLocaleString('en-IN', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//     hour12: true,
//     timeZone: 'Asia/Kolkata',
//   });
// }
// // --- Modal to preview (file or text) ---
// function CoverLetterPreviewModal({ open, onClose, coverLetter }) {
//   if (!open) return null;
//   console.log("CoverLetterPreviewModal: coverLetter:", coverLetter);

//   if (coverLetter.showButton && coverLetter.value) {
//     const fileUrl = `${API_BASE_URL}/api/cover_letter_file/${coverLetter.value}`;
//     return (
//       <div
//         style={{
//           position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
//           background: "rgba(20,40,90,0.29)",
//           display: "flex", alignItems: "center", justifyContent: "center",
//           zIndex: 9999,
//         }}
//         onClick={onClose}
//       >
//         <button
//           onClick={onClose}
//           aria-label="Close Cover Letter"
//           style={{
//             position: "fixed", right: "20vw", top: "6vh",
//             background: "none", border: "none", fontSize: 33, color: "#000000ff",
//             cursor: "pointer", fontWeight: 900, zIndex: 800, padding: 18, lineHeight: 1,
//           }}
//         >&times;</button>
//         <div
//           onClick={(e) => e.stopPropagation()}
//           style={{
//             background: "#fff", borderRadius: 12, boxShadow: "0 8px 48px #11275360",
//             width: "min(700px,96vw)", height: "80vh",
//             position: "relative", display: "flex", flexDirection: "column",
//           }}>
//           <iframe
//             title="Cover Letter Preview"
//             src={fileUrl}
//             width="100%"
//             height="100%"
//             style={{ border: "none", borderRadius: 12 }}
//           />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
//         background: "rgba(20,40,90,0.29)",
//         display: "flex", alignItems: "center", justifyContent: "center",
//         zIndex: 9999,
//       }}
//       onClick={onClose}
//     >
//       <button
//         onClick={onClose}
//         aria-label="Close Cover Letter"
//         style={{
//           position: "fixed", right: "20vw", top: "6vh", background: "none",
//           border: "none", fontSize: 33, color: "#000000ff", cursor: "pointer",
//           fontWeight: 900, zIndex: 800, padding: 18, lineHeight: 1,
//         }}
//       >&times;</button>
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           background: "#fff", borderRadius: 12, boxShadow: "0 8px 48px #11275360",
//           width: "min(700px,96vw)", maxHeight: "80vh", padding: 30,
//           overflowY: "auto", color: "#223455", fontSize: 18, whiteSpace: "pre-wrap",
//           lineHeight: 1.7, position: "relative",
//         }}
//       >{coverLetter.value || "No cover letter available."}
//       </div>
//     </div>
//   );
// }

// function CandidateDetailsModal({ open, onClose, candidate, jobOnboarding, loading, applicationDate }) {
//   const [isDrawerOpen, setDrawerOpen] = useState(false);
//   // const [jobOnboarding, setJobOnboarding] = useState(null);
//   const [showResume, setShowResume] = useState(false);
//   const [showCoverLetter, setShowCoverLetter] = useState(false);
//   if (!open) return null;
//   const resumePdfUrl = candidate?.resume_file_id
//     ? `${API_BASE_URL}/api/resume_pdf/${candidate.resume_file_id}`
//     : null;

//   // Icons
//   const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
//   const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";
//   const locationIcon = "https://cdn-icons-png.flaticon.com/128/14027/14027590.png";
//   // Mapping of display names (edit or extend as needed)
//   const FIELD_LABEL_MAP = {
//     linkedin: "LinkedIn",
//     notice_period: "Notice Period",
//     current_salary: "Current Salary",
//     expected_salary: "Expected Salary",
//     work_mode: "Work Mode",
//     preferred_city: "Preferred City",
//     current_location: "Current Location",
//     interview_date: "Interview Date",
//     interview_time_slots: "Interview Time Slots",
//     legally_authorized: "Legally Authorized",
//     open_to_relocate: "Open to Relocate",
//     found_us: "Found Us by",
//     job_change_reason: "Reason for Job Change",
//     career_gap_reason: "Reason for Career Gap",

//     // add others or fallback to onboarding.label
//   };

//   // Array controls the order and set of shown fields
//   // const SHOWN_FIELDS = [
//   //   "linkedin",
//   //   "notice_period",
//   //   "current_salary",
//   //   "expected_salary",
//   //   "work_mode",
//   //   "preferred_city",
//   //   "current_location",
//   //   "interview_date",
//   //   "interview_time_slots",
//   //   "legally_authorized",
//   // ];

//   // Exclude these always (already handled above for core, but in case onboarding includes them)
//   const EXCLUDED_ONBOARDING_KEYS = ["has_cover_letter", "cover_letter"];
//   const EXCLUDED_EXTRA_KEYS = ["coverLetterName"];
//   const coverLetterObj = candidate ? parseCoverLetter(candidate.cover_letter || "") : { showButton: false, value: "" };
//   console.log("coverLetterObj in CandidateDetailsModal:", coverLetterObj);
//   console.log("jobOnboarding", jobOnboarding);
//   console.log("candidate", candidate);


//   return (
//     <div
//       style={{
//         position: "fixed",
//         left: 0,
//         top: 0,
//         width: "100vw",
//         height: "100vh",
//         background: "rgba(0, 0, 0, 0.15)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 2000,
//         overflowY: "auto",
//         padding: 20,
//       }}
//       onClick={onClose}
//       aria-modal="true"
//       role="dialog"
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           minWidth: 600,
//           maxWidth: 520,
//           background: "#fff",
//           borderRadius: 18,
//           boxShadow: "0 6px 32px #52a4f420",
//           padding: "30px 40px",
//           position: "relative",
//           maxHeight: "93vh",
//           top: -20,
//           bottom: 190,
//           overflowY: "auto",
//         }}
//       >
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             right: 18,
//             top: 6,
//             background: "none",
//             border: "none",
//             fontSize: 30,
//             color: "#236ef2",
//             cursor: "pointer",
//             fontWeight: 800,
//             lineHeight: 1,
//           }}
//           aria-label="Close Modal"
//         >
//           &times;
//         </button>

//         {loading ? (
//           <div style={{ fontSize: 17, textAlign: "center", padding: 40, color: "#236ef2" }}>
//             Loading details...
//           </div>
//         ) : candidate ? (
//           <>
//             {/* Profile Section */}
//             <div style={{ display: "flex", alignItems: "center", marginBottom: 22 }}>
//               <div
//                 style={{
//                   width: 66,
//                   height: 66,
//                   borderRadius: "50%",
//                   background: "radial-gradient(ellipse at 60% 40%, #eaf2ff 80%, #e4ecfc 100%)",
//                   color: "#2457ac", // rich blue for letter (matches your image)
//                   fontWeight: 700,
//                   fontSize: 35,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   boxShadow: "0 4px 20px #eaf2ff, 0 0 0 6px #fff inset",
//                   border: "4px solid #fff",
//                   marginRight: 18,
//                 }}
//               >
//                 {(candidate.name || "?").slice(0, 1).toUpperCase()}
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontWeight: 800,
//                     fontSize: 23,
//                     color: "#182a43",
//                     marginBottom: 7,
//                   }}
//                 >
//                   {candidate.name || "idk"}
//                 </div>
//                 {candidate.email && (
//                   <div style={{ display: "flex", alignItems: "center", color: "#53709c", fontSize: 15, marginBottom: 2 }}>
//                     <img src={emailIcon} alt="Email" style={{ width: 17, height: 17, marginRight: 6 }} />
//                     {candidate.email}
//                   </div>
//                 )}
//                 {candidate.phone && (
//                   <div style={{ display: "flex", alignItems: "center", color: "#53709c", fontSize: 15, marginBottom: 2 }}>
//                     <img src={phoneIcon} alt="Phone" style={{ width: 15, height: 15, marginRight: 7 }} />
//                     {candidate.phone}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Additional Details Tile */}
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 background: "#f7fbfd",
//                 borderRadius: 12,
//                 marginTop: 6,
//                 padding: "19px 26px 16px 21px",
//               }}
//             >
//               <div style={{
//                 fontWeight: 700,
//                 fontSize: 16,
//                 marginBottom: 2,
//                 color: "#2465ae",
//                 letterSpacing: "0.02em"
//               }}>
//                 Additional Details:
//               </div>
//               <div style={{ fontSize: 15, color: "#2d3b51", marginTop: 10, lineHeight: 2 }}>
//                 {/* <div>
//   <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//   <b>Cover Letter:</b> {
//     candidate.cover_letter?.type === "text"
//       ? candidate.cover_letter.value || "N/A"
//       : candidate.cover_letter?.type === "file"
//         ? "Uploaded File"
//         : "N/A"
//   }
// </div> */}

//                 {jobOnboarding && (
//                   <div style={{ marginTop: 24 }}>
//                     {Object.entries(jobOnboarding).map(([key, config]) => {
//                       if (EXCLUDED_ONBOARDING_KEYS.includes(key)) return null;
//                       if (
//                         key === "preferred_city" &&
//                         (
//                           (candidate.work_mode && candidate.work_mode.toLowerCase() === "remote") ||
//                           (candidate["work_mode"] && candidate["work_mode"].toLowerCase() === "remote")
//                         )
//                       ) return null;
//                       let v = candidate[key];
//                       if ((v === undefined || v === "") && candidate.extra_onboarding_fields) {
//                         v = candidate.extra_onboarding_fields[key];
//                       }
//                       if (v === undefined || v === "") v = "N/A";
//                       if (typeof v === "object" && v !== null) {
//                         if ("value" in v) v = v.value;
//                         else v = JSON.stringify(v);
//                       }
//                       // Legal label logic as before
//                       let label = FIELD_LABEL_MAP[key] || config.label || key;
//                       if (key === "legally_authorized" && config.label) {
//                         const suffix = config.label.split("legally authorized")[1]?.trim();
//                         if (suffix) label = `Legally Authorized (${suffix.replace(/[?]/g, '')}):`;
//                       }
//                       if (key === "linkedin" && v && v !== "N/A") {
//                         return (
//                           <div key={key} style={{ marginBottom: 14 }}>
//                             <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//                             <b>
//                               {label.replace(/[?:\s]+$/, "")}:
//                             </b>{" "}
//                             <a
//                               href={v}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               style={{
//                                 color: "#2465ae",
//                                 textDecoration: "underline",
//                               }}
//                             >
//                               Profile Link
//                             </a>
//                           </div>
//                         );
//                       }
//                       return (
//                         <div key={key} style={{ marginBottom: 14 }}>
//                           <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//                           <b>
//                             <span>{label.replace(/[?:\s]+$/, "")}:</span>
//                           </b> {v}
//                         </div>
//                       );
//                     })}

//                     {/* Show extra/dynamic fields not in SHOWN_FIELDS */}
//                     <div style={{ marginTop: 12 }}>
//                       {candidate.extra_onboarding_fields &&
//                         Object.entries(candidate.extra_onboarding_fields)
//                           // Exclude any extra field whose key is in jobOnboarding (already shown above)
//                           .filter(([key]) => !jobOnboarding.hasOwnProperty(key) && !EXCLUDED_EXTRA_KEYS.includes(key))
//                           .map(([key, value]) => (
//                             <div key={key} style={{ marginBottom: 14 }}>
//                               <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//                               <b>{jobOnboarding[key]?.label || key.replace(/[?:\s]+$/, "")}:</b> {value || "N/A"}
//                             </div>
//                           ))}
//                     </div>
//                     <div style={{ marginTop: 18, marginBottom: 3 }}>
//                       <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
//                       <b>Application Date:</b>{" "}
//                       {applicationDate && applicationDate !== "N/A"
//                         ? convertUtcToIst(applicationDate)
//                         : <em>Fetching...</em>
//                       }
//                     </div>
//                   </div>
//                 )}


//               </div>
//             </div>

//             {/* View Resume Button */}
//             {resumePdfUrl && (
//               <div style={{ marginTop: 20 }}>
//                 <button
//                   onClick={() => setShowResume(true)}
//                   style={{
//                     backgroundColor: "#236ef2",
//                     color: "#fff",
//                     border: "none", borderRadius: 6, padding: "12px 20px",
//                     fontWeight: "bold", cursor: "pointer", width: "100%", fontSize: 16,
//                   }}
//                 >
//                   View Resume
//                 </button>
//               </div>
//             )}
//             {/* View Cover Letter button */}
//             {/* console.log("coverLetterObj in CandidateDetailsModal:", coverLetterObj); */}

//             {(coverLetterObj.showButton || coverLetterObj.value) && (
//               <div style={{ marginTop: 20 }}>
//                 <button
//                   onClick={() => setShowCoverLetter(true)}
//                   style={{
//                     backgroundColor: "#236ef2",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 6,
//                     padding: "12px 20px",
//                     fontWeight: "bold",
//                     cursor: "pointer",
//                     width: "100%",
//                     fontSize: 16,
//                   }}
//                 >
//                   View Cover Letter
//                 </button>
//               </div>
//             )}
//             <ResumePreviewModal
//               open={showResume}
//               onClose={() => setShowResume(false)}
//               pdfUrl={resumePdfUrl}
//             />
//             {/* Cover Letter Preview Modal */}
//             <CoverLetterPreviewModal
//               open={showCoverLetter}
//               onClose={() => setShowCoverLetter(false)}
//               coverLetter={coverLetterObj}
//             />
//           </>
//         ) : (
//           <div style={{ fontSize: 16, textAlign: "center", padding: 20, color: "red" }}>
//             Failed to load candidate details.
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function L2QuestionsDialog({ onClose, loading, questions, error }) {
//   console.log("L2QuestionsDialog questions prop:", questions);
//   const shimmerBase = {
//     background: "linear-gradient(90deg, #eef3ff 0%, #f7f9ff 40%, #eef3ff 80%)",
//     backgroundSize: "200% 100%",
//     animation: "shimmer 1.5s infinite",
//     borderRadius: 10
//   };

//   return (
//     <>
//       {/* keyframes for shimmer */}
//       <style>
//         {`
//         @keyframes shimmer {
//           0% { background-position: -200% 0; }
//           100% { background-position: 200% 0; }
//         }
//       `}
//       </style>

//       <div
//         style={{
//           position: "fixed",
//           inset: 0,
//           background: "rgba(0,0,0,0.25)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           zIndex: 2500
//         }}
//         onClick={onClose}
//       >
//         <div
//           onClick={e => e.stopPropagation()}
//           style={{
//             width: 720,
//             maxHeight: "80vh",
//             background: "#fff",
//             borderRadius: 16,
//             boxShadow: "0 10px 40px #13254f33",
//             padding: "24px 26px 26px 26px",
//             position: "relative",
//             overflowY: "auto"
//           }}
//         >
//           <button
//             onClick={onClose}
//             style={{
//               position: "absolute",
//               top: 10,
//               right: 14,
//               border: "none",
//               background: "transparent",
//               fontSize: 26,
//               color: "#2457ac",
//               cursor: "pointer",
//               fontWeight: 700
//             }}
//           >
//             &times;
//           </button>

//           <div style={{ fontSize: 22, fontWeight: 800, color: "#182a43", marginBottom: 8 }}>
//             L2 Interview Question Suggestions
//           </div>
//           <div style={{ fontSize: 13, color: "#667699", marginBottom: 20 }}>
//             Generated Based on Resume and Job Description
//           </div>

//           {loading && (
//             <div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 12 }}>
//               {[1, 2, 3, 4].map(i => (
//                 <div
//                   key={i}
//                   style={{
//                     ...shimmerBase,
//                     height: 60,
//                     padding: "14px 16px",
//                     boxShadow: "0 1px 6px rgba(138, 143, 157, 0.9)"
//                   }}
//                 />
//               ))}
//             </div>
//           )}

//           {!loading && error && (
//             <div
//               style={{
//                 marginTop: 12,
//                 padding: 14,
//                 borderRadius: 10,
//                 background: "#ffefef",
//                 color: "#b02a37",
//                 fontSize: 14,
//                 fontWeight: 500
//               }}
//             >
//               {error}
//             </div>
//           )}

//           {!loading && !error && Array.isArray(questions) && questions.length > 0 && (
//             <div style={{ marginTop: 6, display: "flex", flexDirection: "column", gap: 14 }}>
//               {questions.map((q, idx) => (
//                 <div
//                   key={idx}
//                   style={{
//                     borderRadius: 12,
//                     border: "1px solid #e0e7fb",
//                     padding: "14px 16px",
//                     background: "#f7f9ff",
//                     boxShadow: "0 2px 10px #e1e9ff90",
//                     display: "flex",
//                     gap: 12
//                   }}
//                 >
//                   <div
//                     style={{
//                       minWidth: 26,
//                       height: 26,
//                       borderRadius: "50%",
//                       background: "#2457ac",
//                       color: "#fff",
//                       fontSize: 14,
//                       fontWeight: 700,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginTop: 4
//                     }}
//                   >
//                     {idx + 1}
//                   </div>
//                   <div style={{ fontSize: 15, color: "#182a43", fontWeight: 500, lineHeight: 1.4 }}>
//                     {q}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {!loading && !error && (!questions || questions.length === 0) && (
//             <div style={{ marginTop: 16, fontSize: 14, color: "#6b7280" }}>
//               No questions generated yet.
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }


// function CandidateScoreModal({
//   open,
//   onClose,
//   scores,
//   screeningQA,
//   loading,
//   error,
//   approvedCandidates,
//   rejectedCandidates,
//   setApprovedCandidates,
//   setRejectedCandidates,
//   handleOpenL2
// }) {
//   const [isVerified, setIsVerified] = useState(false);
//   const [decisionMade, setDecisionMade] = useState(false);
//   const reportRef = useRef(null);
//   const summaryRef = useRef(null);

//   const generatePDF = async () => {
//     if (!summaryRef.current) return null;

//     const pdf = new jsPDF("p", "mm", "a4");
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();
//     const margin = 15; // 15mm margin
//     const contentWidth = pdfWidth - (2 * margin);

//     let currentY = margin;

//     // Get all blocks
//     const blocks = summaryRef.current.querySelectorAll('[data-pdf-block="true"]');

//     for (let i = 0; i < blocks.length; i++) {
//       const block = blocks[i];
//       const canvas = await html2canvas(block, {
//         scale: 2,
//         useCORS: true,
//         logging: false,
//         backgroundColor: "#ffffff",
//       });

//       const imgData = canvas.toDataURL("image/png");
//       const imgProps = pdf.getImageProperties(imgData);
//       const blockWidthInPdf = contentWidth;
//       const blockHeightInPdf = (imgProps.height * blockWidthInPdf) / imgProps.width;

//       // Check if block fits on current page
//       if (currentY + blockHeightInPdf > pdfHeight - margin) {
//         pdf.addPage();
//         currentY = margin;
//       }

//       pdf.addImage(imgData, "PNG", margin, currentY, blockWidthInPdf, blockHeightInPdf);
//       currentY += blockHeightInPdf + 5; // Reduced 5mm spacing between blocks
//     }

//     return pdf;
//   };

//   const handleExportPDF = async () => {
//     try {
//       const pdf = await generatePDF();
//       if (pdf) {
//         pdf.save(`${scores?.candidate_name || "Candidate"}_Summary.pdf`);
//       }
//     } catch (err) {
//       console.error("PDF generation failed:", err);
//       alert("Failed to generate PDF summary.");
//     }
//   };

//   const handleShare = async () => {
//     try {
//       const pdf = await generatePDF();
//       if (!pdf) return;

//       const pdfBlob = pdf.output('blob');
//       const fileName = `${scores?.candidate_name || "Candidate"}_Summary.pdf`;
//       const file = new File([pdfBlob], fileName, { type: 'application/pdf' });

//       if (navigator.canShare && navigator.canShare({ files: [file] })) {
//         await navigator.share({
//           files: [file],
//           title: 'Candidate Evaluation Summary',
//           text: `Summary for ${scores?.candidate_name || "Candidate"}`,
//         });
//       } else {
//         // Fallback for browsers that don't support file sharing
//         const shareText = `Candidate Evaluation Summary for ${scores?.candidate_name || "a candidate"}\nScore: ${scores?.llm_score}/100\nStatus: ${scores?.status}`;
//         if (navigator.share) {
//           await navigator.share({
//             title: "Candidate Summary",
//             text: shareText,
//             url: window.location.href,
//           });
//         } else {
//           await navigator.clipboard.writeText(shareText);
//           alert("Summary copied to clipboard (File sharing not supported)!");
//         }
//       }
//     } catch (err) {
//       console.error("Sharing failed:", err);
//     }
//   };

//   const handleApprove = async () => {
//     await fetch(`${API_BASE_URL}/api/update_l1_status`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         candidate_id: scores.candidate_id,
//         job_id: scores.job_id,
//         status: 'approved'
//       })
//     });
//     setDecisionMade(true);
//     onClose();
//   };

//   const handleReject = async () => {
//     await fetch(`${API_BASE_URL}/api/update_l1_status`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         candidate_id: scores.candidate_id,
//         job_id: scores.job_id,
//         status: 'rejected'
//       })
//     });
//     setDecisionMade(true);
//     onClose();
//   };

//   if (!open) return null;

//   const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
//   const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";

//   const loadingOrNoScore = loading || scores?.llm_score == null;

//   if (loadingOrNoScore)
//     return (
//       <div style={{ padding: 300, display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <ClipLoader color="#2d3b51" size={200} />
//         <div style={{ marginTop: 10 }}>Loading score...</div>
//       </div>
//     );

//   const profileCircleStyle = {
//     width: 66,
//     height: 66,
//     borderRadius: "50%",
//     background: "radial-gradient(ellipse at 60% 40%, #eaf2ff 80%, #e4ecfc 100%)",
//     color: "#2457ac",
//     fontWeight: 800,
//     fontSize: 38,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 4px 20px #eaf2ff, inset 0 0 0 6px #fff",
//     border: "4px solid #fff",
//     marginRight: 18,
//   };

//   const initialScreeningPassed = (scores?.compatibility ?? 0) >= 40;

//   // Use nested report structure for screening questions and L1 score
//   const overallL1Score = screeningQA?.interview_report?.overall_l1_score ?? "N/A";
//   const questionScores =
//     Array.isArray(screeningQA?.interview_report?.question_scores)
//       ? screeningQA.interview_report.question_scores
//       : [];

//   return (
//     <div
//       style={{
//         position: "fixed",
//         left: 0,
//         top: 0,
//         width: "100vw",
//         height: "100vh",
//         background: "rgba(36, 84, 217, 0.15)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 2100,
//         overflowY: "auto",
//         padding: 20,
//       }}
//       onClick={onClose}
//       aria-modal="true"
//       role="dialog"
//     >
//       <div
//         ref={reportRef}
//         data-report-container="true"
//         onClick={e => e.stopPropagation()}
//         style={{
//           minWidth: 900,
//           maxWidth: 1000,
//           background: "#fff",
//           borderRadius: 14,
//           boxShadow: "0 6px 28px #52a4f420",
//           padding: "32px 40px",
//           position: "relative",
//           maxHeight: "90vh",
//           overflowY: "auto",
//           display: "grid",
//           gridTemplateAreas: `
//             "left right"
//             "bottom bottom"
//           `,
//           gridTemplateColumns: "1fr 1fr",
//           gridTemplateRows: "auto auto",
//           gridGap: 32,
//         }}
//       >
//         <button
//           data-html2canvas-ignore="true"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             right: 18,
//             top: 6,
//             background: "none",
//             border: "none",
//             fontSize: 30,
//             color: "#236ef2",
//             cursor: "pointer",
//             fontWeight: 800,
//             lineHeight: 1,
//           }}
//           aria-label="Close Modal"
//         >
//           &times;
//         </button>

//         {/* Action Toolbar: Summary PDF, Share, Export */}
//         <div
//           data-html2canvas-ignore="true"
//           style={{
//             position: "absolute",
//             right: 60,
//             top: 15,
//             display: "flex",
//             gap: 12,
//             zIndex: 10
//           }}>
//           <button
//             onClick={handleExportPDF}
//             style={{
//               padding: "6px 14px",
//               background: "#ffffff",
//               border: "1.5px solid #236ef2",
//               borderRadius: "8px",
//               color: "#236ef2",
//               fontSize: "13px",
//               fontWeight: 700,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//               boxShadow: "0 2px 4px rgba(35, 110, 242, 0.1)",
//               transition: "all 0.2s"
//             }}
//             onMouseOver={(e) => e.target.style.background = "#eff6ff"}
//             onMouseOut={(e) => e.target.style.background = "#ffffff"}
//           >
//             <span>📄</span> Final Summary PDF
//           </button>
//           <button
//             onClick={handleShare}
//             style={{
//               padding: "6px 14px",
//               background: "#ffffff",
//               border: "1.5px solid #236ef2",
//               borderRadius: "8px",
//               color: "#236ef2",
//               fontSize: "13px",
//               fontWeight: 700,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//               boxShadow: "0 2px 4px rgba(35, 110, 242, 0.1)",
//               transition: "all 0.2s"
//             }}
//             onMouseOver={(e) => e.target.style.background = "#eff6ff"}
//             onMouseOut={(e) => e.target.style.background = "#ffffff"}
//           >
//             <span>🔗</span> Share
//           </button>
//           <button
//             onClick={handleExportPDF}
//             style={{
//               padding: "6px 14px",
//               background: "#ffffff",
//               border: "1.5px solid #236ef2",
//               borderRadius: "8px",
//               color: "#236ef2",
//               fontSize: "13px",
//               fontWeight: 700,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//               boxShadow: "0 2px 4px rgba(35, 110, 242, 0.1)",
//               transition: "all 0.2s"
//             }}
//             onMouseOver={(e) => e.target.style.background = "#eff6ff"}
//             onMouseOut={(e) => e.target.style.background = "#ffffff"}
//           >
//             <span>📥</span> Export
//           </button>
//         </div>

//         {/* Left Column: Profile + Status + Score */}
//         <div style={{ gridArea: "left", display: "flex", flexDirection: "column", gap: 20 }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
//             <div style={profileCircleStyle}>{(scores?.candidate_name || "?")[0].toUpperCase()}</div>
//             <div>
//               <div style={{ fontWeight: 800, fontSize: 28, color: "#182a43" }}>
//                 {scores?.candidate_name || "N/A"}
//               </div>
//               <div style={{ color: "#53709c", marginTop: 5 }}>
//                 <img src={emailIcon} alt="Email" style={{ width: 17, height: 17, marginRight: 6 }} />
//                 {scores?.candidate_email || "N/A"}
//               </div>
//               <div style={{ color: "#53709c", marginTop: 6 }}>
//                 <img src={phoneIcon} alt="Phone" style={{ width: 15, height: 15, marginRight: 7 }} />
//                 {scores?.candidate_phone || "N/A"}
//               </div>
//             </div>
//           </div>


//           {/* Screening Pass/Fail */}
//           <div
//             style={{
//               border: "1.6px solid #e7eefa",
//               borderRadius: 12,
//               padding: 18,
//               fontWeight: 700,
//               fontSize: 20,
//               color: initialScreeningPassed ? "#198754" : "#d9534f",
//             }}
//           >
//             Initial Screening Status: {initialScreeningPassed ? "Pass" : "Fail"} ({scores?.compatibility ?? "N/A"})
//           </div>
//           {Array.isArray(scores.l0_reasons) && scores.l0_reasons.length > 0 && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 10,
//                 fontWeight: 700,
//                 fontSize: 19,
//                 color: "#2d3b51",
//                 background: "#ffffffff",
//               }}
//             >
//               <div style={{ fontWeight: 700, marginBottom: 10 }}>L0 Reasons:</div>
//               <ul
//                 style={{
//                   marginTop: 6,
//                   paddingLeft: 21,
//                   color: "#444",
//                   fontWeight: 500,
//                   fontSize: 16,
//                 }}
//               >
//                 {scores.l0_reasons.map((reason, idx) => (
//                   <li key={idx} style={{ marginBottom: 3, whiteSpace: "pre-wrap" }}>
//                     {reason}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//         <br></br>
//         <br></br>
//         <br></br>

//         {/* Right Column: Separate tiles for L0 Reasons and Score Breakdown */}
//         <div
//           style={{
//             gridArea: "right",
//             marginTop: 60,
//             display: "flex",
//             flexDirection: "column",
//             gap: 30, // space between tiles
//           }}
//         >
//           <br></br>
//           {scores?.llm_score !== undefined && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 fontWeight: 700,
//                 fontSize: 20,
//                 color: "#2d3b51",
//               }}
//             >
//               Resume Score: <span style={{ color: "#238a51" }}>{scores.llm_score} / 100</span>
//             </div>
//           )}

//           {scores?.score_breakdown?.length > 0 && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 marginTop: -10,
//                 fontWeight: 600,
//                 fontSize: 20,
//                 color: "#2d3b51",
//                 background: "#ffffff",
//               }}
//             >
//               <div style={{ fontWeight: 700, marginBottom: 12 }}>Score Breakdown (Section wise):</div>
//               <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//                 {scores.score_breakdown.map((item, idx) => (
//                   <li key={idx}>
//                     {item.category.charAt(0).toUpperCase() + item.category.slice(1)}: {item.score}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           {/* L2 Question Icon Button: placed below Score Breakdown, above Reasons */}
//           {initialScreeningPassed && (
//             <div
//               style={{
//                 marginTop: 24,  // space from Score Breakdown
//                 marginBottom: 16, // space before Reasons below
//                 display: "flex",
//                 justifyContent: "flex-start",
//               }}
//             >
//               <button
//                 onClick={handleOpenL2}
//                 style={{
//                   border: "none",
//                   background: "transparent",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                   padding: 0,
//                 }}
//                 title="Generate L2 interview questions"
//               >
//                 <div
//                   style={{
//                     width: 34,
//                     height: 34,
//                     borderRadius: "50%",
//                     background: "#e9f2ff",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     boxShadow: "0 2px 8px #2b6fe010",
//                   }}
//                 >
//                   <span style={{ fontWeight: 800, color: "#2457ac", fontSize: 20 }}>L2</span>
//                 </div>
//                 <span style={{ fontSize: 14, color: "#2457ac", fontWeight: 600 }}>
//                   Generate L2 Interview Questions
//                 </span>
//               </button>
//             </div>
//           )}
//         </div>


//         {/* Full-width Bottom: Reasons + L1 Q&A */}
//         <div style={{ gridArea: "bottom", width: "100%" }}>
//           {scores?.reasons?.length > 0 && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 fontWeight: 600,
//                 fontSize: 20,
//                 color: "#2d3b51",
//                 marginBottom: 32,
//               }}
//             >
//               <div style={{ fontWeight: 700, marginBottom: 12 }}>Reasons:</div>
//               <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//                 {scores.reasons.map((reason, idx) => (
//                   <li key={idx}>{reason}</li>
//                 ))}
//               </ul>
//             </div>
//           )}
//           {overallL1Score >= 0 && (
//             <>
//               {/* Overall L1 Score Tile */}
//               <div
//                 style={{
//                   border: "1.6px solid #e7eefa",
//                   borderRadius: 12,
//                   padding: 18,
//                   fontWeight: 700,
//                   fontSize: 20,
//                   color: "#2d3b51",
//                 }}
//               >
//                 Overall L1 Score: <span style={{ color: "#238a51" }}>{overallL1Score}</span>
//               </div>
//               <br></br>
//               {questionScores.length > 0 && (
//                 <div
//                   style={{
//                     border: "1.6px solid #e7eefa",
//                     borderRadius: 12,
//                     padding: 18,
//                     fontWeight: 600,
//                     fontSize: 20,
//                     color: "#2d3b51",
//                     marginBottom: 32,
//                   }}>
//                   <div style={{ fontWeight: 700, marginBottom: 12 }}>L1 Questions and Responses:</div>
//                   <div style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: 34,
//                     marginTop: 20,
//                   }}>
//                     {questionScores.map((qscore, idx) => (
//                       <div key={idx} style={{
//                         background: "#fff",
//                         borderRadius: 16,
//                         border: "1.6px solid #e2eefa",
//                         boxShadow: "0 2px 10px #22519708",
//                         padding: "26px 28px 22px 28px",
//                         display: "flex",
//                         flexDirection: "column",
//                         gap: 9,
//                         position: "relative"
//                       }}>
//                         {/* Score badge */}
//                         <div style={{
//                           position: "absolute",
//                           top: 15,
//                           right: 28,
//                           fontWeight: 700,
//                           padding: "6px 20px",
//                           borderRadius: 14,
//                           fontSize: 15,
//                           background: qscore.score > 0 ? "#cdfee0" : "#ffeaea",
//                           color: qscore.score > 0 ? "#228b22" : "#d9534f",
//                           boxShadow: "0 0 6px #e1eefa50"
//                         }}>
//                           Score: {qscore.score}
//                         </div>
//                         {/* Question label + tile */}
//                         <div style={{
//                           fontWeight: 700,
//                           color: "#213a7d",
//                           fontSize: 25,
//                           marginBottom: 7
//                         }}>
//                           Question
//                         </div>
//                         <div style={{
//                           background: "#e6eeff",
//                           borderRadius: 10,
//                           padding: "14px 18px",
//                           color: "#213a7d",
//                           fontWeight: 600,
//                           fontSize: 21,
//                           wordBreak: "break-word",
//                           minHeight: 40,
//                           marginBottom: 19
//                         }}>
//                           {qscore.question}
//                         </div>
//                         {/* Answer label + tile */}
//                         <div style={{
//                           fontWeight: 700,
//                           color: "#237804",
//                           fontSize: 22,
//                           marginBottom: 7
//                         }}>
//                           Answer summary
//                         </div>
//                         <div style={{
//                           background: "#e5fbe7",
//                           borderRadius: 10,
//                           padding: "13px 18px",
//                           color: "#136a24",
//                           fontWeight: 500,
//                           fontSize: 21,
//                           wordBreak: "break-word",
//                           minHeight: 36
//                         }}>
//                           {qscore.answer_summary || <span style={{ color: "#989" }}>No summary provided</span>}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </>
//           )}



//           {/* Verified Checkbox and Approve/Reject Buttons if Passed */}
//           {initialScreeningPassed && scores.status === "pending" && !decisionMade && (
//             <div style={{ marginBottom: 32, textAlign: "center" }}>
//               <label style={{ fontWeight: 600, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <input
//                   type="checkbox"
//                   checked={isVerified}
//                   onChange={e => setIsVerified(e.target.checked)}
//                   style={{ marginRight: 10, width: 18, height: 14 }}
//                 />
//                 <span style={{ color: "#236ef2", marginTop: -5, display: "inline-block" }}>
//                   Verified all details and ready for decision
//                 </span>
//               </label>
//             </div>
//           )}

//           {initialScreeningPassed && (
//             <div style={{ display: "flex", gap: 22, justifyContent: "center", marginBottom: 8 }}>
//               {scores.status === "pending" && !decisionMade ? (
//                 <>
//                   <button
//                     style={{
//                       background: "#32d157",
//                       color: "#fff",
//                       fontWeight: 600,
//                       fontSize: 16,
//                       border: "none",
//                       borderRadius: 8,
//                       padding: "16px 22px",
//                       cursor: isVerified ? "pointer" : "not-allowed",
//                       opacity: isVerified ? 1 : 0.6
//                     }}
//                     disabled={!isVerified}
//                     onClick={handleApprove}
//                   >
//                     Approve
//                   </button>
//                   <button
//                     style={{
//                       background: "#e34848",
//                       color: "#fff",
//                       fontWeight: 600,
//                       fontSize: 16,
//                       border: "none",
//                       borderRadius: 8,
//                       padding: "16px 22px",
//                       cursor: isVerified ? "pointer" : "not-allowed",
//                       opacity: isVerified ? 1 : 0.6
//                     }}
//                     disabled={!isVerified}
//                     onClick={handleReject}
//                   >
//                     Reject
//                   </button>
//                 </>
//               ) : scores.status === "approved" || (decisionMade && scores.status === "approved") ? (
//                 <span
//                   style={{
//                     background: "#eaf9ed",
//                     color: "#238a51",
//                     fontWeight: 600,
//                     fontSize: 20,
//                     width: 110,
//                     marginTop: 20,
//                     borderRadius: 8,
//                     padding: "15px 32px",
//                     marginLeft: 75,
//                     display: "inline-block"
//                   }}
//                 >
//                   Approved
//                 </span>
//               ) : (
//                 <span
//                   style={{
//                     background: "#ffebeb",
//                     color: "#d9534f",
//                     fontWeight: 600,
//                     fontSize: 20,
//                     width: 110,
//                     marginTop: 20,
//                     borderRadius: 8,
//                     padding: "10px 36px",
//                     marginLeft: 75,
//                     display: "inline-block"
//                   }}
//                 >
//                   Rejected
//                 </span>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Professional Summary Report (Hidden from UI, used for PDF) */}
//       <div
//         ref={summaryRef}
//         style={{
//           position: "absolute",
//           top: -9999,
//           left: -9999,
//           width: "800px",
//           padding: "40px",
//           background: "#ffffff",
//           color: "#2d3b51",
//           fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
//           zIndex: -1,
//         }}
//       >
//         <div data-pdf-block="true" style={{ textAlign: "center", borderBottom: "2px solid #236ef2", paddingBottom: "20px", marginBottom: "30px" }}>
//           <h1 style={{ margin: 0, color: "#236ef2", fontSize: "28px" }}>Candidate Evaluation Report</h1>
//           <p style={{ marginTop: "5px", color: "#53709c" }}>Generated on {new Date().toLocaleDateString()}</p>
//         </div>

//         {/* Candidate Info Section */}
//         <div data-pdf-block="true" style={{ display: "flex", justifyContent: "space-between", marginBottom: "30px", background: "#f8faff", padding: "20px", borderRadius: "8px" }}>
//           <div>
//             <h2 style={{ margin: "0 0 10px 0", fontSize: "22px" }}>{scores?.candidate_name || "N/A"}</h2>
//             <div style={{ color: "#53709c", marginBottom: "5px" }}>Email: {scores?.candidate_email || "N/A"}</div>
//             <div style={{ color: "#53709c" }}>Phone: {scores?.candidate_phone || "N/A"}</div>
//           </div>
//           <div style={{ textAlign: "right" }}>
//             <div style={{ fontSize: "18px", fontWeight: "bold", color: initialScreeningPassed ? "#198754" : "#d9534f" }}>
//               Status: {initialScreeningPassed ? "Passed Screening" : "Failed Screening"}
//             </div>
//             <div style={{ fontSize: "24px", fontWeight: "bold", marginTop: "10px", color: "#236ef2" }}>
//               Overall Score: {scores?.llm_score || 0}/100
//             </div>
//           </div>
//         </div>

//         {/* Score Breakdown Section */}
//         {scores?.score_breakdown?.length > 0 && (
//           <div data-pdf-block="true" style={{ marginBottom: "30px" }}>
//             <h3 style={{ borderBottom: "1px solid #e1eefa", paddingBottom: "8px", color: "#182a43" }}>Score Breakdown</h3>
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "15px", marginTop: "15px" }}>
//               {scores.score_breakdown.map((item, idx) => (
//                 <div key={idx} style={{ padding: "10px", border: "1px solid #e1eefa", borderRadius: "6px" }}>
//                   <span style={{ fontWeight: "600" }}>{item.category.charAt(0).toUpperCase() + item.category.slice(1)}:</span>
//                   <span style={{ float: "right", color: "#238a51", fontWeight: "bold" }}>{item.score}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* L0 Analysis Section */}
//         {Array.isArray(scores.l0_reasons) && scores.l0_reasons.length > 0 && (
//           <div style={{ marginBottom: "20px" }}>
//             <h3 data-pdf-block="true" style={{ borderBottom: "1px solid #e1eefa", paddingBottom: "5px", marginBottom: "10px", color: "#182a43" }}>Initial Screening (L0) Reasons</h3>
//             <ul style={{ marginTop: "5px", paddingLeft: "20px", lineHeight: "1.5" }}>
//               {scores.l0_reasons.map((reason, idx) => (
//                 <li key={idx} data-pdf-block="true" style={{ marginBottom: "5px" }}>{reason}</li>
//               ))}
//             </ul>
//           </div>
//         )}

//         {/* L1 Evaluation Section */}
//         {scores?.reasons?.length > 0 && (
//           <div style={{ marginBottom: "20px" }}>
//             <h3 data-pdf-block="true" style={{ borderBottom: "1px solid #e1eefa", paddingBottom: "5px", marginBottom: "10px", color: "#182a43" }}>Detailed Evaluation (L1) Reasons</h3>
//             <ul style={{ marginTop: "5px", paddingLeft: "20px", lineHeight: "1.5" }}>
//               {scores.reasons.map((reason, idx) => (
//                 <li key={idx} data-pdf-block="true" style={{ marginBottom: "5px" }}>{reason}</li>
//               ))}
//             </ul>
//           </div>
//         )}

//         {/* L1 Q&A Section */}
//         {overallL1Score >= 0 && questionScores.length > 0 && (
//           <div style={{ marginBottom: "20px" }}>
//             <h3 data-pdf-block="true" style={{ borderBottom: "1px solid #e1eefa", paddingBottom: "5px", marginBottom: "15px", color: "#182a43" }}>L1 Interview Q&A Summary</h3>
//             <div style={{ marginTop: "10px" }}>
//               {questionScores.map((qscore, idx) => (
//                 <div key={idx} data-pdf-block="true" style={{ marginBottom: "15px", border: "1px solid #e1eefa", borderRadius: "8px", overflow: "hidden" }}>
//                   <div style={{ background: "#f0f4ff", padding: "8px 15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <span style={{ fontWeight: "bold", color: "#213a7d", fontSize: "14px" }}>Question {idx + 1}</span>
//                     <span style={{ background: qscore.score > 0 ? "#cdfee0" : "#ffeaea", color: qscore.score > 0 ? "#228b22" : "#d9534f", padding: "2px 10px", borderRadius: "10px", fontSize: "12px", fontWeight: "bold" }}>
//                       Score: {qscore.score}
//                     </span>
//                   </div>
//                   <div style={{ padding: "12px 15px" }}>
//                     <div style={{ fontWeight: "600", color: "#213a7d", marginBottom: "5px", fontSize: "15px" }}>{qscore.question}</div>
//                     <div style={{ background: "#f6fff7", border: "1px solid #e0f2e1", padding: "8px", borderRadius: "4px", color: "#136a24", fontSize: "14px" }}>
//                       <strong>Response Summary:</strong> {qscore.answer_summary || "No summary provided"}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div data-pdf-block="true" style={{ textAlign: "center", color: "#95a5a6", fontSize: "12px", marginTop: "40px", borderTop: "1px solid #eee", paddingTop: "20px" }}>
//           &copy; {new Date().getFullYear()} Fanisko Candidate Evaluation System. All rights reserved.
//         </div>
//       </div>
//     </div>
//   );
// }

// function ManualCandidateScoreModal({
//   open,
//   onClose,
//   candidate, // expects { full_name, email, phone, llm_score, score_breakdown, reasons }
//   loading,
//   error
// }) {
//   if (!open) return null;

//   const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
//   const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";

//   if (loading)
//     return (
//       <div style={{ padding: 200, display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <ClipLoader color="#2d3b51" size={120} />
//         <div style={{ marginTop: 10 }}>Loading candidate info...</div>
//       </div>
//     );

//   // Defensive defaults
//   const name = candidate?.full_name || "N/A";
//   const email = candidate?.email || "N/A";
//   const phone = candidate?.phone || "N/A";
//   const score = candidate?.llm_score !== undefined ? candidate.llm_score : "N/A";
//   const breakdown = Array.isArray(candidate?.score_breakdown) ? candidate.score_breakdown : [];
//   const l1Reasons = Array.isArray(candidate?.reasons) ? candidate.reasons : [];

//   const profileCircleStyle = {
//     width: 66,
//     height: 66,
//     borderRadius: "50%",
//     background: "radial-gradient(ellipse at 60% 40%, #eaf2ff 80%, #e4ecfc 100%)",
//     color: "#2457ac",
//     fontWeight: 800,
//     fontSize: 38,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 4px 20px #eaf2ff, inset 0 0 0 6px #fff",
//     border: "4px solid #fff",
//     marginRight: 18,
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         left: 0,
//         top: 0,
//         width: "100vw",
//         height: "100vh",
//         background: "rgba(36, 84, 217, 0.15)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 2100,
//         overflowY: "auto",
//         padding: 20,
//       }}
//       onClick={onClose}
//       aria-modal="true"
//       role="dialog"
//     >
//       <div
//         onClick={e => e.stopPropagation()}
//         style={{
//           minWidth: 700,
//           maxWidth: 850,
//           background: "#fff",
//           borderRadius: 14,
//           boxShadow: "0 6px 28px #52a4f420",
//           padding: "32px 40px",
//           position: "relative",
//           maxHeight: "90vh",
//           overflowY: "auto",
//           display: "grid",
//           gridTemplateAreas: `
//             "left right"
//             "bottom bottom"
//           `,
//           gridTemplateColumns: "1fr 1fr",
//           gridTemplateRows: "auto auto",
//           gridGap: 32,
//         }}
//       >
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             right: 18,
//             top: 6,
//             background: "none",
//             border: "none",
//             fontSize: 30,
//             color: "#236ef2",
//             cursor: "pointer",
//             fontWeight: 800,
//             lineHeight: 1,
//           }}
//           aria-label="Close Modal"
//         >
//           &times;
//         </button>
//         {/* LEFT: Personal Info */}
//         <div style={{ gridArea: "left", display: "flex", flexDirection: "column", gap: 18 }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
//             <div style={profileCircleStyle}>
//               {(name || "?")[0].toUpperCase()}
//             </div>
//             <div>
//               <div style={{ fontWeight: 800, fontSize: 28, color: "#182a43" }}>
//                 {name}
//               </div>
//               <div style={{ color: "#53709c", marginTop: 8 }}>
//                 <img src={emailIcon} alt="Email" style={{ width: 17, height: 17, marginRight: 6 }} />
//                 {email}
//               </div>
//               <div style={{ color: "#53709c", marginTop: 6 }}>
//                 <img src={phoneIcon} alt="Phone" style={{ width: 15, height: 15, marginRight: 7 }} />
//                 {phone}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             gridArea: "left",
//             marginTop: 60,
//             display: "flex",
//             flexDirection: "column",
//             gap: 30, // space between two tiles
//           }}
//         >
//           <br></br>
//           <br></br>
//           <br></br>
//           {score !== undefined && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 fontWeight: 700,
//                 fontSize: 20,
//                 marginright: 150,
//                 color: "#2d3b51",
//               }}
//             >
//               Resume Score: <span style={{ color: "#238a51" }}>{score} / 100</span>
//             </div>
//           )}

//           {breakdown.length > 0 && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 marginTop: -10,
//                 fontWeight: 600,
//                 fontSize: 20,
//                 color: "#2d3b51",
//                 background: "#ffffff",
//               }}
//             >
//               <div style={{ fontWeight: 700, marginBottom: 12 }}>Score Breakdown (Section wise):</div>
//               <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//                 {breakdown.map((item, idx) => (
//                   <li key={idx}>
//                     {item.category.charAt(0).toUpperCase() + item.category.slice(1)}: {item.score}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//         {/* BOTTOM: L1 Reasons */}
//         <div style={{ gridArea: "bottom", width: "100%" }}>
//           {l1Reasons.length > 0 && (
//             <div
//               style={{
//                 border: "1.6px solid #e7eefa",
//                 borderRadius: 12,
//                 padding: 18,
//                 fontWeight: 600,
//                 fontSize: 20,
//                 color: "#2d3b51",
//               }}
//             >
//               <div style={{ fontWeight: 700, marginBottom: 12 }}>
//                 L1 Reasons:
//               </div>
//               <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//                 {l1Reasons.map((reason, idx) => (
//                   <li key={idx}>{reason}</li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }




// export default function HRJobApplications() {
//   const { jobrole, location, jobid } = useParams();
//   console.log("Params:", jobrole, location, jobid);

//   const navigate = useNavigate();
//   const [applications, setApplications] = useState([]);
//   const [loadingList, setLoadingList] = useState(true);
//   const [listError, setListError] = useState(null);

//   const [jobOnboarding, setJobOnboarding] = useState(null);
//   const [showDetails, setShowDetails] = useState(false);
//   const [selectedCand, setSelectedCand] = useState(null);
//   const [loadingDetails, setLoadingDetails] = useState(false);
//   const [detailsError, setDetailsError] = useState(null);
//   const [applicationDate, setApplicationDate] = useState("N/A");

//   const [hoveredCard, setHoveredCard] = useState(null);


//   // For scores modal
//   const [showScores, setShowScores] = useState(false);
//   const [scores, setScores] = useState(null);
//   const [loadingScores, setLoadingScores] = useState(false);
//   const [scoresError, setScoresError] = useState(null);
//   const [showL2Dialog, setShowL2Dialog] = useState(false);
//   const [l2Loading, setL2Loading] = useState(false);
//   const [l2Questions, setL2Questions] = useState([]);
//   const [l2Error, setL2Error] = useState("");

//   const handleOpenL2 = async () => {
//     setShowL2Dialog(true);
//     setL2Loading(true);
//     setL2Error("");
//     try {
//       const res = await fetch(
//         `${API_BASE_URL}/l2-questions/${scores.candidate_id}/${scores.job_id}`
//       );
//       const data = await res.json();
//       console.log("L2 RAW DATA:", data);

//       if (!res.ok || data.error) {
//         setL2Error(data.error || "Failed to generate L2 questions");
//         setL2Questions([]);
//       } else {
//         // backend: { "question": [...] }
//         const arr = Array.isArray(data.question) ? data.question : [];
//         console.log("L2 QUESTIONS ARRAY:", arr);
//         setL2Questions(arr);
//       }
//     } catch (e) {
//       setL2Error("Network error while generating L2 questions");
//       setL2Questions([]);
//     } finally {
//       setL2Loading(false);
//     }
//   };



//   const fetchCandidates = () => {
//     setLoadingList(true);
//     fetch(`${API_BASE_URL}/api/candidate_scores/${jobid}`)
//       .then(res => res.json())
//       .then(async scoresList => {
//         const mergedList = await Promise.all(scoresList.map(async cand => {
//           const infoRes = await fetch(`${API_BASE_URL}/api/candidate_by_id/${cand.candidate_id}`);
//           const info = await infoRes.json();
//           return { ...cand, name: info.name, email: info.email };
//         }));
//         setApplications(mergedList);
//         setLoadingList(false);
//         setListError(null);
//       })
//       .catch(err => {
//         setListError(err.message);
//         setLoadingList(false);
//       });
//   };
//   useEffect(() => {
//     fetchCandidates();
//   }, [jobid]);
//   useEffect(() => {
//     if (!showScores) {
//       fetchCandidates();
//     }
//   }, [showScores]);

//   const [filterOpen, setFilterOpen] = useState(false);
//   const [sortType, setSortType] = useState("");

//   const [screeningQA, setScreeningQA] = useState(null);

//   // const [tabFilter, setTabFilter] = useState("all");
//   // const [approvedCandidates, setApprovedCandidates] = useState([]);
//   // const [rejectedCandidates, setRejectedCandidates] = useState([]);
//   // const [l0Status, setL0Status] = useState("all");  // "all" | "passed" | "failed"
//   // const [l1Status, setL1Status] = useState("all");  // "all" | "approved" | "failed"
//   // const [activeTab, setActiveTab] = useState("all");
//   //   // Tab labels & keys
//   //   const tabDefinitions = [
//   //   { key: "all", label: "All" },
//   //   { key: "l0", label: "L0" },
//   //   { key: "l1", label: "L1" },
//   // ];
//   const [l0Dropdown, setL0Dropdown] = useState("all");
//   const [l1Dropdown, setL1Dropdown] = useState("all");
//   const [activeTab, setActiveTab] = useState("all");
//   const [manualApplications, setManualApplications] = useState([]);
//   const [loadingManual, setLoadingManual] = useState(false);
//   const [manualError, setManualError] = useState(null);
//   const [showManualScore, setShowManualScore] = useState(false);
//   const [selectedManualCandidate, setSelectedManualCandidate] = useState(null);
//   const [manualScoreLoading, setManualScoreLoading] = useState(false);
//   const [manualScoreError, setManualScoreError] = useState(null);
//   const [loadingManualScore, setLoadingManualScore] = useState(false);
//   const [showManualScoreModal, setShowManualScoreModal] = useState(false);
//   const [manualCandidateScore, setManualCandidateScore] = useState(null);



//   const tabDefs = [
//     { key: "all", label: "All" },
//     { key: "l0", label: "L0" },
//     { key: "l1", label: "L1" },
//     { key: "manual", label: "Manual" }, // New tab
//   ];

//   const [showL0Dropdown, setShowL0Dropdown] = useState(false);
//   const [showL1Dropdown, setShowL1Dropdown] = useState(false);

//   // Fetch candidate list for job
//   useEffect(() => {
//     setLoadingList(true);
//     fetch(`${API_BASE_URL}/api/candidate_scores/${jobid}`)
//       .then(res => res.json())
//       .then(async scoresList => {
//         // Fetch name/email for every candidate_id
//         const mergedList = await Promise.all(scoresList.map(async cand => {
//           const infoRes = await fetch(`${API_BASE_URL}/api/candidate_by_id/${cand.candidate_id}`);
//           const info = await infoRes.json();
//           return { ...cand, name: info.name, email: info.email };
//         }));
//         setApplications(mergedList);
//         setLoadingList(false);
//         setListError(null);
//       })
//       .catch(err => {
//         setListError(err.message);
//         setLoadingList(false);
//       });
//   }, [jobid]);

//   useEffect(() => {
//     if (activeTab === "manual") {
//       setLoadingManual(true);
//       fetch(`${API_BASE_URL}/api/manual_candidates/${jobid}`)
//         .then(res => {
//           if (!res.ok) throw new Error("Failed to fetch manual candidates");
//           return res.json();
//         })
//         .then(manualList => {
//           setManualApplications(manualList); // manualList includes {candidate_id, full_name, email, phone, llm_score}
//           setLoadingManual(false);
//           setManualError(null);
//         })
//         .catch(err => {
//           setManualError(err.message);
//           setLoadingManual(false);
//         });
//     }
//   }, [activeTab, jobid]);


//   const openCandidateDetails = (candidate) => {
//     setLoadingDetails(true);
//     setDetailsError(null);
//     setShowDetails(true);
//     setSelectedCand(null);
//     setApplicationDate("N/A");

//     // Fetch candidate basic details
//     fetch(`${API_BASE_URL}/api/candidate/${candidate.candidate_id}?job_id=${jobid}`)
//       .then((res) => {
//         if (!res.ok) throw new Error("Failed to fetch candidate details");
//         return res.json();
//       })
//       .then((data) => {
//         setSelectedCand(data);
//         console.log("Fetched candidate details:", data);                // Check entire candidate object
//         console.log("Will fetch onboarding for job_id:", data.job_id);  // Should be a valid string, not undefined

//         if (data.job_id) {
//           fetch(`${API_BASE_URL}/api/jobview/${data.job_id}/onboarding`)
//             .then(res => {
//               if (!res.ok) throw new Error("Failed to fetch onboarding questions");
//               return res.json();
//             })
//             .then(onboarding => setJobOnboarding(onboarding))
//             .catch(() => setJobOnboarding(null)); // If no onboarding, set to null
//         } else {
//           console.error("No job_id found in candidate data — onboarding fetch skipped");
//           setJobOnboarding(null);
//         }

//         // After getting candidate details, fetch resume upload date
//         if (data.resume_file_id) {
//           fetch(`${API_BASE_URL}/api/resume_upload_date/${candidate.candidate_id}/${jobid}`)
//             .then((res) => {
//               if (!res.ok) throw new Error("Failed to fetch resume upload date");
//               return res.json();
//             })
//             .then((dateData) => {
//               if (dateData.uploadDate) {
//                 setApplicationDate(new Date(dateData.uploadDate).toLocaleString());
//               }
//             })
//             .catch(() => {
//               setApplicationDate("N/A");
//             });
//         } else {
//           setApplicationDate("N/A");
//         }

//         setLoadingDetails(false);
//       })
//       .catch((err) => {
//         setDetailsError(err.message);
//         setLoadingDetails(false);
//       });
//   };



//   // Fetch candidate scores and show modal
//   const openCandidateScores = async (candidate) => {
//     setLoadingScores(true);
//     setScoresError(null);
//     setScores(null);
//     setScreeningQA(null); // reset Q&A
//     setShowScores(true);

//     try {
//       const [scoresRes, infoRes] = await Promise.all([
//         fetch(`${API_BASE_URL}/api/get_final_score?candidate_id=${candidate.candidate_id}&job_id=${jobid}`),
//         fetch(`${API_BASE_URL}/api/candidate_by_id/${candidate.candidate_id}`)
//       ]);
//       if (!scoresRes.ok) throw new Error("Failed to fetch candidate scores");
//       if (!infoRes.ok) throw new Error("Failed to fetch candidate info");

//       const scoresData = await scoresRes.json();
//       const infoData = await infoRes.json();

//       // Merge candidate info into the scores object
//       const mergedScores = {
//         ...scoresData,
//         candidate_name: infoData.name,
//         candidate_email: infoData.email,
//         candidate_phone: infoData.phone,
//       };
//       setScores(mergedScores);

//       // Only fetch Q&A if candidate passed
//       if (mergedScores.llm_score && mergedScores.llm_score > 0) {
//         const screeningRes = await fetch(
//           `${API_BASE_URL}/api/screening_questions?candidate_id=${candidate.candidate_id}&job_id=${jobid}`
//         );
//         if (screeningRes.ok) {
//           setScreeningQA(await screeningRes.json());
//         }
//       }

//       setLoadingScores(false);
//     } catch (err) {
//       setScoresError(err.message);
//       setLoadingScores(false);
//     }
//   };

//   const openManualScore = (cand) => {
//     setManualCandidateScore(cand); // use full object directly
//     setShowManualScoreModal(true);
//   };

//   const renderManualCandidateCard = (cand, i) => (

//     <div
//       key={i}
//       style={{
//         background: "#fff",
//         borderRadius: 14,
//         boxShadow: "0 4px 18px rgba(35,115,240,0.08)",
//         padding: "22px 22px 20px 22px",
//         minHeight: 170,
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "stretch",
//         border: "1px solid #35b5ffff",
//         cursor: "default"
//       }}
//       onMouseEnter={() => setHoveredCard(i)}
//       onMouseLeave={() => setHoveredCard(null)}
//     >
//       <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
//         <div
//           aria-label="Profile"
//           title={cand.full_name || "Applicant"}
//           style={{
//             width: 44,
//             height: 44,
//             borderRadius: "50%",
//             background: "linear-gradient(135deg,#eaf2ff,#cfe0ff)",
//             color: "#1b4ab8",
//             fontWeight: 800,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             boxShadow: "inset 0 0 0 2px #ffffff, 0 2px 8px rgba(35,115,240,.12)",
//           }}
//         >
//           {(cand?.full_name || "?").toString().trim().slice(0, 1).toUpperCase()}
//         </div>
//         <div style={{ minWidth: 0 }}>
//           <div
//             style={{
//               fontWeight: 800,
//               fontSize: 16,
//               color: "#1c3558",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis"
//             }}
//             title={cand.full_name || ""}
//           >
//             {cand.full_name || "N/A"}
//           </div>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 4,
//               fontSize: 13,
//               color: "#5f779b",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis"
//             }}
//             title={cand.email || ""}
//           >
//             <img
//               src="https://cdn-icons-png.flaticon.com/128/14348/14348015.png"
//               alt="Email Icon"
//               style={{ width: 16, height: 16, flexShrink: 0 }}
//             />
//             <span>{cand.email || "N/A"}</span>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 4,
//               fontSize: 13,
//               color: "#5f779b",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis"
//             }}
//             title={cand.email || ""}
//           >
//             <img
//               src="https://cdn-icons-png.flaticon.com/128/597/597177.png"
//               alt="Email Icon"
//               style={{ width: 16, height: 16, flexShrink: 0 }}
//             />
//             <span>{cand.phone || "N/A"}</span>
//           </div>
//           <div
//             style={{
//               fontSize: 15,
//               color: "#000000",
//               fontWeight: 600,
//               marginTop: 4,
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis"
//             }}
//             title={`Resume Score: ${cand.llm_score ?? "N/A"}/100`}
//           >
//             Resume Score:{" "}
//             <span style={{ marginLeft: 20, color: "#2c6d15" }}>
//               {typeof cand.llm_score === "number" ? `${cand.llm_score}/100` : "N/A"}
//             </span>
//           </div>
//           {/* Add status or additional info as needed */}
//         </div>
//       </div>
//       <div style={{
//         marginTop: "auto",
//         width: "100%",
//         display: "flex",
//         gap: 12
//       }}>
//         <button
//           onClick={() => {
//             setSelectedManualCandidate(cand);
//             setShowManualScore(true);
//           }}
//           style={{
//             background: "#1e7e34",
//             color: "#fff",
//             fontWeight: 700,
//             padding: "10px 0",
//             border: "none",
//             borderRadius: 6,
//             fontSize: 15,
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             flex: 1,
//             minWidth: 0
//           }}
//         >
//           View Scores
//         </button>
//       </div>
//     </div>
//   );

//   if (loadingList)
//     return (
//       <div style={{ padding: 300, display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <ClipLoader color="#2d3b51" size={32} />
//         <div style={{ marginTop: 10 }}>Loading candidates...</div>
//       </div>
//     );

//   if (listError)
//     return (
//       <div style={{ padding: 20, color: "red" }}>
//         Error loading candidates: {listError}
//       </div>
//     );

//   const applySort = (apps, sortType) => {
//     if (sortType === "score-desc") {
//       return [...apps].sort((a, b) => (b.llm_score ?? 0) - (a.llm_score ?? 0));
//     }
//     if (sortType === "score-asc") {
//       return [...apps].sort((a, b) => (a.llm_score ?? 0) - (b.llm_score ?? 0));
//     }
//     return apps;
//   };

//   const sortedApplications = applySort(applications, sortType);

//   const l0PassedCount = applications.filter(cand => (cand.compatibility ?? 0) >= 40).length;
//   const l0FailedCount = applications.filter(cand => (cand.compatibility ?? 0) < 40).length;
//   const l1ApprovedCount = applications.filter(cand => cand.status === "approved").length;





//   // Filtering by tab selection
//   const filteredApplications = sortedApplications.filter((cand) => {
//     // if (activeTab === "all") return true;
//     if (activeTab === "l0") {
//       const screened = (cand.compatibility ?? 0) >= 40;
//       if (l0Dropdown === "all") return true;
//       if (l0Dropdown === "passed") return screened;
//       if (l0Dropdown === "failed") return !screened;
//     }
//     if (activeTab === "l1") {
//       if (l1Dropdown === "all") return cand.status === "approved" || cand.status === "rejected";
//       if (l1Dropdown === "approved") return cand.status === "approved";
//       if (l1Dropdown === "rejected") return cand.status === "rejected";
//     }
//     return true;
//   });



//   const getSortLabel = (sortType) => {
//     switch (sortType) {
//       case "score-desc":
//         return "High to Low";
//       case "score-asc":
//         return "Low to High";
//       default:
//         return "Filter & Sort";
//     }
//   };

//   // Helper to render a candidate card used in both grids
//   const renderCandidateCard = (cand, i) => (
//     <div
//       key={i}
//       style={{
//         background: "#fff",
//         borderRadius: 14,
//         boxShadow:
//           hoveredCard === i
//             ? "0 10px 26px rgba(39,130,226,0.18)"
//             : "0 4px 18px rgba(35,115,240,0.08)",
//         padding: "22px 22px 20px 22px",
//         minHeight: 170,
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "stretch",
//         transform: hoveredCard === i ? "translateY(-4px)" : "translateY(0)",
//         transition: "all 0.2s ease",
//         border: "1px solid #35b5ffff",
//         cursor: "default",
//       }}
//       onMouseEnter={() => setHoveredCard(i)}
//       onMouseLeave={() => setHoveredCard(null)}
//     >
//       <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
//         <div
//           aria-label="Profile"
//           title={cand.name || "Applicant"}
//           style={{
//             width: 44,
//             height: 44,
//             borderRadius: "50%",
//             background: "linear-gradient(135deg,#eaf2ff,#cfe0ff)",
//             color: "#1b4ab8",
//             fontWeight: 800,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             boxShadow: "inset 0 0 0 2px #ffffff, 0 2px 8px rgba(35,115,240,.12)",
//           }}
//         >
//           {(cand?.name || "?")
//             .toString()
//             .trim()
//             .slice(0, 1)
//             .toUpperCase()}
//         </div>
//         <div style={{ minWidth: 0 }}>
//           <div
//             style={{
//               fontWeight: 800,
//               fontSize: 16,
//               color: "#1c3558",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//             }}
//             title={cand.name || ""}
//           >
//             {cand.name || "N/A"}
//           </div>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 4,
//               fontSize: 13,
//               color: "#5f779b",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//             }}
//             title={cand.email || ""}
//           >
//             <img
//               src="https://cdn-icons-png.flaticon.com/128/14348/14348015.png"
//               alt="Email Icon"
//               style={{ width: 16, height: 16, flexShrink: 0 }}
//             />
//             <span>{cand.email || "N/A"}</span>
//           </div>
//           <div
//             style={{
//               fontSize: 15,
//               color: "#000000", // black for label
//               fontWeight: 600,
//               marginTop: 4,
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//             }}
//             title={`Resume Score: ${cand.llm_score ?? "N/A"}/100`}
//           >
//             Resume Score:{" "}
//             <span style={{ marginLeft: 65, color: "#2c6d15" }}>
//               {cand.llm_score !== undefined ? `${cand.llm_score}/100` : "N/A"}
//             </span>
//           </div>
//           <div style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 8,
//             fontSize: 15,
//             color: "#000",
//             fontWeight: 600,
//             marginTop: 4,
//           }}>
//             <span>Status:</span>
//             {cand.status === "approved" ? (
//               <span style={{
//                 background: "#eaf9ed",
//                 color: "#238a51",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 borderRadius: 8,
//                 padding: "5px 16px",
//                 marginLeft: 10,
//                 display: "inline-block"
//               }}>Approved</span>
//             ) : cand.status === "rejected" ? (
//               <span style={{
//                 background: "#ffebeb",
//                 color: "#d9534f",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 borderRadius: 8,
//                 padding: "5px 16px",
//                 marginLeft: 10,
//                 display: "inline-block"
//               }}>Rejected</span>
//             ) : (
//               <span style={{
//                 color: "#777",
//                 fontSize: 13,
//                 marginLeft: 10,
//                 fontStyle: "italic"
//               }}>Pending</span>
//             )}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           marginTop: "auto",
//           width: "100%",
//           display: "flex",
//           gap: 12
//         }}
//       >
//         <button
//           style={{
//             background: "#2684ff",
//             color: "#fff",
//             fontWeight: 700,
//             padding: "10px 0",
//             border: "none",
//             borderRadius: 6,
//             fontSize: 15,
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             flex: 1,
//             minWidth: 0
//           }}
//           onClick={() => openCandidateDetails(cand)}
//         >
//           More Info
//         </button>
//         <button
//           style={{
//             background: "#1e7e34",
//             color: "#fff",
//             fontWeight: 700,
//             padding: "10px 0",
//             border: "none",
//             borderRadius: 6,
//             fontSize: 15,
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             flex: 1,
//             minWidth: 0
//           }}
//           onClick={() => openCandidateScores(cand)}
//         >
//           View Scores
//         </button>
//       </div>
//     </div>
//   );


//   return (
//     <>
//       {/* Header with job info from params */}
//       <div
//         style={{
//           position: "sticky",
//           top: 0,
//           left: 0,
//           right: 0,
//           background: "#fff",
//           zIndex: 110,
//           borderBottom: "1px solid #f0f1f5",
//           padding: "24px 40px 18px 40px",
//           display: "flex",
//           alignItems: "flex-end",
//           justifyContent: "space-between",
//         }}
//       >
//         <div>
//           <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
//             <button
//               onClick={() => navigate(-1)}
//               style={{
//                 background: "#eaf2ff",
//                 color: "#236ef2",
//                 border: "none",
//                 borderRadius: 8,
//                 padding: "8px 12px",
//                 fontWeight: 700,
//                 cursor: "pointer",
//               }}
//             >
//               ← Back to Jobs
//             </button>
//             <span style={{ fontSize: 40, fontWeight: 800, marginLeft: 10, color: "#172d44" }}>
//               {jobrole || "Job"}
//             </span>
//           </div>
//           <div style={{ color: "#5a6e8a", marginLeft: 150, fontSize: 20, fontWeight: 600 }}>
//             <span style={{ marginRight: 12 }}>{jobid}</span>·
//             <span style={{ marginLeft: 12 }}>{location}</span>
//           </div>
//         </div>
//         <div style={{ color: "#4a5f85", marginRight: 40, marginBottom: 10, fontWeight: 800 }}>
//           Total Applications: <span style={{ color: "#236ef2" }}>{applications.length}</span>
//           <div style={{ fontWeight: 600, marginTop: 4 }}>
//             <span style={{ color: "#4a5f85", fontWeight: 800 }}>L0 Passed:</span><span style={{ color: "#236ef2" }}> {l0PassedCount} </span> |<span style={{ color: "#4a5f85", fontWeight: 800 }}> L0 Failed:</span> <span style={{ color: "#236ef2" }}> {l0FailedCount} </span> | <span style={{ color: "#4a5f85", fontWeight: 800 }}>L1 Approved:</span><span style={{ color: "#236ef2" }}> {l1ApprovedCount}</span>
//           </div>
//         </div>
//       </div>

//       {/* Filter and Sort Bar with Tabs */}
//       <div
//         style={{
//           width: "95%",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           background: "#f9fbff",
//           padding: "12px 36px 8px 36px",
//           borderBottom: "1px solid #ebfaedff",
//           marginBottom: 16,
//           position: "relative"
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             gap: 4,
//             justifyContent: "flex-start",
//             marginLeft: 153,    // <-- LEFT ALIGN
//             alignItems: "center",
//             flex: 1,                      // <-- MAKE SURE TABS FILL THE ROW
//           }}
//         >
//           {tabDefs.map(tab => (
//             <div key={tab.key} style={{ position: "relative" }}>
//               {tab.key === "l0" ? (
//                 <button
//                   onClick={() => {
//                     setActiveTab("l0");
//                     setShowL0Dropdown(true);
//                     setShowL1Dropdown(false);
//                   }}
//                   style={{
//                     background: activeTab === "l0" ? "#236ef2" : "transparent",
//                     color: activeTab === "l0" ? "#fff" : "#236ef2",
//                     border: "none",
//                     borderRadius: 8,
//                     padding: "8px 20px",
//                     fontWeight: 700,
//                     cursor: "pointer",
//                     fontSize: 18,
//                     boxShadow: activeTab === "l0" ? "0 2px 8px #b9dbff45" : "none",
//                   }}
//                 >
//                   {tab.label}
//                   <span style={{
//                     marginLeft: 6,
//                     fontSize: 16,
//                     transition: "transform 0.2s",
//                     transform: showL0Dropdown ? "rotate(180deg)" : "none"
//                   }}>
//                     ▼
//                   </span>
//                 </button>
//               ) : tab.key === "l1" ? (
//                 <button
//                   onClick={() => {
//                     setActiveTab("l1");
//                     setShowL1Dropdown(true);
//                     setShowL0Dropdown(false);
//                   }}
//                   style={{
//                     background: activeTab === "l1" ? "#236ef2" : "transparent",
//                     color: activeTab === "l1" ? "#fff" : "#236ef2",
//                     border: "none",
//                     borderRadius: 8,
//                     padding: "8px 20px",
//                     fontWeight: 700,
//                     cursor: "pointer",
//                     fontSize: 18,
//                     boxShadow: activeTab === "l1" ? "0 2px 8px #b9dbff45" : "none",
//                   }}
//                 >
//                   {tab.label}
//                   <span style={{
//                     marginLeft: 6,
//                     fontSize: 16,
//                     transition: "transform 0.2s",
//                     transform: showL1Dropdown ? "rotate(180deg)" : "none"
//                   }}>
//                     ▼
//                   </span>
//                 </button>
//               ) : (
//                 <button
//                   onClick={() => setActiveTab(tab.key)}
//                   style={{
//                     background: activeTab === tab.key ? "#236ef2" : "transparent",
//                     color: activeTab === tab.key ? "#fff" : "#236ef2",
//                     border: "none",
//                     borderRadius: 8,
//                     padding: "8px 20px",
//                     fontWeight: 700,
//                     cursor: "pointer",
//                     fontSize: 18,
//                     boxShadow: activeTab === tab.key ? "0 2px 8px #b9dbff45" : "none",
//                   }}
//                 >
//                   {tab.label}

//                 </button>
//               )}

//               {/* Show custom dropdown if L0 tab is active and dropdown is open */}
//               {tab.key === "l0" && activeTab === "l0" && showL0Dropdown && (
//                 <div style={{
//                   position: "absolute",
//                   top: "100%",
//                   left: 0,
//                   background: "#fff",
//                   border: "1px solid #daeafd",
//                   borderRadius: 7,
//                   marginTop: 5,
//                   boxShadow: "0 7px 18px #dae2ff59",
//                   zIndex: 200,
//                   minWidth: 144,
//                   fontWeight: 600,
//                 }}>
//                   <div
//                     style={{
//                       padding: "10px 22px",
//                       color: l0Dropdown === "passed" ? "#fff" : "#236ef2",
//                       background: l0Dropdown === "passed" ? "#236ef2" : "none",
//                       cursor: "pointer",
//                       borderTopLeftRadius: 7,
//                       borderTopRightRadius: 7,
//                     }}
//                     onClick={() => {
//                       setL0Dropdown("passed");
//                       setShowL0Dropdown(false); // Close after selection
//                     }}
//                   >
//                     L0 Passed
//                   </div>
//                   <div
//                     style={{
//                       padding: "10px 22px",
//                       color: l0Dropdown === "failed" ? "#fff" : "#236ef2",
//                       background: l0Dropdown === "failed" ? "#236ef2" : "none",
//                       cursor: "pointer",
//                       borderBottomLeftRadius: 7,
//                       borderBottomRightRadius: 7,
//                     }}
//                     onClick={() => {
//                       setL0Dropdown("failed");
//                       setShowL0Dropdown(false); // Close after selection
//                     }}
//                   >
//                     L0 Failed
//                   </div>
//                 </div>
//               )}

//               {/* Same for L1 */}
//               {tab.key === "l1" && activeTab === "l1" && showL1Dropdown && (
//                 <div style={{
//                   position: "absolute",
//                   top: "100%",
//                   left: 0,
//                   background: "#fff",
//                   border: "1px solid #daeafd",
//                   borderRadius: 7,
//                   marginTop: 5,
//                   boxShadow: "0 7px 18px #dae2ff59",
//                   zIndex: 200,
//                   minWidth: 144,
//                   fontWeight: 600,
//                 }}>
//                   <div
//                     style={{
//                       padding: "10px 22px",
//                       color: l1Dropdown === "approved" ? "#fff" : "#236ef2",
//                       background: l1Dropdown === "approved" ? "#236ef2" : "none",
//                       cursor: "pointer",
//                       borderTopLeftRadius: 7,
//                       borderTopRightRadius: 7,
//                     }}
//                     onClick={() => {
//                       setL1Dropdown("approved");
//                       setShowL1Dropdown(false);
//                     }}
//                   >
//                     L1 Approved
//                   </div>
//                   <div
//                     style={{
//                       padding: "10px 22px",
//                       color: l1Dropdown === "rejected" ? "#fff" : "#236ef2",
//                       background: l1Dropdown === "rejected" ? "#236ef2" : "none",
//                       cursor: "pointer",
//                       borderBottomLeftRadius: 7,
//                       borderBottomRightRadius: 7,
//                     }}
//                     onClick={() => {
//                       setL1Dropdown("rejected");
//                       setShowL1Dropdown(false);
//                     }}
//                   >
//                     L1 Rejected
//                   </div>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Sort button absolutely positioned on the right */}
//         <div
//           style={{
//             position: "absolute",
//             right: 36,
//             top: "50%",
//             transform: "translateY(-50%)",
//           }}
//         >
//           <button
//             style={{
//               background: "#eef5ff",
//               color: "#236ef2",
//               border: "1px solid #daeafd",
//               borderRadius: 8,
//               fontWeight: 700,
//               fontSize: 16,
//               padding: "10px 22px 10px 16px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               gap: 7,
//               userSelect: "none"
//             }}
//             onClick={() => setFilterOpen(f => !f)}
//           >
//             {getSortLabel(sortType)}
//             <span style={{
//               fontSize: 15,
//               transform: filterOpen ? "rotate(180deg)" : "none",
//               transition: "transform 0.2s ease"
//             }}>▼</span>
//           </button>
//           {filterOpen && (
//             <div style={{
//               position: "absolute",
//               right: 0,
//               top: "115%",
//               minWidth: 170,
//               background: "#fff",
//               border: "1px solid #ddeafc",
//               borderRadius: 8,
//               boxShadow: "0 7px 18px #dae2ff59",
//               zIndex: 30,
//               padding: "10px 0",
//             }}>
//               <button
//                 style={{
//                   background: "none",
//                   border: "none",
//                   color: "#236ef2",
//                   fontWeight: 600,
//                   textAlign: "left",
//                   width: "100%",
//                   padding: "10px 24px",
//                   cursor: "pointer",
//                   fontSize: 15,
//                   userSelect: "none"
//                 }}
//                 onClick={() => { setSortType("score-desc"); setFilterOpen(false); }}
//               >
//                 Sort by High Score
//               </button>
//               <button
//                 style={{
//                   background: "none",
//                   border: "none",
//                   color: "#236ef2",
//                   fontWeight: 600,
//                   textAlign: "left",
//                   width: "100%",
//                   padding: "10px 24px",
//                   cursor: "pointer",
//                   fontSize: 15,
//                   userSelect: "none"
//                 }}
//                 onClick={() => { setSortType("score-asc"); setFilterOpen(false); }}
//               >
//                 Sort by Low Score
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Candidate Cards Grid filtered */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(3, 320px)",
//           gap: 32,
//           justifyContent: "center",
//           alignItems: "start",
//           maxWidth: 1080,
//           margin: "28px auto 0 auto",
//           padding: "0 16px"
//         }}
//       >
//         {activeTab === "manual" ? (
//           loadingManual ? (
//             <div>Loading manual candidates...</div>
//           ) : manualError ? (
//             <div style={{ color: "red" }}>Error loading manual candidates: {manualError}</div>
//           ) : manualApplications.length === 0 ? (
//             <div>No manual candidates added by HR found.</div>
//           ) : (
//             manualApplications.map((cand, i) => renderManualCandidateCard(cand, i))
//           )
//         ) : (
//           filteredApplications.length === 0 ? (
//             <div style={{ color: "#999", fontSize: 17 }}>
//               No applications found for this filter.
//             </div>
//           ) : (
//             filteredApplications.map((cand, i) => renderCandidateCard(cand, i))
//           )
//         )}
//       </div>

//       {/* Candidate details modal */}
//       <CandidateDetailsModal
//         open={showDetails}
//         onClose={() => setShowDetails(false)}
//         candidate={selectedCand}
//         jobOnboarding={jobOnboarding}
//         loading={loadingDetails}
//         applicationDate={applicationDate}
//       />


//       {/* Candidate scores modal */}
//       <CandidateScoreModal
//         open={showScores}
//         onClose={() => setShowScores(false)}
//         scores={scores}
//         screeningQA={screeningQA}
//         loading={loadingScores}
//         error={scoresError}
//         handleOpenL2={handleOpenL2}
//       />
//       {showL2Dialog && (
//         <L2QuestionsDialog
//           onClose={() => setShowL2Dialog(false)}
//           loading={l2Loading}
//           questions={l2Questions}
//           error={l2Error}
//         />
//       )}
//       <ManualCandidateScoreModal
//         open={showManualScore}
//         onClose={() => setShowManualScore(false)}
//         candidate={selectedManualCandidate}
//         loading={manualScoreLoading}
//         error={manualScoreError}
//       />

//     </>
//   );
// }

// share pdf working
import React, { useEffect, useState, useRef } from "react";
import { API_BASE_URL } from "../../config";
import { ClipLoader } from "react-spinners"; // Example react-spinners usage
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useParams, useNavigate } from "react-router-dom";
import ProfileMenu from "./ProfileMenu";

// const API_BASE_URL = "https://screening.fanisko.com";
// const API_BASE_URL = "http://127.0.0.1:8000";



function ResumePreviewModal({ open, onClose, pdfUrl }) {
  if (!open || !pdfUrl) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: -300, top: 0, width: "120vw", height: "100vh",
        background: "rgba(20,40,90,0.29)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      {/* Close button OUTSIDE preview box */}
      <button
        onClick={onClose}
        aria-label="Close Resume"
        style={{
          position: "fixed", // Instead of absolute, so it's relative to viewport
          right: "10vw",
          top: "4vh",        // Or try top: 22px;
          background: "none",
          border: "none",
          fontSize: 33,
          color: "#000000ff",
          cursor: "pointer",
          fontWeight: 900,
          zIndex: 800,     // Higher than preview
          padding: 18,
          lineHeight: 1,
        }}
      >
        &times;
      </button>
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 8px 48px #11275360",
          width: "min(700px,96vw)",
          maxHeight: "80vh",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <iframe
          title="Resume Preview"
          src={pdfUrl}
          width="150%"
          height="800px"
          marginright="200px"
          style={{ border: "none", borderRadius: 12 }}
        />
      </div>
    </div>
  );
}

function parseCoverLetter(raw) {
  console.log("parseCoverLetter INPUT:", raw);

  // If raw is an object with type and value, extract the value string
  let valueStr = raw;
  if (typeof raw === "object" && raw !== null && "value" in raw) {
    valueStr = raw.value;
  }

  if (valueStr && typeof valueStr === "string" && valueStr.includes("_")) {
    const lastUnderscoreIndex = valueStr.lastIndexOf("_");
    const possibleId = valueStr.slice(lastUnderscoreIndex + 1);
    console.log("parseCoverLetter possibleId:", possibleId);

    if (lastUnderscoreIndex > 0 && possibleId && /^[a-fA-F0-9]+$/.test(possibleId)) {
      console.log("parseCoverLetter: showButton = true");
      return {
        showButton: true,
        value: possibleId,
        filename: valueStr.slice(0, lastUnderscoreIndex),
      };
    }
    console.log("parseCoverLetter: showButton = false - did not match hex/number");
  }

  return { showButton: false, value: valueStr || "" };
}

function convertUtcToIst(utcDateStr) {
  // Parse the date string directly as UTC
  const utcDate = new Date(utcDateStr + ' UTC');
  // Format the date explicitly in 'Asia/Kolkata' timezone
  return utcDate.toLocaleString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  });
}
// --- Modal to preview (file or text) ---
function CoverLetterPreviewModal({ open, onClose, coverLetter }) {
  if (!open) return null;
  console.log("CoverLetterPreviewModal: coverLetter:", coverLetter);

  if (coverLetter.showButton && coverLetter.value) {
    const fileUrl = `${API_BASE_URL}/api/cover_letter_file/${coverLetter.value}`;
    return (
      <div
        style={{
          position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
          background: "rgba(20,40,90,0.29)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 9999,
        }}
        onClick={onClose}
      >
        <button
          onClick={onClose}
          aria-label="Close Cover Letter"
          style={{
            position: "fixed", right: "20vw", top: "6vh",
            background: "none", border: "none", fontSize: 33, color: "#000000ff",
            cursor: "pointer", fontWeight: 900, zIndex: 800, padding: 18, lineHeight: 1,
          }}
        >&times;</button>
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "#fff", borderRadius: 12, boxShadow: "0 8px 48px #11275360",
            width: "min(700px,96vw)", height: "80vh",
            position: "relative", display: "flex", flexDirection: "column",
          }}>
          <iframe
            title="Cover Letter Preview"
            src={fileUrl}
            width="100%"
            height="100%"
            style={{ border: "none", borderRadius: 12 }}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
        background: "rgba(20,40,90,0.29)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <button
        onClick={onClose}
        aria-label="Close Cover Letter"
        style={{
          position: "fixed", right: "20vw", top: "6vh", background: "none",
          border: "none", fontSize: 33, color: "#000000ff", cursor: "pointer",
          fontWeight: 900, zIndex: 800, padding: 18, lineHeight: 1,
        }}
      >&times;</button>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff", borderRadius: 12, boxShadow: "0 8px 48px #11275360",
          width: "min(700px,96vw)", maxHeight: "80vh", padding: 30,
          overflowY: "auto", color: "#223455", fontSize: 18, whiteSpace: "pre-wrap",
          lineHeight: 1.7, position: "relative",
        }}
      >{coverLetter.value || "No cover letter available."}
      </div>
    </div>
  );
}

function CandidateDetailsModal({ open, onClose, candidate, jobOnboarding, loading, applicationDate }) {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  // const [jobOnboarding, setJobOnboarding] = useState(null);
  const [showResume, setShowResume] = useState(false);
  const [showCoverLetter, setShowCoverLetter] = useState(false);
  if (!open) return null;
  const resumePdfUrl = candidate?.resume_file_id
    ? `${API_BASE_URL}/api/resume_pdf/${candidate.resume_file_id}`
    : null;

  // Icons
  const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
  const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";
  const locationIcon = "https://cdn-icons-png.flaticon.com/128/14027/14027590.png";
  // Mapping of display names (edit or extend as needed)
  const FIELD_LABEL_MAP = {
    linkedin: "LinkedIn",
    notice_period: "Notice Period",
    current_salary: "Current Salary",
    expected_salary: "Expected Salary",
    work_mode: "Work Mode",
    preferred_city: "Preferred City",
    current_location: "Current Location",
    interview_date: "Interview Date",
    interview_time_slots: "Interview Time Slots",
    legally_authorized: "Legally Authorized",
    open_to_relocate: "Open to Relocate",
    found_us: "Found Us by",
    job_change_reason: "Reason for Job Change",
    career_gap_reason: "Reason for Career Gap",

    // add others or fallback to onboarding.label
  };

  // Array controls the order and set of shown fields
  // const SHOWN_FIELDS = [
  //   "linkedin",
  //   "notice_period",
  //   "current_salary",
  //   "expected_salary",
  //   "work_mode",
  //   "preferred_city",
  //   "current_location",
  //   "interview_date",
  //   "interview_time_slots",
  //   "legally_authorized",
  // ];

  // Exclude these always (already handled above for core, but in case onboarding includes them)
  const EXCLUDED_ONBOARDING_KEYS = ["has_cover_letter", "cover_letter"];
  const EXCLUDED_EXTRA_KEYS = ["coverLetterName"];
  const coverLetterObj = candidate ? parseCoverLetter(candidate.cover_letter || "") : { showButton: false, value: "" };
  console.log("coverLetterObj in CandidateDetailsModal:", coverLetterObj);
  console.log("jobOnboarding", jobOnboarding);
  console.log("candidate", candidate);


  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        overflowY: "auto",
        padding: 20,
      }}
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          minWidth: 600,
          maxWidth: 520,
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 6px 32px #52a4f420",
          padding: "30px 40px",
          position: "relative",
          maxHeight: "93vh",
          top: -20,
          bottom: 190,
          overflowY: "auto",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: 18,
            top: 6,
            background: "none",
            border: "none",
            fontSize: 30,
            color: "#236ef2",
            cursor: "pointer",
            fontWeight: 800,
            lineHeight: 1,
          }}
          aria-label="Close Modal"
        >
          &times;
        </button>

        {loading ? (
          <div style={{ fontSize: 17, textAlign: "center", padding: 40, color: "#236ef2" }}>
            Loading details...
          </div>
        ) : candidate ? (
          <>
            {/* Profile Section */}
            <div style={{ display: "flex", alignItems: "center", marginBottom: 22 }}>
              <div
                style={{
                  width: 66,
                  height: 66,
                  borderRadius: "50%",
                  background: "radial-gradient(ellipse at 60% 40%, #eaf2ff 80%, #e4ecfc 100%)",
                  color: "#2457ac", // rich blue for letter (matches your image)
                  fontWeight: 700,
                  fontSize: 35,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 20px #eaf2ff, 0 0 0 6px #fff inset",
                  border: "4px solid #fff",
                  marginRight: 18,
                }}
              >
                {(candidate.name || "?").slice(0, 1).toUpperCase()}
              </div>
              <div>
                <div
                  style={{
                    fontWeight: 800,
                    fontSize: 23,
                    color: "#182a43",
                    marginBottom: 7,
                  }}
                >
                  {candidate.name || "idk"}
                </div>
                {candidate.email && (
                  <div style={{ display: "flex", alignItems: "center", color: "#53709c", fontSize: 15, marginBottom: 2 }}>
                    <img src={emailIcon} alt="Email" style={{ width: 17, height: 17, marginRight: 6 }} />
                    {candidate.email}
                  </div>
                )}
                {candidate.phone && (
                  <div style={{ display: "flex", alignItems: "center", color: "#53709c", fontSize: 15, marginBottom: 2 }}>
                    <img src={phoneIcon} alt="Phone" style={{ width: 15, height: 15, marginRight: 7 }} />
                    {candidate.phone}
                  </div>
                )}
              </div>
            </div>

            {/* Additional Details Tile */}
            <div
              style={{
                border: "1.6px solid #e7eefa",
                background: "#f7fbfd",
                borderRadius: 12,
                marginTop: 6,
                padding: "19px 26px 16px 21px",
              }}
            >
              <div style={{
                fontWeight: 700,
                fontSize: 16,
                marginBottom: 2,
                color: "#2465ae",
                letterSpacing: "0.02em"
              }}>
                Additional Details:
              </div>
              <div style={{ fontSize: 15, color: "#2d3b51", marginTop: 10, lineHeight: 2 }}>
                {/* <div>
  <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
  <b>Cover Letter:</b> {
    candidate.cover_letter?.type === "text"
      ? candidate.cover_letter.value || "N/A"
      : candidate.cover_letter?.type === "file"
        ? "Uploaded File"
        : "N/A"
  }
</div> */}

                {jobOnboarding && (
                  <div style={{ marginTop: 24 }}>
                    {Object.entries(jobOnboarding).map(([key, config]) => {
                      if (EXCLUDED_ONBOARDING_KEYS.includes(key)) return null;
                      if (
                        key === "preferred_city" &&
                        (
                          (candidate.work_mode && candidate.work_mode.toLowerCase() === "remote") ||
                          (candidate["work_mode"] && candidate["work_mode"].toLowerCase() === "remote")
                        )
                      ) return null;
                      let v = candidate[key];
                      if ((v === undefined || v === "") && candidate.extra_onboarding_fields) {
                        v = candidate.extra_onboarding_fields[key];
                      }
                      if (v === undefined || v === "") v = "N/A";
                      if (typeof v === "object" && v !== null) {
                        if ("value" in v) v = v.value;
                        else v = JSON.stringify(v);
                      }
                      // Legal label logic as before
                      let label = FIELD_LABEL_MAP[key] || config.label || key;
                      if (key === "legally_authorized" && config.label) {
                        const suffix = config.label.split("legally authorized")[1]?.trim();
                        if (suffix) label = `Legally Authorized (${suffix.replace(/[?]/g, '')}):`;
                      }
                      if (key === "linkedin" && v && v !== "N/A") {
                        return (
                          <div key={key} style={{ marginBottom: 14 }}>
                            <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
                            <b>
                              {label.replace(/[?:\s]+$/, "")}:
                            </b>{" "}
                            <a
                              href={v}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#2465ae",
                                textDecoration: "underline",
                              }}
                            >
                              Profile Link
                            </a>
                          </div>
                        );
                      }
                      return (
                        <div key={key} style={{ marginBottom: 14 }}>
                          <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
                          <b>
                            <span>{label.replace(/[?:\s]+$/, "")}:</span>
                          </b> {v}
                        </div>
                      );
                    })}

                    {/* Show extra/dynamic fields not in SHOWN_FIELDS */}
                    <div style={{ marginTop: 12 }}>
                      {candidate.extra_onboarding_fields &&
                        Object.entries(candidate.extra_onboarding_fields)
                          // Exclude any extra field whose key is in jobOnboarding (already shown above)
                          .filter(([key]) => !jobOnboarding.hasOwnProperty(key) && !EXCLUDED_EXTRA_KEYS.includes(key))
                          .map(([key, value]) => (
                            <div key={key} style={{ marginBottom: 14 }}>
                              <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
                              <b>{jobOnboarding[key]?.label || key.replace(/[?:\s]+$/, "")}:</b> {value || "N/A"}
                            </div>
                          ))}
                    </div>
                    <div style={{ marginTop: 18, marginBottom: 3 }}>
                      <span style={{ marginRight: 5 }}>{'\u25AA'}</span>
                      <b>Application Date:</b>{" "}
                      {applicationDate && applicationDate !== "N/A"
                        ? convertUtcToIst(applicationDate)
                        : <em>Fetching...</em>
                      }
                    </div>
                  </div>
                )}


              </div>
            </div>

            {/* View Resume Button */}
            {resumePdfUrl && (
              <div style={{ marginTop: 20 }}>
                <button
                  onClick={() => setShowResume(true)}
                  style={{
                    backgroundColor: "#236ef2",
                    color: "#fff",
                    border: "none", borderRadius: 6, padding: "12px 20px",
                    fontWeight: "bold", cursor: "pointer", width: "100%", fontSize: 16,
                  }}
                >
                  View Resume
                </button>
              </div>
            )}
            {/* View Cover Letter button */}
            {/* console.log("coverLetterObj in CandidateDetailsModal:", coverLetterObj); */}

            {(coverLetterObj.showButton || coverLetterObj.value) && (
              <div style={{ marginTop: 20 }}>
                <button
                  onClick={() => setShowCoverLetter(true)}
                  style={{
                    backgroundColor: "#236ef2",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    padding: "12px 20px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    width: "100%",
                    fontSize: 16,
                  }}
                >
                  View Cover Letter
                </button>
              </div>
            )}
            <ResumePreviewModal
              open={showResume}
              onClose={() => setShowResume(false)}
              pdfUrl={resumePdfUrl}
            />
            {/* Cover Letter Preview Modal */}
            <CoverLetterPreviewModal
              open={showCoverLetter}
              onClose={() => setShowCoverLetter(false)}
              coverLetter={coverLetterObj}
            />
          </>
        ) : (
          <div style={{ fontSize: 16, textAlign: "center", padding: 20, color: "red" }}>
            Failed to load candidate details.
          </div>
        )}
      </div>
    </div>
  );
}

function L2QuestionsDialog({ onClose, loading, questions, error }) {
  console.log("L2QuestionsDialog questions prop:", questions);
  const shimmerBase = {
    background: "linear-gradient(90deg, #eef3ff 0%, #f7f9ff 40%, #eef3ff 80%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.5s infinite",
    borderRadius: 10
  };

  return (
    <>
      {/* keyframes for shimmer */}
      <style>
        {`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}
      </style>

      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2500
        }}
        onClick={onClose}
      >
        <div
          onClick={e => e.stopPropagation()}
          style={{
            width: 720,
            maxHeight: "80vh",
            background: "#fff",
            borderRadius: 16,
            boxShadow: "0 10px 40px #13254f33",
            padding: "24px 26px 26px 26px",
            position: "relative",
            overflowY: "auto"
          }}
        >
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: 10,
              right: 14,
              border: "none",
              background: "transparent",
              fontSize: 26,
              color: "#2457ac",
              cursor: "pointer",
              fontWeight: 700
            }}
          >
            &times;
          </button>

          <div style={{ fontSize: 22, fontWeight: 800, color: "#182a43", marginBottom: 8 }}>
            L2 Interview Question Suggestions
          </div>
          <div style={{ fontSize: 13, color: "#667699", marginBottom: 20 }}>
            Generated Based on Resume and Job Description
          </div>

          {loading && (
            <div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 12 }}>
              {[1, 2, 3, 4].map(i => (
                <div
                  key={i}
                  style={{
                    ...shimmerBase,
                    height: 60,
                    padding: "14px 16px",
                    boxShadow: "0 1px 6px rgba(138, 143, 157, 0.9)"
                  }}
                />
              ))}
            </div>
          )}

          {!loading && error && (
            <div
              style={{
                marginTop: 12,
                padding: 14,
                borderRadius: 10,
                background: "#ffefef",
                color: "#b02a37",
                fontSize: 14,
                fontWeight: 500
              }}
            >
              {error}
            </div>
          )}

          {!loading && !error && Array.isArray(questions) && questions.length > 0 && (
            <div style={{ marginTop: 6, display: "flex", flexDirection: "column", gap: 14 }}>
              {questions.map((q, idx) => (
                <div
                  key={idx}
                  style={{
                    borderRadius: 12,
                    border: "1px solid #e0e7fb",
                    padding: "14px 16px",
                    background: "#f7f9ff",
                    boxShadow: "0 2px 10px #e1e9ff90",
                    display: "flex",
                    gap: 12
                  }}
                >
                  <div
                    style={{
                      minWidth: 26,
                      height: 26,
                      borderRadius: "50%",
                      background: "#2457ac",
                      color: "#fff",
                      fontSize: 14,
                      fontWeight: 700,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: 4
                    }}
                  >
                    {idx + 1}
                  </div>
                  <div style={{ fontSize: 15, color: "#182a43", fontWeight: 500, lineHeight: 1.4 }}>
                    {q}
                  </div>
                </div>
              ))}
            </div>
          )}

          {!loading && !error && (!questions || questions.length === 0) && (
            <div style={{ marginTop: 16, fontSize: 14, color: "#6b7280" }}>
              No questions generated yet.
            </div>
          )}
        </div>
      </div>
    </>
  );
}


// Schedule L2 Interview Modal Component
function ScheduleL2Modal({ open, onClose, candidateName, jobTitle }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3000,
        backdropFilter: "blur(4px)"
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "min(500px, 95vw)", background: "#fff", borderRadius: 16, overflow: "hidden",
          display: "flex", flexDirection: "column", boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)"
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ padding: "20px 24px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#1e293b" }}>Schedule L2 Interview</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 28, cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>&times;</button>
        </div>

        <div style={{ padding: 24, display: "flex", flexDirection: "column", gap: 20 }}>
          <div style={{ background: "#f0f7ff", borderRadius: 12, padding: "16px 20px", border: "1px solid #e0e7fb" }}>
            <div style={{ fontWeight: 700, color: "#2563eb", fontSize: 14 }}>{candidateName || "Candidate Name"}</div>
            <div style={{ color: "#3b82f6", fontSize: 13, fontWeight: 500 }}>{jobTitle || "Senior Frontend Developer"}</div>
          </div>

          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#475569", marginBottom: 8 }}>Interview Type</label>
            <select style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 14, outline: "none", background: "#fff" }}>
              <option>Online</option>
              <option>Offline</option>
            </select>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#475569", marginBottom: 8 }}>Date</label>
              <input type="date" style={{ width: "90%", padding: "10px 14px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 14, outline: "none" }} />
            </div>
            <div>
              <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#475569", marginBottom: 8 }}>Time</label>
              <input type="time" style={{ width: "90%", padding: "9px 14px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 14, outline: "none" }} />
            </div>
          </div>

          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#475569", marginBottom: 8 }}>Interviewer</label>
            <input type="text" placeholder="Enter name" style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 14, outline: "none" }} />
          </div>

          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#475569", marginBottom: 8 }}>Notes (Optional)</label>
            <textarea placeholder="Add any notes..." style={{ width: "100%", height: 80, padding: "12px 14px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 14, outline: "none", resize: "none" }} />
          </div>
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <button onClick={onClose} style={{ padding: "10px 20px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: "pointer", color: "#64748b" }}>Cancel</button>
          <button style={{ padding: "10px 24px", background: "#9333ea", color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: "pointer", boxShadow: "0 4px 6px -1px rgba(147, 51, 234, 0.3)" }}>Confirm & Schedule</button>
        </div>
      </div>
    </div>
  );
}

function AssignReviewersModal({ open, onClose, onConfirm, emails, setEmails, emailInput, setEmailInput, mainReviewer, setMainReviewer, loading }) {
  if (!open) return null;

  const handleAddEmail = (e) => {
    if (e.key === 'Enter' && emailInput.trim()) {
      e.preventDefault();
      // Basic email validation regex
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailInput.trim())) {
        alert("Please enter a valid email address");
        return;
      }
      if (!emails.includes(emailInput.trim())) {
        setEmails([...emails, emailInput.trim()]);
      }
      setEmailInput("");
    }
  };

  const removeEmail = (email) => {
    setEmails(emails.filter(m => m !== email));
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3000, backdropFilter: "blur(4px)" }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ width: "min(450px, 90vw)", background: "#fff", borderRadius: 16, padding: "28px", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#1e293b" }}>Panel Members</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 24, cursor: "pointer", color: "#94a3b8" }}>&times;</button>
        </div>

        <p style={{ fontSize: 13, color: "#64748b", margin: "-10px 0 20px" }}>The selected reviewers will receive a notification about this candidate's approval.</p>

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 14, fontWeight: 600, color: "#475569", display: "block", marginBottom: 10 }}>Main Reviewer</label>
          <input
            value={mainReviewer}
            onChange={e => setMainReviewer(e.target.value)}
            placeholder="Enter main reviewer email..."
            style={{ width: "93%", padding: "10px 14px", borderRadius: 10, border: "1px solid #e2e8f0", fontSize: 14, outline: "none", background: "#fcfdfe" }}
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 14, fontWeight: 600, color: "#475569", display: "block", marginBottom: 10 }}>Reviewer Email Addresses</label>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, padding: "10px", border: "1px solid #e2e8f0", borderRadius: 10, minHeight: 48, background: "#fcfdfe", transition: "border-color 0.2s" }}>
            {emails.map((email, idx) => (
              <div
                key={idx}
                style={{ background: "#eff6ff", color: "#3b82f6", padding: "4px 10px", borderRadius: 8, fontSize: 13, display: "flex", alignItems: "center", gap: 6, border: "1px solid #dbeafe", fontWeight: 600 }}
              >
                {email}
                <span
                  onClick={() => removeEmail(email)}
                  style={{ cursor: "pointer", fontWeight: 800, color: "#60a5fa", hover: { color: "#3b82f6" } }}
                >&times;</span>
              </div>
            ))}
            <input
              value={emailInput}
              onChange={e => setEmailInput(e.target.value)}
              onKeyDown={handleAddEmail}
              placeholder={emails.length === 0 ? "Type email and press Enter..." : "Add another..."}
              style={{ flex: 1, border: "none", outline: "none", fontSize: 14, minWidth: 150, background: "transparent" }}
            />
          </div>
          <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>Tip: You can add multiple emails by pressing Enter after each one.</p>
        </div>

        <button
          onClick={onConfirm}
          disabled={(emails.length === 0 && !mainReviewer) || loading}
          style={{
            width: "100%", padding: "12px", background: (emails.length === 0 || loading) ? "#d1fae5" : "#10b981",
            color: "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 15,
            cursor: (emails.length === 0 || loading) ? "not-allowed" : "pointer", transition: "all 0.2s",
            boxShadow: (emails.length === 0 || loading) ? "none" : "0 4px 6px -1px rgba(16, 185, 129, 0.2)",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 8
          }}
        >
          {loading ? <ClipLoader color="#fff" size={20} /> : "Confirm Approval"}
        </button>
      </div>
    </div>
  );
}

function CandidateScoreModal({
  open,
  onClose,
  scores,
  screeningQA,
  loading,
  error,
  approvedCandidates,
  rejectedCandidates,
  setApprovedCandidates,
  setRejectedCandidates,
  handleOpenL2,
  jobrole, // Added jobrole prop
  jobid
}) {
  const [isVerified, setIsVerified] = useState(false);
  const [decisionMade, setDecisionMade] = useState(false);
  const [activeNoteTab, setActiveNoteTab] = useState("L0");
  const [noteText, setNoteText] = useState("");
  const [notes, setNotes] = useState([]);
  const [l2Feedback, setL2Feedback] = useState("");
  const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [showNotesPanel, setShowNotesPanel] = useState(true);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showApproveEmailModal, setShowApproveEmailModal] = useState(false);
  const [approveEmails, setApproveEmails] = useState([]);
  const [emailInput, setEmailInput] = useState("");
  const [isApproving, setIsApproving] = useState(false);
  const [mainReviewer, setMainReviewer] = useState("");
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);
  const [submittedFeedbacks, setSubmittedFeedbacks] = useState([]);

  async function fetchSubmittedFeedbacks() {
    if (!scores?.candidate_id || !jobid) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/get_submitted_feedbacks/${scores.candidate_id}/${jobid}`);
      if (res.ok) {
        const data = await res.json();
        setSubmittedFeedbacks(data.feedbacks || []);
      }
    } catch (err) {
      console.error("Error fetching submitted feedbacks:", err);
    }
  }

  async function fetchNotes() {
    if (!scores?.candidate_id) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/get_notes/${scores.candidate_id}`);
      if (res.ok) {
        const data = await res.json();
        setNotes(Array.isArray(data) ? data : (data.notes || []));
      }
    } catch (err) {
      console.error("Error fetching notes:", err);
    }
  }

  async function fetchDraftFeedback() {
    if (!scores?.candidate_id || !jobid) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/get_draft_feedback/${scores.candidate_id}/${jobid}`);
      if (res.ok) {
        const data = await res.json();
        if (data && data.feedback) {
          setL2Feedback(data.feedback);
        }
      }
    } catch (err) {
      console.error("Error fetching draft feedback:", err);
    }
  }

  async function handleSaveDraft() {
    if (!scores?.candidate_id || !jobid) return;
    try {
      const payload = {
        candidate_id: scores.candidate_id,
        job_id: jobid,
        feedback: l2Feedback
      };
      const res = await fetch(`${API_BASE_URL}/api/save_draft_feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setShowSaveSuccess(true);
      } else {
        alert("Failed to save draft");
      }
    } catch (err) {
      console.error("Error saving draft feedback:", err);
    }
  }

  useEffect(() => {
    if (open && scores?.candidate_id) {
      fetchNotes();
      fetchDraftFeedback();
      fetchSubmittedFeedbacks();
    }
  }, [open, scores?.candidate_id, jobid]);

  const reportRef = useRef(null);
  const summaryRef = useRef(null);

  const generatePDF = async (options = {}) => {
    if (!summaryRef.current) return null;

    const { optimized = false } = options;
    const scale = optimized ? 1.5 : 2;
    const quality = optimized ? 0.5 : 0.8;

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 15; // 15mm margin
    const contentWidth = pdfWidth - (2 * margin);

    let currentY = margin;

    // Get all blocks
    const blocks = summaryRef.current.querySelectorAll('[data-pdf-block="true"]');

    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      const canvas = await html2canvas(block, {
        scale: scale,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/jpeg", quality);
      const imgProps = pdf.getImageProperties(imgData);
      const blockWidthInPdf = contentWidth;
      const blockHeightInPdf = (imgProps.height * blockWidthInPdf) / imgProps.width;

      // Check if block fits on current page
      if (currentY + blockHeightInPdf > pdfHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }

      pdf.addImage(imgData, "JPEG", margin, currentY, blockWidthInPdf, blockHeightInPdf);
      currentY += blockHeightInPdf + 5; // Reduced 5mm spacing between blocks
    }

    return pdf;
  };

  const handleExportPDF = async () => {
    try {
      const pdf = await generatePDF({ optimized: false });
      if (pdf) {
        pdf.save(`${scores?.candidate_name || "Candidate"}_Summary.pdf`);
      }
    } catch (err) {
      console.error("PDF generation failed:", err);
      alert("Failed to generate PDF summary.");
    }
  };

  const handleShare = async () => {
    try {
      // Use optimized PDF (smaller size) for sharing to fix Teams/WhatsApp compatibility
      const pdf = await generatePDF({ optimized: true });
      if (!pdf) return;

      const pdfBlob = pdf.output('blob');
      const fileName = `${scores?.candidate_name || "Candidate"}_Summary.pdf`;
      const file = new File([pdfBlob], fileName, { type: 'application/pdf' });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'Candidate Evaluation Summary',
          // Note: Removing 'text' as some apps (Teams) fail when both files and text are present
        });
      } else {
        // Fallback for browsers that don't support file sharing
        const shareText = `Candidate Evaluation Summary for ${scores?.candidate_name || "a candidate"}\nScore: ${scores?.llm_score}/100\nStatus: ${scores?.status}`;
        if (navigator.share) {
          await navigator.share({
            title: "Candidate Summary",
            text: shareText,
            url: window.location.href,
          });
        } else {
          await navigator.clipboard.writeText(shareText);
          alert("Summary copied to clipboard (File sharing not supported)!");
        }
      }
    } catch (err) {
      console.error("Sharing failed:", err);
    }
  };

  const handleApprove = async () => {
    setIsApproving(true);
    try {
      const payload = {
        candidate_name: scores.candidate_name,
        candidate_email: scores.candidate_email,
        candidate_id: scores.candidate_id,
        job_id: scores.job_id || jobid,
        position: jobrole || "Position",
        interview_level: "Technical Round",
        date: "2026-03-03",
        time: "4:30 PM",
        duration_minutes: 30,
        timezone: "Asia/Kolkata",
        main_reviews: mainReviewer,
        interviewers: approveEmails.map(email => ({
          name: "Manager",
          email: email
        })),
        status: 'approved'
      };
      await fetch(`${API_BASE_URL}/api/update_l1_status`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      setDecisionMade(true);
      setShowApproveEmailModal(false);
      onClose();
    } catch (err) {
      console.error("Approve failed:", err);
    } finally {
      setIsApproving(false);
    }
  };

  const handleReject = async () => {
    await fetch(`${API_BASE_URL}/api/update_l1_status`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        candidate_id: scores.candidate_id,
        job_id: scores.job_id,
        status: 'rejected'
      })
    });
    setDecisionMade(true);
    onClose();
  };

  if (!open) return null;

  const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
  const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";

  const loadingOrNoScore = loading || scores?.llm_score == null;

  if (loadingOrNoScore)
    return (
      <div style={{ padding: 300, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <ClipLoader color="#2d3b51" size={200} />
        <div style={{ marginTop: 10 }}>Loading score...</div>
      </div>
    );

  const profileCircleStyle = {
    width: 66,
    height: 66,
    borderRadius: "50%",
    background: "radial-gradient(ellipse at 60% 40%, #5b84ff 0%, #3a68ff 100%)",
    color: "#fff",
    fontWeight: 800,
    fontSize: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 18,
  };

  const initialScreeningPassed = (scores?.compatibility ?? 0) >= 40;
  const overallL1Score = screeningQA?.interview_report?.overall_l1_score ?? "N/A";
  const questionScores =
    Array.isArray(screeningQA?.interview_report?.question_scores)
      ? screeningQA.interview_report.question_scores
      : [];

  async function handleAddNote() {
    if (!noteText.trim()) return;
    try {
      const payload = {
        candidate_id: scores.candidate_id,
        candidate_name: scores.candidate_name,
        job_id: scores.job_id || jobid || "N/A",
        note: noteText,
        level: activeNoteTab,
        author: "HR Manager"
      };
      const res = await fetch(`${API_BASE_URL}/api/add_note`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setNoteText("");
        fetchNotes();
      } else {
        alert("Failed to add note");
      }
    } catch (err) {
      console.error("Error adding note:", err);
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2100,
        backdropFilter: "blur(4px)"
      }}
      onClick={onClose}
    >
      <div
        ref={reportRef}
        data-report-container="true"
        onClick={e => e.stopPropagation()}
        style={{
          width: "min(1200px, 96vw)",
          height: "92vh",
          background: "#fff",
          borderRadius: 20,
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative"
        }}
      >
        {/* Header Bar */}
        <div style={{
          padding: "16px 24px",
          borderBottom: "1px solid #f1f5f9",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#fff"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#1e293b" }}>Candidate Scores & Details</h2>
            <span style={{
              background: "#eff6ff",
              color: "#3b82f6",
              fontSize: 11,
              fontWeight: 700,
              padding: "4px 8px",
              borderRadius: 12,
              textTransform: "uppercase"
            }}>
              {scores?.candidate_id || "APP003"}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button
              onClick={handleShare}
              style={{
                display: "flex", alignItems: "center", gap: 6, padding: "8px 14px",
                background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8,
                fontSize: 13, fontWeight: 600, color: "#475569", cursor: "pointer"
              }}
            >
              <span style={{ fontSize: 16 }}> 📤 </span> Share</button>
            <button
              onClick={handleExportPDF}
              style={{
                display: "flex", alignItems: "center", gap: 6, padding: "8px 14px",
                background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8,
                fontSize: 13, fontWeight: 600, color: "#475569", cursor: "pointer"
              }}
            >
              <span style={{ fontSize: 16 }}>📄</span> Download PDF
            </button>
            <div
              onClick={() => setShowNotesPanel(!showNotesPanel)}
              style={{
                width: 38, height: 38, borderRadius: 8, background: "#fff", border: "1px solid #e2e8f0",
                display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                boxShadow: showNotesPanel ? "inset 0 2px 4px rgba(0,0,0,0.05)" : "0 1px 2px rgba(0,0,0,0.05)",
                borderColor: showNotesPanel ? "#3b82f6" : "#e2e8f0"
              }}>
              <span style={{ color: "#3b82f6", fontSize: 20 }}>📋</span>
            </div>
            <button
              onClick={onClose}
              style={{
                background: "none", border: "none", fontSize: 24, color: "#94a3b8", cursor: "pointer",
                padding: "4px 8px", display: "flex", alignItems: "center", justifyContent: "center"
              }}
            >
              &times;
            </button>
          </div>
        </div>

        {/* Body Content */}
        <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
          {/* Main Details Panel */}
          <div style={{ flex: 1, padding: "32px 40px", overflowY: "auto", display: "flex", flexDirection: "column", gap: 32 }}>

            {/* Candidate Header */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={profileCircleStyle}>{(scores?.candidate_name || "?")[0].toUpperCase()}</div>
              <div>
                <h1 style={{ margin: 0, fontSize: 28, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>
                  {(scores?.candidate_name || "N/A").toUpperCase()}
                </h1>
                <div style={{ display: "flex", gap: 20, marginTop: 8 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#64748b", fontSize: 14 }}>
                    <img src={emailIcon} style={{ width: 14, height: 14 }} alt="" /> {scores?.candidate_email || "N/A"}
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#64748b", fontSize: 14 }}>
                    <img src={phoneIcon} style={{ width: 14, height: 14 }} alt="" /> {scores?.candidate_phone || "N/A"}
                  </div>
                </div>
              </div>
            </div>

            {/* Status & Resume Score Cards */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
              <div style={{
                padding: "16px 20px", borderRadius: 12, border: "1px solid #f1f5f9",
                background: "#fff", display: "flex", alignItems: "center", gap: 12
              }}>
                <span style={{ fontSize: 15, fontWeight: 600, color: "#475569" }}>Initial Screening Status:</span>
                <span style={{
                  fontWeight: 700, fontSize: 15, color: initialScreeningPassed ? "#10b981" : "#ef4444"
                }}>
                  {initialScreeningPassed ? "Pass" : "Fail"} ({scores?.compatibility ?? "N/A"})
                </span>
              </div>
              <div style={{
                padding: "16px 20px", borderRadius: 12, border: "1px solid #f1f5f9",
                background: "#fff", display: "flex", alignItems: "center", gap: 12
              }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: "#475569" }}>Resume Score:</span>
                <span style={{ fontWeight: 800, fontSize: 15, color: "#0f172a" }}>
                  <span style={{ color: "#10b981" }}>{scores?.llm_score}</span> / 100
                </span>
              </div>
            </div>

            {/* Reasons Columns */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32 }}>
              <div>
                <h3 style={{ fontSize: 15, fontWeight: 700, color: "#1e293b", marginBottom: 16 }}>L0 Reasons:</h3>
                <ul style={{ padding: 0, margin: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 12 }}>
                  {Array.isArray(scores.l0_reasons) && scores.l0_reasons.map((reason, idx) => (
                    <li key={idx} style={{
                      fontSize: 14, color: "#64748b", lineHeight: 1.5, position: "relative", paddingLeft: 18
                    }}>
                      <span style={{ position: "absolute", left: 0, color: "#94a3b8" }}>•</span> {reason}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 style={{ fontSize: 15, fontWeight: 700, color: "#1e293b", marginBottom: 16 }}>Score Breakdown (Section wise):</h3>
                <ul style={{ padding: 0, margin: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 12 }}>
                  {Array.isArray(scores.score_breakdown) && scores.score_breakdown.map((item, idx) => (
                    <li key={idx} style={{
                      fontSize: 14, color: "#64748b", display: "flex", justifyContent: "space-between"
                    }}>
                      <span>• {item.category.charAt(0).toUpperCase() + item.category.slice(1)}:</span>
                      <span style={{ fontWeight: 600, color: "#475569" }}>{item.score}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* L2 Link */}
            {initialScreeningPassed && (
              <div style={{ marginTop: -8 }}>
                <button
                  onClick={handleOpenL2}
                  style={{
                    background: "none", border: "none", padding: 0, cursor: "pointer",
                    display: "flex", alignItems: "center", gap: 8, color: "#3b82f6", fontWeight: 600, fontSize: 14
                  }}
                >
                  <span>L2</span> <span style={{ textDecoration: "underline" }}>Generate L2 Interview Questions</span> ↗
                </button>
              </div>
            )}

            <div style={{ height: 1, background: "#f1f5f9" }} />

            {/* Detailed Reasons */}
            <div>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", marginBottom: 16 }}>Reasons:</h3>
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                {Array.isArray(scores.reasons) && scores.reasons.map((reason, idx) => (
                  <div key={idx} style={{
                    fontSize: 15, color: "#475569", lineHeight: 1.6, position: "relative", paddingLeft: 20
                  }}>
                    <span style={{ position: "absolute", left: 0, color: "#94a3b8" }}>•</span> {reason}
                  </div>
                ))}
              </div>
            </div>

            {/* L1 Evaluation Section */}
            {overallL1Score >= 0 && (
              <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
                <div style={{
                  padding: "16px 20px", borderRadius: 12, border: "1px solid #f1f5f9",
                  background: "#f8fafc", display: "flex", alignItems: "center", gap: 12
                }}>
                  <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>Overall L1 Score:</span>
                  <span style={{ fontWeight: 800, fontSize: 18, color: "#10b981" }}>{overallL1Score}</span>
                </div>

                {questionScores.length > 0 && (
                  <div>
                    <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", marginBottom: 20 }}>L1 Questions and Responses:</h3>
                    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
                      {questionScores.map((qscore, idx) => (
                        <div key={idx} style={{
                          background: "#fff",
                          borderRadius: 16,
                          border: "1px solid #e2e8f0",
                          padding: "24px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 16,
                          position: "relative"
                        }}>
                          {/* Score badge */}
                          <div style={{
                            position: "absolute",
                            top: 24,
                            right: 24,
                            fontWeight: 700,
                            padding: "4px 12px",
                            borderRadius: 12,
                            fontSize: 12,
                            background: qscore.score > 0 ? "#d1fae5" : "#fee2e2",
                            color: qscore.score > 0 ? "#059669" : "#dc2626",
                          }}>
                            Score: {qscore.score}
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            <div style={{ fontWeight: 700, color: "#334155", fontSize: 14, textTransform: "uppercase", letterSpacing: "0.05em" }}>Question</div>
                            <div style={{
                              background: "#f8fafc", borderRadius: 8, padding: "12px 16px",
                              color: "#1e293b", fontWeight: 600, fontSize: 15, lineHeight: 1.5
                            }}>
                              {qscore.question}
                            </div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            <div style={{ fontWeight: 700, color: "#059669", fontSize: 14, textTransform: "uppercase", letterSpacing: "0.05em" }}>Answer summary</div>
                            <div style={{
                              background: "#f0fdf4", borderRadius: 8, padding: "12px 16px",
                              color: "#166534", fontWeight: 500, fontSize: 15, lineHeight: 1.5
                            }}>
                              {qscore.answer_summary || <span style={{ color: "#94a3b8" }}>No summary provided</span>}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* L2 Recruiter Feedback Section (New from Image) */}
            {scores.status === "approved" && (
              <div style={{ borderTop: "1px solid #f1f5f9", paddingTop: 32 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                  <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", margin: 0 }}>L2 Recruiter Feedback</h3>
                  <span style={{
                    fontSize: 10, fontWeight: 700, background: "#fef3c7", color: "#92400e",
                    padding: "2px 8px", borderRadius: 4, textTransform: "uppercase"
                  }}>Draft</span>
                </div>

                <textarea
                  placeholder="Enter L2 recruiter feedback..."
                  value={l2Feedback}
                  onChange={(e) => setL2Feedback(e.target.value)}
                  style={{
                    width: "100%", height: 120, padding: 16, borderRadius: 12, border: "1px solid #e2e8f0",
                    fontSize: 14, color: "#1e293b", resize: "none", background: "#fcfdfe",
                    marginBottom: 16, outline: "none", boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)"
                  }}
                />

                <div style={{ display: "flex", gap: 12, marginBottom: 32 }}>
                  <button
                    onClick={handleSaveDraft}
                    style={{
                      padding: "8px 16px", background: "#fff", color: "#1e293b",
                      border: "1px solid #e2e8f0", borderRadius: 6, fontWeight: 600, fontSize: 13, cursor: "pointer"
                    }}
                  >
                    Save Draft
                  </button>
                  <button
                    onClick={async () => {
                      setIsSubmittingFeedback(true);
                      try {
                        const payload = {
                          candidate_id: scores.candidate_id,
                          job_id: jobid,
                          feedback: l2Feedback,
                          author: "HR Manager",
                          level: "L2"
                        };
                        const res = await fetch(`${API_BASE_URL}/api/submit_feedback`, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify(payload)
                        });
                        if (res.ok) {
                          setFeedbackSubmitted(true);
                          setL2Feedback("");
                          fetchSubmittedFeedbacks();
                          // Fetch draft again to ensure it's cleared in UI if backend clears it
                          fetchDraftFeedback();
                        } else {
                          alert("Failed to submit feedback");
                        }
                      } catch (err) {
                        console.error("Submit feedback failed:", err);
                      } finally {
                        setIsSubmittingFeedback(false);
                      }
                    }}
                    disabled={!l2Feedback.trim() || isSubmittingFeedback}
                    style={{
                      padding: "8px 16px", background: "#3b82f6", color: "#fff",
                      border: "none", borderRadius: 6, fontWeight: 600, fontSize: 13,
                      cursor: (!l2Feedback.trim() || isSubmittingFeedback) ? "not-allowed" : "pointer",
                      opacity: (!l2Feedback.trim() || isSubmittingFeedback) ? 0.6 : 1
                    }}
                  >
                    {isSubmittingFeedback ? "Submitting..." : "Submit Feedback"}
                  </button>
                </div>

                {/* Submitted Feedbacks List */}
                {submittedFeedbacks.length > 0 && (
                  <div style={{ marginBottom: 32 }}>
                    <h4 style={{ fontSize: 14, fontWeight: 700, color: "#1e293b", marginBottom: 12 }}>Feedback History</h4>
                    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                      {submittedFeedbacks.map((fb, idx) => (
                        <div key={idx} style={{ padding: 16, background: "#f8fafc", borderRadius: 12, border: "1px solid #e2e8f0" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                            <span style={{ fontWeight: 700, fontSize: 13, color: "#334155" }}>{fb.author || "HR Manager"}</span>
                            <span style={{ fontSize: 11, color: "#94a3b8" }}>{fb.submitted_at}</span>
                          </div>
                          <p style={{ margin: 0, fontSize: 13, color: "#475569", lineHeight: 1.5 }}>{fb.feedback}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* <button
                  onClick={() => setShowScheduleModal(true)}
                  style={{
                    width: "fit-content", padding: "12px 24px", background: "#8b5cf6", color: "#fff",
                    border: "none", borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: "pointer",
                    display: "flex", alignItems: "center", gap: 8, transition: "all 0.2s",
                    boxShadow: "0 4px 12px rgba(139, 92, 246, 0.25)"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.background = "#7c3aed"}
                  onMouseOut={(e) => e.currentTarget.style.background = "#8b5cf6"}
                >
                  <span style={{ fontSize: 18 }}>📋</span> Schedule L2 Interview
                </button> */}
              </div>
            )}

            {/* Decision Bar */}
            {initialScreeningPassed && (
              <div style={{ marginTop: "auto", borderTop: "1px solid #f1f5f9", paddingTop: 32, display: "flex", flexDirection: "column", alignItems: "center", gap: 24 }}>
                {scores.status === "pending" && !decisionMade && (
                  <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={isVerified}
                      onChange={e => setIsVerified(e.target.checked)}
                      style={{ width: 18, height: 18, borderRadius: 4, cursor: "pointer" }}
                    />
                    <span style={{ color: "#3b82f6", fontWeight: 600, fontSize: 14 }}>
                      Verified all details and ready for decision
                    </span>
                  </label>
                )}

                <div style={{ display: "flex", gap: 16 }}>
                  {scores.status === "pending" && !decisionMade ? (
                    <>
                      <button
                        onClick={() => setShowApproveEmailModal(true)}
                        disabled={!isVerified}
                        style={{
                          padding: "12px 40px", background: isVerified ? "#10b981" : "#d1fae5",
                          color: "#fff", border: "none", borderRadius: 10, fontWeight: 700,
                          cursor: isVerified ? "pointer" : "not-allowed", transition: "all 0.2s"
                        }}
                      >
                        Approve
                      </button>
                      <button
                        onClick={handleReject}
                        disabled={!isVerified}
                        style={{
                          padding: "12px 40px", background: isVerified ? "#ef4444" : "#fee2e2",
                          color: "#fff", border: "none", borderRadius: 10, fontWeight: 700,
                          cursor: isVerified ? "pointer" : "not-allowed", transition: "all 0.2s"
                        }}
                      >
                        Reject
                      </button>
                    </>
                  ) : (
                    <div style={{
                      padding: "12px 40px",
                      background: (scores.status === "approved" || (decisionMade && scores.status === "approved")) ? "#d1fae5" : "#fee2e2",
                      color: (scores.status === "approved" || (decisionMade && scores.status === "approved")) ? "#059669" : "#dc2626",
                      borderRadius: 10, fontWeight: 700, fontSize: 18
                    }}>
                      {(scores.status === "approved" || (decisionMade && scores.status === "approved")) ? "Approved" : "Rejected"}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Vertical Separator */}
          {showNotesPanel && <div style={{ width: 1, background: "#f1f5f9" }} />}

          {/* Right Panel: Notes */}
          {showNotesPanel && (
            <div style={{ width: 380, background: "#fcfdfe", display: "flex", flexDirection: "column" }}>
              <div style={{ padding: "24px 24px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 18 }}>📂</span>
                  <span style={{ fontWeight: 700, color: "#1e293b" }}>Notes</span>
                </div>
                <span style={{ color: "#94a3b8", fontSize: 12 }}>{notes.length} note</span>
              </div>

              {/* Note Tabs */}
              <div style={{ px: 24, display: "flex", gap: 12, padding: "0 24px 16px" }}>
                {["L0", "L1", "L2"].map(tab => (
                  <button
                    key={tab}
                    onClick={() => setActiveNoteTab(tab)}
                    style={{
                      padding: "6px 16px", borderRadius: 20, border: "none", cursor: "pointer",
                      fontSize: 12, fontWeight: 700, transition: "all 0.2s",
                      background: activeNoteTab === tab ? "#eff6ff" : "transparent",
                      color: activeNoteTab === tab ? "#3b82f6" : "#94a3b8"
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              {/* Note Input Area */}
              <div style={{ padding: "0 24px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
                <textarea
                  placeholder="Add a note..."
                  value={noteText}
                  onChange={e => setNoteText(e.target.value)}
                  style={{
                    width: "90%", height: 100, padding: 16, borderRadius: 12, border: "1px solid #e2e8f0",
                    fontSize: 14, color: "#1e293b", resize: "none", background: "#fff",
                    boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)"
                  }}
                />
                <button
                  onClick={handleAddNote}
                  style={{
                    width: "100%", padding: "10px", background: "#3b82f6", color: "#fff",
                    border: "none", borderRadius: 8, fontWeight: 600, cursor: "pointer"
                  }}
                >
                  + Add Note
                </button>
              </div>

              <div style={{ height: 1, background: "#f1f5f9", margin: "0 24px" }} />

              {/* Notes List */}
              <div style={{ flex: 1, overflowY: "auto", padding: 24, display: "flex", flexDirection: "column", gap: 16 }}>
                {notes.map((note, idx) => (
                  <div key={idx} style={{
                    padding: 16, background: "#fff", borderRadius: 12, border: "1px solid #f1f5f9", boxShadow: "0 1px 3px rgba(0,0,0,0.02)"
                  }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: "#334155" }}>{note.author || note.user || "HR Manager"}</span>
                        <span style={{
                          fontSize: 10, fontWeight: 700, background: "#eff6ff", color: "#3b82f6", padding: "2px 6px", borderRadius: 4
                        }}>{note.level || note.type}</span>
                      </div>
                    </div>
                    <div style={{ fontSize: 13, color: "#64748b", lineHeight: 1.5, marginBottom: 8 }}>
                      {note.note || note.text}
                    </div>
                    <div style={{ fontSize: 11, color: "#cbd5e1" }}>
                      {note.timestamp}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {showSaveSuccess && (
          <SuccessFeedbackModal
            onClose={() => setShowSaveSuccess(false)}
            message="Your draft feedback has been saved successfully."
          />
        )}

        {/* Professional Summary Report (Hidden from UI, used for PDF generation) */}
        <div ref={summaryRef} style={{ position: "absolute", left: -9999, top: 0, width: "210mm", padding: "20mm", background: "#fff" }}>
          <div data-pdf-block="true" style={{ marginBottom: "30px", borderBottom: "3px solid #3b82f6", paddingBottom: "20px" }}>
            <h1 style={{ color: "#1e3a8a", margin: "0 0 10px 0", fontSize: "28px" }}>Professional Evaluation Report</h1>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
              <div>
                <h2 style={{ color: "#3b82f6", margin: "0 0 5px 0", fontSize: "20px" }}>{scores?.candidate_name}</h2>
                <p style={{ color: "#64748b", margin: 0, fontSize: "14px" }}>{jobrole || "Candidate Evaluation"}</p>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "24px", fontWeight: "bold", color: "#10b981" }}>{scores?.llm_score}/100</div>
                <div style={{ fontSize: "12px", color: "#94a3b8" }}>OVERALL SCORE</div>
              </div>
            </div>
          </div>

          {/* L0 Analysis Section */}
          {Array.isArray(scores.l0_reasons) && scores.l0_reasons.length > 0 && (
            <div data-pdf-block="true" style={{ marginBottom: "25px" }}>
              <h3 style={{ borderBottom: "1px solid #e1eefa", paddingBottom: "5px", marginBottom: "12px", color: "#1e293b", fontSize: "16px" }}>Initial Screening (L0) Reasons</h3>
              <ul style={{ marginTop: "5px", paddingLeft: "20px", lineHeight: "1.6", color: "#475569" }}>
                {scores.l0_reasons.map((reason, idx) => (
                  <li key={idx} style={{ marginBottom: "6px" }}>{reason}</li>
                ))}
              </ul>
            </div>
          )}

          {/* L1 Evaluation Section */}
          {scores?.reasons?.length > 0 && (
            <div data-pdf-block="true" style={{ marginBottom: "25px" }}>
              <h3 style={{ borderBottom: "1px solid #e1eefa", paddingBottom: "5px", marginBottom: "12px", color: "#1e293b", fontSize: "16px" }}>Detailed Evaluation (L1) Reasons</h3>
              <ul style={{ marginTop: "5px", paddingLeft: "20px", lineHeight: "1.6", color: "#475569" }}>
                {scores.reasons.map((reason, idx) => (
                  <li key={idx} style={{ marginBottom: "6px" }}>{reason}</li>
                ))}
              </ul>
            </div>
          )}

          {/* L1 Q&A Section */}
          {overallL1Score >= 0 && questionScores.length > 0 && (
            <div data-pdf-block="true" style={{ marginBottom: "25px" }}>
              <h3 style={{ borderBottom: "1px solid #e1eefa", paddingBottom: "5px", marginBottom: "15px", color: "#1e293b", fontSize: "16px" }}>L1 Interview Q&A Summary</h3>
              <div style={{ marginTop: "10px" }}>
                {questionScores.map((qscore, idx) => (
                  <div key={idx} style={{ marginBottom: "15px", border: "1px solid #e2e8f0", borderRadius: "10px", overflow: "hidden" }}>
                    <div style={{ background: "#f8fafc", padding: "10px 15px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0" }}>
                      <span style={{ fontWeight: "bold", color: "#1e293b", fontSize: "14px" }}>Question {idx + 1}</span>
                      <span style={{ background: qscore.score > 0 ? "#d1fae5" : "#fee2e2", color: qscore.score > 0 ? "#059669" : "#dc2626", padding: "2px 10px", borderRadius: "10px", fontSize: "11px", fontWeight: "bold" }}>
                        Score: {qscore.score}
                      </span>
                    </div>
                    <div style={{ padding: "12px 15px" }}>
                      <div style={{ fontWeight: "600", color: "#1e293b", marginBottom: "8px", fontSize: "14px" }}>{qscore.question}</div>
                      <div style={{ background: "#f0fdf4", border: "1px solid #dcfce7", padding: "10px", borderRadius: "6px", color: "#166534", fontSize: "13px" }}>
                        <strong>Response Summary:</strong> {qscore.answer_summary || "No summary provided"}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div data-pdf-block="true" style={{ textAlign: "center", color: "#94a3b8", fontSize: "11px", marginTop: "40px", borderTop: "1px solid #f1f5f9", paddingTop: "20px" }}>
            &copy; {new Date().getFullYear()} Fanisko Candidate Evaluation System. Confidential Report.
          </div>
        </div>
      </div>

      <ScheduleL2Modal
        open={showScheduleModal}
        onClose={() => setShowScheduleModal(false)}
        candidateName={scores?.candidate_name}
        jobTitle={jobrole}
      />

      <AssignReviewersModal
        open={showApproveEmailModal}
        onClose={() => setShowApproveEmailModal(false)}
        onConfirm={handleApprove}
        emails={approveEmails}
        setEmails={setApproveEmails}
        emailInput={emailInput}
        setEmailInput={setEmailInput}
        mainReviewer={mainReviewer}
        setMainReviewer={setMainReviewer}
        loading={isApproving}
      />
    </div>
  );
}

function ManualCandidateScoreModal({
  open,
  onClose,
  candidate,
  loading,
  error,
  jobrole,
  jobid
}) {
  const [activeNoteTab, setActiveNoteTab] = useState("L0");
  const [noteText, setNoteText] = useState("");
  const [notes, setNotes] = useState([]);
  const [showNotesPanel, setShowNotesPanel] = useState(true);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [l2Feedback, setL2Feedback] = useState("");
  const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);
  const [submittedFeedbacks, setSubmittedFeedbacks] = useState([]);

  async function fetchSubmittedFeedbacks() {
    if (!candidate?.candidate_id || !jobid) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/get_submitted_feedbacks/${candidate.candidate_id}/${jobid}`);
      if (res.ok) {
        const data = await res.json();
        setSubmittedFeedbacks(data.feedbacks || []);
      }
    } catch (err) {
      console.error("Error fetching submitted feedbacks:", err);
    }
  }

  async function fetchNotes() {
    if (!candidate?.candidate_id) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/get_notes/${candidate.candidate_id}`);
      if (res.ok) {
        const data = await res.json();
        setNotes(Array.isArray(data) ? data : (data.notes || []));
      }
    } catch (err) {
      console.error("Error fetching notes:", err);
    }
  }

  async function fetchDraftFeedback() {
    if (!candidate?.candidate_id || !jobid) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/get_draft_feedback/${candidate.candidate_id}/${jobid}`);
      if (res.ok) {
        const data = await res.json();
        if (data && data.feedback) {
          setL2Feedback(data.feedback);
        }
      }
    } catch (err) {
      console.error("Error fetching draft feedback:", err);
    }
  }

  async function handleSaveDraft() {
    if (!candidate?.candidate_id || !jobid) return;
    try {
      const payload = {
        candidate_id: candidate.candidate_id,
        job_id: jobid,
        feedback: l2Feedback
      };
      const res = await fetch(`${API_BASE_URL}/api/save_draft_feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setShowSaveSuccess(true);
      } else {
        alert("Failed to save draft");
      }
    } catch (err) {
      console.error("Error saving draft feedback:", err);
    }
  }

  useEffect(() => {
    if (open && candidate?.candidate_id) {
      fetchNotes();
      fetchDraftFeedback();
      fetchSubmittedFeedbacks();
    }
  }, [open, candidate?.candidate_id, jobid]);

  const summaryRef = useRef(null);

  const generatePDF = async (options = {}) => {
    if (!summaryRef.current) return null;
    const { optimized = false } = options;
    const scale = optimized ? 1.5 : 2;
    const quality = optimized ? 0.5 : 0.8;
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 15;
    const contentWidth = pdfWidth - (2 * margin);
    let currentY = margin;
    const blocks = summaryRef.current.querySelectorAll('[data-pdf-block="true"]');
    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      const canvas = await html2canvas(block, { scale: scale, useCORS: true, logging: false, backgroundColor: "#ffffff" });
      const imgData = canvas.toDataURL("image/jpeg", quality);
      const imgProps = pdf.getImageProperties(imgData);
      const blockWidthInPdf = contentWidth;
      const blockHeightInPdf = (imgProps.height * blockWidthInPdf) / imgProps.width;
      if (currentY + blockHeightInPdf > pdfHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }
      pdf.addImage(imgData, "JPEG", margin, currentY, blockWidthInPdf, blockHeightInPdf);
      currentY += blockHeightInPdf + 5;
    }
    return pdf;
  };

  const handleExportPDF = async () => {
    try {
      const pdf = await generatePDF({ optimized: false });
      if (pdf) {
        pdf.save(`${name || "Candidate"}_Summary.pdf`);
      }
    } catch (err) {
      console.error("PDF generation failed:", err);
      alert("Failed to generate PDF summary.");
    }
  };

  const handleShare = async () => {
    try {
      const pdf = await generatePDF({ optimized: true });
      if (!pdf) return;

      const pdfBlob = pdf.output('blob');
      const fileName = `${name || "Candidate"}_Summary.pdf`;
      const file = new File([pdfBlob], fileName, { type: 'application/pdf' });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'Candidate Evaluation Summary',
        });
      } else {
        const shareText = `Candidate Evaluation Summary for ${name || "a candidate"}\nScore: ${score}/100\nStatus: ${candidate?.status || "N/A"}`;
        if (navigator.share) {
          await navigator.share({
            title: "Candidate Summary",
            text: shareText,
            url: window.location.href,
          });
        } else {
          await navigator.clipboard.writeText(shareText);
          alert("Summary copied to clipboard (File sharing not supported)!");
        }
      }
    } catch (err) {
      console.error("Sharing failed:", err);
    }
  };

  if (!open) return null;

  const emailIcon = "https://cdn-icons-png.flaticon.com/128/14348/14348015.png";
  const phoneIcon = "https://cdn-icons-png.flaticon.com/128/597/597177.png";

  if (loading)
    return (
      <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2100, backdropFilter: "blur(4px)" }}>
        <ClipLoader color="#fff" size={60} />
      </div>
    );

  const name = candidate?.full_name || "N/A";
  const email = candidate?.email || "N/A";
  const phone = candidate?.phone || "N/A";
  const score = candidate?.llm_score !== undefined ? candidate.llm_score : "N/A";
  const breakdown = Array.isArray(candidate?.score_breakdown) ? candidate.score_breakdown : [];
  const l1Reasons = Array.isArray(candidate?.reasons) ? candidate.reasons : [];

  async function handleAddNote() {
    if (!noteText.trim()) return;
    try {
      const payload = {
        candidate_id: candidate.candidate_id,
        candidate_name: candidate.full_name,
        job_id: candidate.job_id || jobid || "N/A",
        note: noteText,
        level: activeNoteTab,
        author: "HR Manager"
      };
      const res = await fetch(`${API_BASE_URL}/api/add_note`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setNoteText("");
        fetchNotes();
      } else {
        alert("Failed to add note");
      }
    } catch (err) {
      console.error("Error adding note:", err);
    }
  }

  const profileCircleStyle = {
    width: 66, height: 66, borderRadius: "50%",
    background: "radial-gradient(ellipse at 60% 40%, #5b84ff 0%, #3a68ff 100%)",
    color: "#fff", fontWeight: 800, fontSize: 32,
    display: "flex", alignItems: "center", justifyContent: "center", marginRight: 18,
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2100, backdropFilter: "blur(4px)" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ width: "min(1200px, 96vw)", height: "92vh", background: "#fff", borderRadius: 20, boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)", display: "flex", flexDirection: "column", overflow: "hidden", position: "relative" }}>
        {/* Header Bar */}
        <div style={{ padding: "16px 24px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#1e293b" }}>Candidate Scores & Details</h2>
            <span style={{ background: "#eff6ff", color: "#3b82f6", fontSize: 11, fontWeight: 700, padding: "4px 8px", borderRadius: 12, textTransform: "uppercase" }}>{candidate?.candidate_id || "APP001"}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button onClick={handleShare} style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 14px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontWeight: 600, color: "#475569", cursor: "pointer" }}>
              <span style={{ fontSize: 16 }}> 📤 </span> Share
            </button>
            <button
              onClick={handleExportPDF}
              style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 14px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontWeight: 600, color: "#475569", cursor: "pointer" }}
            >
              📄 Download PDF
            </button>
            <div onClick={() => setShowNotesPanel(!showNotesPanel)} style={{ width: 38, height: 38, borderRadius: 8, background: "#fff", border: "1px solid #e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", borderColor: showNotesPanel ? "#3b82f6" : "#e2e8f0" }}>
              <span style={{ color: "#3b82f6", fontSize: 20 }}>📋</span>
            </div>
            <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 24, color: "#94a3b8", cursor: "pointer", padding: "4px 8px" }}>&times;</button>
          </div>
        </div>

        {/* Body Content */}
        <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
          <div style={{ flex: 1, padding: "32px 40px", overflowY: "auto", display: "flex", flexDirection: "column", gap: 32 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={profileCircleStyle}>{(name || "?")[0].toUpperCase()}</div>
              <div>
                <h1 style={{ margin: 0, fontSize: 28, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>{(name || "N/A").toUpperCase()}</h1>
                <div style={{ display: "flex", gap: 20, marginTop: 8 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#64748b", fontSize: 14 }}><img src={emailIcon} style={{ width: 14, height: 14 }} alt="" /> {email}</div>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#64748b", fontSize: 14 }}><img src={phoneIcon} style={{ width: 14, height: 14 }} alt="" /> {phone}</div>
                </div>
              </div>
            </div>
            <div style={{ padding: "16px 20px", borderRadius: 12, border: "1px solid #f1f5f9", background: "#fff", display: "flex", alignItems: "center", gap: 12, width: "fit-content" }}>
              <span style={{ fontSize: 14, fontWeight: 600, color: "#475569" }}>Resume Score:</span>
              <span style={{ fontWeight: 800, fontSize: 15, color: "#0f172a" }}><span style={{ color: "#10b981" }}>{score}</span> / 100</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 32 }}>
              <div>
                <h3 style={{ fontSize: 15, fontWeight: 700, color: "#1e293b", marginBottom: 16 }}>Score Breakdown:</h3>
                <ul style={{ padding: 0, margin: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 12 }}>
                  {breakdown.length > 0 ? breakdown.map((item, idx) => (
                    <li key={idx} style={{ fontSize: 14, color: "#64748b", display: "flex", justifyContent: "space-between", maxWidth: 300 }}><span>• {item.category}:</span><span style={{ fontWeight: 600, color: "#475569" }}>{item.score}</span></li>
                  )) : <li style={{ fontSize: 14, color: "#94a3b8" }}>No breakdown data available</li>}
                </ul>
              </div>
            </div>
            <div style={{ height: 1, background: "#f1f5f9" }} />
            <div>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", marginBottom: 16 }}>L1 Reasons:</h3>
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                {l1Reasons.length > 0 ? l1Reasons.map((reason, idx) => (
                  <div key={idx} style={{ fontSize: 15, color: "#475569", lineHeight: 1.6, position: "relative", paddingLeft: 20 }}><span style={{ position: "absolute", left: 0, color: "#94a3b8" }}>•</span> {reason}</div>
                )) : <div style={{ fontSize: 15, color: "#94a3b8" }}>No reasons provided</div>}
              </div>
            </div>

            {/* L2 Recruiter Feedback Section */}
            {candidate?.status === "approved" && (
              <div style={{ borderTop: "1px solid #f1f5f9", paddingTop: 32 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                  <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", margin: 0 }}>L2 Recruiter Feedback</h3>
                  <span style={{ fontSize: 10, fontWeight: 700, background: "#fef3c7", color: "#92400e", padding: "2px 8px", borderRadius: 4, textTransform: "uppercase" }}>Draft</span>
                </div>
                <textarea
                  placeholder="Enter L2 recruiter feedback..."
                  value={l2Feedback}
                  onChange={(e) => setL2Feedback(e.target.value)}
                  style={{ width: "100%", height: 120, padding: 16, borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 14, color: "#1e293b", resize: "none", background: "#fcfdfe", marginBottom: 16, outline: "none" }}
                />
                <div style={{ display: "flex", gap: 12, marginBottom: 32 }}>
                  <button
                    onClick={handleSaveDraft}
                    style={{ padding: "8px 16px", background: "#fff", color: "#1e293b", border: "1px solid #e2e8f0", borderRadius: 6, fontWeight: 600, fontSize: 13, cursor: "pointer" }}
                  >
                    Save Draft
                  </button>
                  <button
                    onClick={async () => {
                      setIsSubmittingFeedback(true);
                      try {
                        const payload = {
                          candidate_id: candidate.candidate_id,
                          job_id: jobid,
                          feedback: l2Feedback,
                          author: "HR Manager",
                          level: "L2"
                        };
                        const res = await fetch(`${API_BASE_URL}/api/submit_feedback`, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify(payload)
                        });
                        if (res.ok) {
                          setFeedbackSubmitted(true);
                          setL2Feedback("");
                          fetchSubmittedFeedbacks();
                          fetchDraftFeedback();
                        } else {
                          alert("Failed to submit feedback");
                        }
                      } catch (err) {
                        console.error("Submit feedback failed:", err);
                      } finally {
                        setIsSubmittingFeedback(false);
                      }
                    }}
                    disabled={!l2Feedback.trim() || isSubmittingFeedback}
                    style={{
                      padding: "8px 16px", background: "#3b82f6", color: "#fff",
                      border: "none", borderRadius: 6, fontWeight: 600, fontSize: 13,
                      cursor: (!l2Feedback.trim() || isSubmittingFeedback) ? "not-allowed" : "pointer",
                      opacity: (!l2Feedback.trim() || isSubmittingFeedback) ? 0.6 : 1
                    }}
                  >
                    {isSubmittingFeedback ? "Submitting..." : "Submit Feedback"}
                  </button>
                </div>

                {/* Submitted Feedbacks List */}
                {submittedFeedbacks.length > 0 && (
                  <div style={{ marginBottom: 32 }}>
                    <h4 style={{ fontSize: 14, fontWeight: 700, color: "#1e293b", marginBottom: 12 }}>Feedback History</h4>
                    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                      {submittedFeedbacks.map((fb, idx) => (
                        <div key={idx} style={{ padding: 16, background: "#f8fafc", borderRadius: 12, border: "1px solid #e2e8f0" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                            <span style={{ fontWeight: 700, fontSize: 13, color: "#334155" }}>{fb.author || "HR Manager"}</span>
                            <span style={{ fontSize: 11, color: "#94a3b8" }}>{fb.submitted_at}</span>
                          </div>
                          <p style={{ margin: 0, fontSize: 13, color: "#475569", lineHeight: 1.5 }}>{fb.feedback}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <button
                  onClick={() => setShowScheduleModal(true)}
                  style={{ width: "fit-content", padding: "12px 24px", background: "#8b5cf6", color: "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, transition: "all 0.2s", boxShadow: "0 4px 12px rgba(139, 92, 246, 0.25)" }}
                >
                  <span style={{ fontSize: 18 }}>📋</span> Schedule L2 Interview
                </button>
              </div>
            )}

            {/* Hidden div for PDF generation */}
            <div ref={summaryRef} style={{ position: "absolute", left: -9999, top: 0, width: "210mm", padding: "20mm", background: "#fff" }}>
              <div data-pdf-block="true" style={{ marginBottom: "30px", borderBottom: "3px solid #3b82f6", paddingBottom: "20px" }}>
                <h1 style={{ color: "#1e3a8a", margin: "0 0 10px 0", fontSize: "28px" }}>Professional Evaluation Report</h1>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                  <div>
                    <h2 style={{ color: "#3b82f6", margin: "0 0 5px 0", fontSize: "20px" }}>{name}</h2>
                    <p style={{ color: "#64748b", margin: 0, fontSize: "14px" }}>{jobrole || "Candidate Evaluation"}</p>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: "24px", fontWeight: "bold", color: "#10b981" }}>{score}/100</div>
                    <div style={{ fontSize: "12px", color: "#94a3b8" }}>OVERALL SCORE</div>
                  </div>
                </div>
              </div>
              {l1Reasons.length > 0 && (
                <div data-pdf-block="true" style={{ marginBottom: "25px" }}>
                  <h3 style={{ borderBottom: "1px solid #e1eefa", paddingBottom: "5px", marginBottom: "12px", color: "#1e293b", fontSize: "16px" }}>L1 Reasons</h3>
                  <ul style={{ marginTop: "5px", paddingLeft: "20px", lineHeight: "1.6", color: "#475569" }}>
                    {l1Reasons.map((reason, idx) => <li key={idx} style={{ marginBottom: "6px" }}>{reason}</li>)}
                  </ul>
                </div>
              )}
              <div data-pdf-block="true" style={{ textAlign: "center", color: "#94a3b8", fontSize: "11px", marginTop: "40px", borderTop: "1px solid #f1f5f9", paddingTop: "20px" }}>
                &copy; {new Date().getFullYear()} Fanisko Candidate Evaluation System. Confidential Report.
              </div>
            </div>
          </div>

          {showNotesPanel && <div style={{ width: 1, background: "#f1f5f9" }} />}
          {showNotesPanel && (
            <div style={{ width: 380, background: "#fcfdfe", display: "flex", flexDirection: "column" }}>
              <div style={{ padding: 24, display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f1f5f9" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}><span style={{ fontSize: 18 }}>📂</span><span style={{ fontWeight: 700, color: "#1e293b" }}>Notes</span></div>
                <span style={{ color: "#94a3b8", fontSize: 12 }}>{notes.length} note</span>
              </div>
              <div style={{ px: 24, display: "flex", gap: 12, padding: "0 24px 16px" }}>
                {["L0", "L1", "L2"].map(tab => <button key={tab} onClick={() => setActiveNoteTab(tab)} style={{ padding: "6px 16px", borderRadius: 20, border: "none", cursor: "pointer", fontSize: 12, fontWeight: 700, background: activeNoteTab === tab ? "#eff6ff" : "transparent", color: activeNoteTab === tab ? "#3b82f6" : "#94a3b8" }}>{tab}</button>)}
              </div>
              <div style={{ padding: "0 24px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
                <textarea placeholder="Add a note..." value={noteText} onChange={e => setNoteText(e.target.value)} style={{ width: "100%", height: 100, padding: 16, borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 14, resize: "none" }} />
                <button onClick={handleAddNote} style={{ padding: 10, background: "#7c9bff", color: "#fff", border: "none", borderRadius: 8, fontWeight: 600, cursor: "pointer" }}>+ Add Note</button>
              </div>
              <div style={{ flex: 1, overflowY: "auto", padding: 24, display: "flex", flexDirection: "column", gap: 16 }}>
                {notes.map((note, idx) => (
                  <div key={idx} style={{ padding: 16, background: "#fff", borderRadius: 12, border: "1px solid #f1f5f9", boxShadow: "0 1px 3px rgba(0,0,0,0.02)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: "#334155" }}>{note.author || note.user || "HR Manager"}</span>
                        <span style={{ fontSize: 10, background: "#eff6ff", color: "#3b82f6", padding: "2px 6px", borderRadius: 4 }}>{note.level || note.type}</span>
                      </div>
                    </div>
                    <div style={{ fontSize: 13, color: "#64748b", lineHeight: 1.5, marginBottom: 8 }}>{note.note || note.text}</div>
                    <div style={{ fontSize: 11, color: "#cbd5e1" }}>{note.timestamp}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {showSaveSuccess && (
          <SuccessFeedbackModal
            onClose={() => setShowSaveSuccess(false)}
            message="Your draft feedback has been saved successfully."
          />
        )}

        <ScheduleL2Modal open={showScheduleModal} onClose={() => setShowScheduleModal(false)} candidateName={name} jobTitle={jobrole} />

      </div>
    </div>
  );
}



function SuccessFeedbackModal({ message, onClose }) {
  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.2)", zIndex: 10000,
        display: "flex", alignItems: "center", justifyContent: "center",
        backdropFilter: "blur(2px)"
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#f0f7ff", borderRadius: 24, padding: "50px 40px",
          width: "90%", maxWidth: 450, textAlign: "center",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          display: "flex", flexDirection: "column", alignItems: "center", gap: 24
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{
          background: "#22c55e", width: 60, height: 60, borderRadius: "50%",
          display: "flex", alignItems: "center", justifyContent: "center"
        }}>
          <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <div>
          <h2 style={{ margin: "0 0 12px 0", color: "#1e293b", fontSize: 20, fontWeight: 800 }}>Thank you!</h2>
          <p style={{ margin: 0, color: "#64748b", fontSize: 14, lineHeight: 1.6 }}>{message}</p>
        </div>
        <button
          onClick={onClose}
          style={{
            marginTop: 8, padding: "12px 32px", background: "#3b82f6", color: "#fff",
            border: "none", borderRadius: 12, fontWeight: 700, fontSize: 15, cursor: "pointer",
            boxShadow: "0 8px 16px rgba(59,130,246,0.2)"
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default function HRJobApplications() {
  const { jobrole, location, jobid } = useParams();
  console.log("Params:", jobrole, location, jobid);

  const navigate = useNavigate();
  const [applications, setApplications] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const [listError, setListError] = useState(null);

  const [jobOnboarding, setJobOnboarding] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedCand, setSelectedCand] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [detailsError, setDetailsError] = useState(null);
  const [applicationDate, setApplicationDate] = useState("N/A");

  const [hoveredCard, setHoveredCard] = useState(null);


  // For scores modal
  const [showScores, setShowScores] = useState(false);
  const [scores, setScores] = useState(null);
  const [loadingScores, setLoadingScores] = useState(false);
  const [scoresError, setScoresError] = useState(null);
  const [showL2Dialog, setShowL2Dialog] = useState(false);
  const [l2Loading, setL2Loading] = useState(false);
  const [l2Questions, setL2Questions] = useState([]);
  const [l2Error, setL2Error] = useState("");

  const handleOpenL2 = async () => {
    setShowL2Dialog(true);
    setL2Loading(true);
    setL2Error("");
    try {
      const res = await fetch(
        `${API_BASE_URL}/l2-questions/${scores.candidate_id}/${scores.job_id}`
      );
      const data = await res.json();
      console.log("L2 RAW DATA:", data);

      if (!res.ok || data.error) {
        setL2Error(data.error || "Failed to generate L2 questions");
        setL2Questions([]);
      } else {
        // backend: {"question": [...] }
        const arr = Array.isArray(data.question) ? data.question : [];
        console.log("L2 QUESTIONS ARRAY:", arr);
        setL2Questions(arr);
      }
    } catch (e) {
      setL2Error("Network error while generating L2 questions");
      setL2Questions([]);
    } finally {
      setL2Loading(false);
    }
  };



  const fetchCandidates = () => {
    setLoadingList(true);
    fetch(`${API_BASE_URL}/api/candidate_scores/${jobid}`)
      .then(res => res.json())
      .then(async scoresList => {
        const mergedList = await Promise.all(scoresList.map(async cand => {
          const infoRes = await fetch(`${API_BASE_URL}/api/candidate_by_id/${cand.candidate_id}`);
          const info = await infoRes.json();
          return { ...cand, name: info.name, email: info.email };
        }));
        setApplications(mergedList);
        setLoadingList(false);
        setListError(null);
      })
      .catch(err => {
        setListError(err.message);
        setLoadingList(false);
      });
  };
  useEffect(() => {
    fetchCandidates();
  }, [jobid]);
  useEffect(() => {
    if (!showScores) {
      fetchCandidates();
    }
  }, [showScores]);

  const [filterOpen, setFilterOpen] = useState(false);
  const [sortType, setSortType] = useState("");

  const [screeningQA, setScreeningQA] = useState(null);

  // const [tabFilter, setTabFilter] = useState("all");
  // const [approvedCandidates, setApprovedCandidates] = useState([]);
  // const [rejectedCandidates, setRejectedCandidates] = useState([]);
  // const [l0Status, setL0Status] = useState("all");  // "all" | "passed" | "failed"
  // const [l1Status, setL1Status] = useState("all");  // "all" | "approved" | "failed"
  // const [activeTab, setActiveTab] = useState("all");
  //   // Tab labels & keys
  //   const tabDefinitions = [
  //   {key: "all", label: "All" },
  //   {key: "l0", label: "L0" },
  //   {key: "l1", label: "L1" },
  // ];
  const [l0Dropdown, setL0Dropdown] = useState("all");
  const [l1Dropdown, setL1Dropdown] = useState("all");
  const [activeTab, setActiveTab] = useState("all");
  const [manualApplications, setManualApplications] = useState([]);
  const [loadingManual, setLoadingManual] = useState(false);
  const [manualError, setManualError] = useState(null);
  const [showManualScore, setShowManualScore] = useState(false);
  const [selectedManualCandidate, setSelectedManualCandidate] = useState(null);
  const [manualScoreLoading, setManualScoreLoading] = useState(false);
  const [manualScoreError, setManualScoreError] = useState(null);
  const [loadingManualScore, setLoadingManualScore] = useState(false);
  const [showManualScoreModal, setShowManualScoreModal] = useState(false);
  const [manualCandidateScore, setManualCandidateScore] = useState(null);



  const tabDefs = [
    { key: "all", label: "All" },
    { key: "l0", label: "L0" },
    { key: "l1", label: "L1" },
    { key: "manual", label: "Manual" }, // New tab
  ];

  const [showL0Dropdown, setShowL0Dropdown] = useState(false);
  const [showL1Dropdown, setShowL1Dropdown] = useState(false);

  // Fetch candidate list for job
  useEffect(() => {
    setLoadingList(true);
    fetch(`${API_BASE_URL}/api/candidate_scores/${jobid}`)
      .then(res => res.json())
      .then(async scoresList => {
        // Fetch name/email for every candidate_id
        const mergedList = await Promise.all(scoresList.map(async cand => {
          const infoRes = await fetch(`${API_BASE_URL}/api/candidate_by_id/${cand.candidate_id}`);
          const info = await infoRes.json();
          return { ...cand, name: info.name, email: info.email };
        }));
        setApplications(mergedList);
        setLoadingList(false);
        setListError(null);
      })
      .catch(err => {
        setListError(err.message);
        setLoadingList(false);
      });
  }, [jobid]);

  useEffect(() => {
    if (activeTab === "manual") {
      setLoadingManual(true);
      fetch(`${API_BASE_URL}/api/manual_candidates/${jobid}`)
        .then(res => {
          if (!res.ok) throw new Error("Failed to fetch manual candidates");
          return res.json();
        })
        .then(manualList => {
          setManualApplications(manualList); // manualList includes {candidate_id, full_name, email, phone, llm_score}
          setLoadingManual(false);
          setManualError(null);
        })
        .catch(err => {
          setManualError(err.message);
          setLoadingManual(false);
        });
    }
  }, [activeTab, jobid]);


  const openCandidateDetails = (candidate) => {
    setLoadingDetails(true);
    setDetailsError(null);
    setShowDetails(true);
    setSelectedCand(null);
    setApplicationDate("N/A");

    // Fetch candidate basic details
    fetch(`${API_BASE_URL}/api/candidate/${candidate.candidate_id}?job_id=${jobid}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch candidate details");
        return res.json();
      })
      .then((data) => {
        setSelectedCand(data);
        console.log("Fetched candidate details:", data);                // Check entire candidate object
        console.log("Will fetch onboarding for job_id:", data.job_id);  // Should be a valid string, not undefined

        if (data.job_id) {
          fetch(`${API_BASE_URL}/api/jobview/${data.job_id}/onboarding`)
            .then(res => {
              if (!res.ok) throw new Error("Failed to fetch onboarding questions");
              return res.json();
            })
            .then(onboarding => setJobOnboarding(onboarding))
            .catch(() => setJobOnboarding(null)); // If no onboarding, set to null
        } else {
          console.error("No job_id found in candidate data — onboarding fetch skipped");
          setJobOnboarding(null);
        }

        // After getting candidate details, fetch resume upload date
        if (data.resume_file_id) {
          fetch(`${API_BASE_URL}/api/resume_upload_date/${candidate.candidate_id}/${jobid}`)
            .then((res) => {
              if (!res.ok) throw new Error("Failed to fetch resume upload date");
              return res.json();
            })
            .then((dateData) => {
              if (dateData.uploadDate) {
                setApplicationDate(new Date(dateData.uploadDate).toLocaleString());
              }
            })
            .catch(() => {
              setApplicationDate("N/A");
            });
        } else {
          setApplicationDate("N/A");
        }

        setLoadingDetails(false);
      })
      .catch((err) => {
        setDetailsError(err.message);
        setLoadingDetails(false);
      });
  };



  // Fetch candidate scores and show modal
  const openCandidateScores = async (candidate) => {
    setLoadingScores(true);
    setScoresError(null);
    setScores(null);
    setScreeningQA(null); // reset Q&A
    setShowScores(true);

    try {
      const [scoresRes, infoRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/get_final_score?candidate_id=${candidate.candidate_id}&job_id=${jobid}`),
        fetch(`${API_BASE_URL}/api/candidate_by_id/${candidate.candidate_id}`)
      ]);
      if (!scoresRes.ok) throw new Error("Failed to fetch candidate scores");
      if (!infoRes.ok) throw new Error("Failed to fetch candidate info");

      const scoresData = await scoresRes.json();
      const infoData = await infoRes.json();

      // Merge candidate info into the scores object
      const mergedScores = {
        ...scoresData,
        candidate_name: infoData.name,
        candidate_email: infoData.email,
        candidate_phone: infoData.phone,
      };
      setScores(mergedScores);

      // Only fetch Q&A if candidate passed
      if (mergedScores.llm_score && mergedScores.llm_score > 0) {
        const screeningRes = await fetch(
          `${API_BASE_URL}/api/screening_questions?candidate_id=${candidate.candidate_id}&job_id=${jobid}`
        );
        if (screeningRes.ok) {
          setScreeningQA(await screeningRes.json());
        }
      }

      setLoadingScores(false);
    } catch (err) {
      setScoresError(err.message);
      setLoadingScores(false);
    }
  };

  const openManualScore = (cand) => {
    setManualCandidateScore(cand); // use full object directly
    setShowManualScoreModal(true);
  };

  const renderManualCandidateCard = (cand, i) => (

    <div
      key={i}
      style={{
        background: "#fff",
        borderRadius: 14,
        boxShadow: "0 4px 18px rgba(35,115,240,0.08)",
        padding: "22px 22px 20px 22px",
        minHeight: 170,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        border: "1px solid #35b5ffff",
        cursor: "default"
      }}
      onMouseEnter={() => setHoveredCard(i)}
      onMouseLeave={() => setHoveredCard(null)}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
        <div
          aria-label="Profile"
          title={cand.full_name || "Applicant"}
          style={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            background: "linear-gradient(135deg,#eaf2ff,#cfe0ff)",
            color: "#1b4ab8",
            fontWeight: 800,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "inset 0 0 0 2px #ffffff, 0 2px 8px rgba(35,115,240,.12)",
          }}
        >
          {(cand?.full_name || "?").toString().trim().slice(0, 1).toUpperCase()}
        </div>
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontWeight: 800,
              fontSize: 16,
              color: "#1c3558",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
            title={cand.full_name || ""}
          >
            {cand.full_name || "N/A"}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: 13,
              color: "#5f779b",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
            title={cand.email || ""}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/128/14348/14348015.png"
              alt="Email Icon"
              style={{ width: 16, height: 16, flexShrink: 0 }}
            />
            <span>{cand.email || "N/A"}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: 13,
              color: "#5f779b",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
            title={cand.email || ""}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/128/597/597177.png"
              alt="Email Icon"
              style={{ width: 16, height: 16, flexShrink: 0 }}
            />
            <span>{cand.phone || "N/A"}</span>
          </div>
          <div
            style={{
              fontSize: 15,
              color: "#000000",
              fontWeight: 600,
              marginTop: 4,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
            title={`Resume Score: ${cand.llm_score ?? "N/A"}/100`}
          >
            Resume Score:{" "}
            <span style={{ marginLeft: 20, color: "#2c6d15" }}>
              {typeof cand.llm_score === "number" ? `${cand.llm_score}/100` : "N/A"}
            </span>
          </div>
          {/* Add status or additional info as needed */}
        </div>
      </div>
      <div style={{
        marginTop: "auto",
        width: "100%",
        display: "flex",
        gap: 12
      }}>
        <button
          onClick={() => {
            setSelectedManualCandidate(cand);
            setShowManualScore(true);
          }}
          style={{
            background: "#1e7e34",
            color: "#fff",
            fontWeight: 700,
            padding: "10px 0",
            border: "none",
            borderRadius: 6,
            fontSize: 15,
            cursor: "pointer",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            minWidth: 0
          }}
        >
          View Scores
        </button>
      </div>
    </div>
  );

  if (loadingList)
    return (
      <div style={{ padding: 300, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <ClipLoader color="#2d3b51" size={32} />
        <div style={{ marginTop: 10 }}>Loading candidates...</div>
      </div>
    );

  if (listError)
    return (
      <div style={{ padding: 20, color: "red" }}>
        Error loading candidates: {listError}
      </div>
    );

  const applySort = (apps, sortType) => {
    if (sortType === "score-desc") {
      return [...apps].sort((a, b) => (b.llm_score ?? 0) - (a.llm_score ?? 0));
    }
    if (sortType === "score-asc") {
      return [...apps].sort((a, b) => (a.llm_score ?? 0) - (b.llm_score ?? 0));
    }
    return apps;
  };

  const sortedApplications = applySort(applications, sortType);

  const l0PassedCount = applications.filter(cand => (cand.compatibility ?? 0) >= 40).length;
  const l0FailedCount = applications.filter(cand => (cand.compatibility ?? 0) < 40).length;
  const l1ApprovedCount = applications.filter(cand => cand.status === "approved").length;





  // Filtering by tab selection
  const filteredApplications = sortedApplications.filter((cand) => {
    // if (activeTab === "all") return true;
    if (activeTab === "l0") {
      const screened = (cand.compatibility ?? 0) >= 40;
      if (l0Dropdown === "all") return true;
      if (l0Dropdown === "passed") return screened;
      if (l0Dropdown === "failed") return !screened;
    }
    if (activeTab === "l1") {
      if (l1Dropdown === "all") return cand.status === "approved" || cand.status === "rejected";
      if (l1Dropdown === "approved") return cand.status === "approved";
      if (l1Dropdown === "rejected") return cand.status === "rejected";
    }
    return true;
  });



  const getSortLabel = (sortType) => {
    switch (sortType) {
      case "score-desc":
        return "High to Low";
      case "score-asc":
        return "Low to High";
      default:
        return "Filter & Sort";
    }
  };

  // Helper to render a candidate card used in both grids
  const renderCandidateCard = (cand, i) => (
    <div
      key={i}
      style={{
        background: "#fff",
        borderRadius: 14,
        boxShadow:
          hoveredCard === i
            ? "0 10px 26px rgba(39,130,226,0.18)"
            : "0 4px 18px rgba(35,115,240,0.08)",
        padding: "22px 22px 20px 22px",
        minHeight: 170,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        transform: hoveredCard === i ? "translateY(-4px)" : "translateY(0)",
        transition: "all 0.2s ease",
        border: "1px solid #35b5ffff",
        cursor: "default",
      }}
      onMouseEnter={() => setHoveredCard(i)}
      onMouseLeave={() => setHoveredCard(null)}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
        <div
          aria-label="Profile"
          title={cand.name || "Applicant"}
          style={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            background: "linear-gradient(135deg,#eaf2ff,#cfe0ff)",
            color: "#1b4ab8",
            fontWeight: 800,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "inset 0 0 0 2px #ffffff, 0 2px 8px rgba(35,115,240,.12)",
          }}
        >
          {(cand?.name || "?")
            .toString()
            .trim()
            .slice(0, 1)
            .toUpperCase()}
        </div>
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontWeight: 800,
              fontSize: 16,
              color: "#1c3558",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={cand.name || ""}
          >
            {cand.name || "N/A"}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: 13,
              color: "#5f779b",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={cand.email || ""}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/128/14348/14348015.png"
              alt="Email Icon"
              style={{ width: 16, height: 16, flexShrink: 0 }}
            />
            <span>{cand.email || "N/A"}</span>
          </div>
          <div
            style={{
              fontSize: 15,
              color: "#000000", // black for label
              fontWeight: 600,
              marginTop: 4,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={`Resume Score: ${cand.llm_score ?? "N/A"}/100`}
          >
            Resume Score:{" "}
            <span style={{ marginLeft: 65, color: "#2c6d15" }}>
              {cand.llm_score !== undefined ? `${cand.llm_score}/100` : "N/A"}
            </span>
          </div>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 15,
            color: "#000",
            fontWeight: 600,
            marginTop: 4,
          }}>
            <span>Status:</span>
            {cand.status === "approved" ? (
              <span style={{
                background: "#eaf9ed",
                color: "#238a51",
                fontWeight: 600,
                fontSize: 13,
                borderRadius: 8,
                padding: "5px 16px",
                marginLeft: 10,
                display: "inline-block"
              }}>Approved</span>
            ) : cand.status === "rejected" ? (
              <span style={{
                background: "#ffebeb",
                color: "#d9534f",
                fontWeight: 600,
                fontSize: 13,
                borderRadius: 8,
                padding: "5px 16px",
                marginLeft: 10,
                display: "inline-block"
              }}>Rejected</span>
            ) : (
              <span style={{
                color: "#777",
                fontSize: 13,
                marginLeft: 10,
                fontStyle: "italic"
              }}>Pending</span>
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          marginTop: "auto",
          width: "100%",
          display: "flex",
          gap: 12
        }}
      >
        <button
          style={{
            background: "#2684ff",
            color: "#fff",
            fontWeight: 700,
            padding: "10px 0",
            border: "none",
            borderRadius: 6,
            fontSize: 15,
            cursor: "pointer",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            minWidth: 0
          }}
          onClick={() => openCandidateDetails(cand)}
        >
          More Info
        </button>
        <button
          style={{
            background: "#1e7e34",
            color: "#fff",
            fontWeight: 700,
            padding: "10px 0",
            border: "none",
            borderRadius: 6,
            fontSize: 15,
            cursor: "pointer",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            minWidth: 0
          }}
          onClick={() => openCandidateScores(cand)}
        >
          View Scores
        </button>
      </div>
    </div>
  );


  return (
    <>
      {/* Header with job info from params */}
      <div
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          right: 0,
          background: "#fff",
          zIndex: 110,
          borderBottom: "1px solid #f0f1f5",
          padding: "24px 40px 18px 40px",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                background: "#eaf2ff",
                color: "#236ef2",
                border: "none",
                borderRadius: 8,
                padding: "8px 12px",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              ← Back to Jobs
            </button>
            <span style={{ fontSize: 40, fontWeight: 800, marginLeft: 10, color: "#172d44" }}>
              {jobrole || "Job"}
            </span>
          </div>
          <div style={{ color: "#5a6e8a", marginLeft: 150, fontSize: 20, fontWeight: 600 }}>
            <span style={{ marginRight: 12 }}>{jobid}</span>·
            <span style={{ marginLeft: 12 }}>{location}</span>
          </div>
        </div>
        <div style={{ color: "#4a5f85", marginRight: 0, marginBottom: 10, fontWeight: 800, display: "flex", alignItems: "flex-end", gap: 32 }}>
          <div>
            Total Applications: <span style={{ color: "#236ef2" }}>{applications.length}</span>
            <div style={{ fontWeight: 600, marginTop: 4 }}>
              <span style={{ color: "#4a5f85", fontWeight: 800 }}>L0 Passed:</span><span style={{ color: "#236ef2" }}> {l0PassedCount} </span> |<span style={{ color: "#4a5f85", fontWeight: 800 }}> L0 Failed:</span> <span style={{ color: "#236ef2" }}> {l0FailedCount} </span> | <span style={{ color: "#4a5f85", fontWeight: 800 }}>L1 Approved:</span><span style={{ color: "#236ef2" }}> {l1ApprovedCount}</span>
            </div>
          </div>
          <ProfileMenu />
        </div>
      </div>

      {/* Filter and Sort Bar with Tabs */}
      <div
        style={{
          width: "95%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#f9fbff",
          padding: "12px 36px 8px 36px",
          borderBottom: "1px solid #ebfaedff",
          marginBottom: 16,
          position: "relative"
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 4,
            justifyContent: "flex-start",
            marginLeft: 153,    // <-- LEFT ALIGN
            alignItems: "center",
            flex: 1,                      // <-- MAKE SURE TABS FILL THE ROW
          }}
        >
          {tabDefs.map(tab => (
            <div key={tab.key} style={{ position: "relative" }}>
              {tab.key === "l0" ? (
                <button
                  onClick={() => {
                    setActiveTab("l0");
                    setShowL0Dropdown(true);
                    setShowL1Dropdown(false);
                  }}
                  style={{
                    background: activeTab === "l0" ? "#236ef2" : "transparent",
                    color: activeTab === "l0" ? "#fff" : "#236ef2",
                    border: "none",
                    borderRadius: 8,
                    padding: "8px 20px",
                    fontWeight: 700,
                    cursor: "pointer",
                    fontSize: 18,
                    boxShadow: activeTab === "l0" ? "0 2px 8px #b9dbff45" : "none",
                  }}
                >
                  {tab.label}
                  <span style={{
                    marginLeft: 6,
                    fontSize: 16,
                    transition: "transform 0.2s",
                    transform: showL0Dropdown ? "rotate(180deg)" : "none"
                  }}>
                    ▼
                  </span>
                </button>
              ) : tab.key === "l1" ? (
                <button
                  onClick={() => {
                    setActiveTab("l1");
                    setShowL1Dropdown(true);
                    setShowL0Dropdown(false);
                  }}
                  style={{
                    background: activeTab === "l1" ? "#236ef2" : "transparent",
                    color: activeTab === "l1" ? "#fff" : "#236ef2",
                    border: "none",
                    borderRadius: 8,
                    padding: "8px 20px",
                    fontWeight: 700,
                    cursor: "pointer",
                    fontSize: 18,
                    boxShadow: activeTab === "l1" ? "0 2px 8px #b9dbff45" : "none",
                  }}
                >
                  {tab.label}
                  <span style={{
                    marginLeft: 6,
                    fontSize: 16,
                    transition: "transform 0.2s",
                    transform: showL1Dropdown ? "rotate(180deg)" : "none"
                  }}>
                    ▼
                  </span>
                </button>
              ) : (
                <button
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    background: activeTab === tab.key ? "#236ef2" : "transparent",
                    color: activeTab === tab.key ? "#fff" : "#236ef2",
                    border: "none",
                    borderRadius: 8,
                    padding: "8px 20px",
                    fontWeight: 700,
                    cursor: "pointer",
                    fontSize: 18,
                    boxShadow: activeTab === tab.key ? "0 2px 8px #b9dbff45" : "none",
                  }}
                >
                  {tab.label}

                </button>
              )}

              {/* Show custom dropdown if L0 tab is active and dropdown is open */}
              {tab.key === "l0" && activeTab === "l0" && showL0Dropdown && (
                <div style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  border: "1px solid #daeafd",
                  borderRadius: 7,
                  marginTop: 5,
                  boxShadow: "0 7px 18px #dae2ff59",
                  zIndex: 200,
                  minWidth: 144,
                  fontWeight: 600,
                }}>
                  <div
                    style={{
                      padding: "10px 22px",
                      color: l0Dropdown === "passed" ? "#fff" : "#236ef2",
                      background: l0Dropdown === "passed" ? "#236ef2" : "none",
                      cursor: "pointer",
                      borderTopLeftRadius: 7,
                      borderTopRightRadius: 7,
                    }}
                    onClick={() => {
                      setL0Dropdown("passed");
                      setShowL0Dropdown(false); // Close after selection
                    }}
                  >
                    L0 Passed
                  </div>
                  <div
                    style={{
                      padding: "10px 22px",
                      color: l0Dropdown === "failed" ? "#fff" : "#236ef2",
                      background: l0Dropdown === "failed" ? "#236ef2" : "none",
                      cursor: "pointer",
                      borderBottomLeftRadius: 7,
                      borderBottomRightRadius: 7,
                    }}
                    onClick={() => {
                      setL0Dropdown("failed");
                      setShowL0Dropdown(false); // Close after selection
                    }}
                  >
                    L0 Failed
                  </div>
                </div>
              )}

              {/* Same for L1 */}
              {tab.key === "l1" && activeTab === "l1" && showL1Dropdown && (
                <div style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  border: "1px solid #daeafd",
                  borderRadius: 7,
                  marginTop: 5,
                  boxShadow: "0 7px 18px #dae2ff59",
                  zIndex: 200,
                  minWidth: 144,
                  fontWeight: 600,
                }}>
                  <div
                    style={{
                      padding: "10px 22px",
                      color: l1Dropdown === "approved" ? "#fff" : "#236ef2",
                      background: l1Dropdown === "approved" ? "#236ef2" : "none",
                      cursor: "pointer",
                      borderTopLeftRadius: 7,
                      borderTopRightRadius: 7,
                    }}
                    onClick={() => {
                      setL1Dropdown("approved");
                      setShowL1Dropdown(false);
                    }}
                  >
                    L1 Approved
                  </div>
                  <div
                    style={{
                      padding: "10px 22px",
                      color: l1Dropdown === "rejected" ? "#fff" : "#236ef2",
                      background: l1Dropdown === "rejected" ? "#236ef2" : "none",
                      cursor: "pointer",
                      borderBottomLeftRadius: 7,
                      borderBottomRightRadius: 7,
                    }}
                    onClick={() => {
                      setL1Dropdown("rejected");
                      setShowL1Dropdown(false);
                    }}
                  >
                    L1 Rejected
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Sort button absolutely positioned on the right */}
        <div
          style={{
            position: "absolute",
            right: 36,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <button
            style={{
              background: "#eef5ff",
              color: "#236ef2",
              border: "1px solid #daeafd",
              borderRadius: 8,
              fontWeight: 700,
              fontSize: 16,
              padding: "10px 22px 10px 16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 7,
              userSelect: "none"
            }}
            onClick={() => setFilterOpen(f => !f)}
          >
            {getSortLabel(sortType)}
            <span style={{
              fontSize: 15,
              transform: filterOpen ? "rotate(180deg)" : "none",
              transition: "transform 0.2s ease"
            }}>▼</span>
          </button>
          {filterOpen && (
            <div style={{
              position: "absolute",
              right: 0,
              top: "115%",
              minWidth: 170,
              background: "#fff",
              border: "1px solid #ddeafc",
              borderRadius: 8,
              boxShadow: "0 7px 18px #dae2ff59",
              zIndex: 30,
              padding: "10px 0",
            }}>
              <button
                style={{
                  background: "none",
                  border: "none",
                  color: "#236ef2",
                  fontWeight: 600,
                  textAlign: "left",
                  width: "100%",
                  padding: "10px 24px",
                  cursor: "pointer",
                  fontSize: 15,
                  userSelect: "none"
                }}
                onClick={() => { setSortType("score-desc"); setFilterOpen(false); }}
              >
                Sort by High Score
              </button>
              <button
                style={{
                  background: "none",
                  border: "none",
                  color: "#236ef2",
                  fontWeight: 600,
                  textAlign: "left",
                  width: "100%",
                  padding: "10px 24px",
                  cursor: "pointer",
                  fontSize: 15,
                  userSelect: "none"
                }}
                onClick={() => { setSortType("score-asc"); setFilterOpen(false); }}
              >
                Sort by Low Score
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Candidate Cards Grid filtered */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 320px)",
          gap: 32,
          justifyContent: "center",
          alignItems: "start",
          maxWidth: 1080,
          margin: "28px auto 0 auto",
          padding: "0 16px"
        }}
      >
        {activeTab === "manual" ? (
          loadingManual ? (
            <div>Loading manual candidates...</div>
          ) : manualError ? (
            <div style={{ color: "red" }}>Error loading manual candidates: {manualError}</div>
          ) : manualApplications.length === 0 ? (
            <div>No manual candidates added by HR found.</div>
          ) : (
            manualApplications.map((cand, i) => renderManualCandidateCard(cand, i))
          )
        ) : (
          filteredApplications.length === 0 ? (
            <div style={{ color: "#999", fontSize: 17 }}>
              No applications found for this filter.
            </div>
          ) : (
            filteredApplications.map((cand, i) => renderCandidateCard(cand, i))
          )
        )}
      </div>

      {/* Candidate details modal */}
      <CandidateDetailsModal
        open={showDetails}
        onClose={() => setShowDetails(false)}
        candidate={selectedCand}
        jobOnboarding={jobOnboarding}
        loading={loadingDetails}
        applicationDate={applicationDate}
      />


      {/* Candidate scores modal */}
      <CandidateScoreModal
        open={showScores}
        onClose={() => setShowScores(false)}
        scores={scores}
        screeningQA={screeningQA}
        loading={loadingScores}
        error={scoresError}
        handleOpenL2={handleOpenL2}
        jobrole={jobrole}
        jobid={jobid}
      />
      {showL2Dialog && (
        <L2QuestionsDialog
          onClose={() => setShowL2Dialog(false)}
          loading={l2Loading}
          questions={l2Questions}
          error={l2Error}
        />
      )}
      <ManualCandidateScoreModal
        open={showManualScore}
        onClose={() => setShowManualScore(false)}
        candidate={selectedManualCandidate}
        loading={manualScoreLoading}
        error={manualScoreError}
        jobrole={jobrole}
        jobid={jobid}
      />

    </>
  );
}
